import { gql } from '@apollo/client/core'
import * as VueApolloComposable from '@vue/apollo-composable'
import type * as VueCompositionApi from 'vue'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export type ReactiveFunction<TParam> = () => TParam
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigInt: { input: any; output: any }
  GlobalId: { input: any; output: any }
  ISO8601Date: { input: any; output: any }
  ISO8601DateTime: { input: string; output: string }
  JSON: { input: any; output: any }
  Upload: { input: File | File[]; output: File | File[] }
}

export enum AccountTypeEnum {
  Agency = 'agency',
  Reviewer = 'reviewer',
  Vendor = 'vendor',
}

/** Autogenerated input type of AddLeadNote */
export type AddLeadNoteInput = {
  body: Scalars['String']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  leadId: Scalars['ID']['input']
}

/** Autogenerated return type of AddLeadNote. */
export type AddLeadNotePayload = {
  __typename?: 'AddLeadNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  note: LeadNote
}

export type AgenciesResult = {
  __typename?: 'AgenciesResult'
  agencies: Array<Agency>
  pagination: Pagination
}

export type Agency = Attachable &
  Contactable & {
    __typename?: 'Agency'
    /** Per-aspect average scores */
    aspectAverages: Array<AspectAverage>
    assignedBadges: Array<AssignedBadge>
    assignedCategories: Array<AgencyAssignedCategory>
    assignedFeatures: Array<AgencyAssignedFeature>
    assignedIndustries: Array<AgencyAssignedIndustry>
    /** Average recommendation score across published universal reviews */
    averageRecommendationRating?: Maybe<Scalars['Float']['output']>
    categories: Array<Category>
    /** Internal + external review count used for combined ranking */
    combinedReviewCount: Scalars['Int']['output']
    companySlug?: Maybe<Scalars['String']['output']>
    config: AgencyConfig
    contactFormRecipients?: Maybe<Array<Scalars['String']['output']>>
    ctaSecondary?: Maybe<Link>
    ctaSecondaryLabelTranslations: Array<Translation>
    ctaSecondaryUrlTranslations: Array<Translation>
    description?: Maybe<Scalars['String']['output']>
    descriptionTranslations: Array<Translation>
    documents: Array<Asset>
    errors?: Maybe<Array<FieldError>>
    expiredAssignedBadges: Array<AssignedBadge>
    /** Unweighted mean of per-platform external scores */
    externalAverageScore?: Maybe<Scalars['Float']['output']>
    /** External platform ratings */
    externalRatings?: Maybe<ExternalRatings>
    externalRatingsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
    /** Total review count from external platforms */
    externalReviewCount?: Maybe<Scalars['Int']['output']>
    /** Weighted average score from external platforms */
    externalWeightedScore?: Maybe<Scalars['Float']['output']>
    featureCategories: Array<AgencyFeatureCategory>
    globalId: Scalars['ID']['output']
    hero?: Maybe<Asset>
    /** Custom poster image for the hero video, when set */
    heroVideoThumbnail?: Maybe<Asset>
    id: Scalars['ID']['output']
    linkText?: Maybe<Scalars['String']['output']>
    linkTextTranslations: Array<Translation>
    linkedin?: Maybe<Scalars['String']['output']>
    locations: Array<Location>
    logo?: Maybe<Asset>
    pageVisitReportEmails?: Maybe<Array<Scalars['String']['output']>>
    remote: Scalars['Boolean']['output']
    /** Total number of published universal reviews */
    reviewCount: Scalars['Int']['output']
    reviewSummary?: Maybe<ReviewSummary>
    /** Published universal reviews for the agency */
    reviews: PaginatedUniversalReviews
    screenshots: Array<Asset>
    seoData?: Maybe<SeoData>
    shortDescription?: Maybe<Scalars['String']['output']>
    shortDescriptionTranslations: Array<Translation>
    slug: Scalars['ID']['output']
    title: Scalars['String']['output']
    toolPartners: Array<ToolPartner>
    traits: Array<AgencyTrait>
    twitter?: Maybe<Scalars['String']['output']>
    url?: Maybe<Scalars['String']['output']>
    urlTranslations: Array<Translation>
    vendorEmailAddresses?: Maybe<Array<Scalars['String']['output']>>
  }

export type AgencyReviewsArgs = {
  filters?: InputMaybe<UniversalReviewsSearchFilters>
}

export type AgencyAssignedCategory = {
  __typename?: 'AgencyAssignedCategory'
  agency: Agency
  assignedFeatures: Array<AgencyAssignedFeature>
  category: Category
  id?: Maybe<Scalars['ID']['output']>
  position: Scalars['Int']['output']
}

export type AgencyAssignedFeature = {
  __typename?: 'AgencyAssignedFeature'
  feature: AgencyFeature
  id?: Maybe<Scalars['ID']['output']>
  position: Scalars['Int']['output']
}

export type AgencyAssignedIndustry = {
  __typename?: 'AgencyAssignedIndustry'
  id?: Maybe<Scalars['ID']['output']>
  industry: Industry
  position: Scalars['Int']['output']
}

export type AgencyAttributeFilterFacet = {
  __typename?: 'AgencyAttributeFilterFacet'
  docCount: Scalars['Int']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type AgencyCitiesFacet = {
  __typename?: 'AgencyCitiesFacet'
  agenciesCount: Scalars['Int']['output']
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type AgencyConfig = {
  __typename?: 'AgencyConfig'
  badgesAdminCalculated: DealAgencyPlanBadgesEnum
  badgesCached: AgencyConfigBadgesCachedEnum
  badgesVendor: AgencyConfigBadgesVendorEnum
  badgesVendorPossibleOptions: Array<Scalars['String']['output']>
  certificatesUspsAdminCalculated: DealAgencyPlanCertificatesUspsEnum
  certificatesUspsCached: AgencyConfigCertificatesUspsCachedEnum
  certificatesUspsVendor: AgencyConfigCertificatesUspsVendorEnum
  certificatesUspsVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaCustomQuoteAdminCalculated: DealAgencyPlanCtaCustomQuoteEnum
  ctaCustomQuoteCached: AgencyConfigCtaCustomQuoteCachedEnum
  ctaCustomQuoteVendor: AgencyConfigCtaCustomQuoteVendorEnum
  ctaCustomQuoteVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaPrimaryAdminCalculated: DealAgencyPlanCtaPrimaryEnum
  ctaPrimaryCached: AgencyConfigCtaPrimaryCachedEnum
  ctaPrimaryVendor: AgencyConfigCtaPrimaryVendorEnum
  ctaPrimaryVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaSecondaryAdminCalculated: DealAgencyPlanCtaSecondaryEnum
  ctaSecondaryCached: AgencyConfigCtaSecondaryCachedEnum
  ctaSecondaryVendor: AgencyConfigCtaSecondaryVendorEnum
  ctaSecondaryVendorPossibleOptions: Array<Scalars['String']['output']>
  descriptionLongAdminCalculated: DealAgencyPlanDescriptionLongEnum
  descriptionLongCached: AgencyConfigDescriptionLongCachedEnum
  descriptionLongVendor: AgencyConfigDescriptionLongVendorEnum
  descriptionLongVendorPossibleOptions: Array<Scalars['String']['output']>
  documentsAdminCalculated: DealAgencyPlanDocumentsEnum
  documentsCached: AgencyConfigDocumentsCachedEnum
  documentsVendor: AgencyConfigDocumentsVendorEnum
  documentsVendorPossibleOptions: Array<Scalars['String']['output']>
  errors?: Maybe<Array<FieldError>>
  heroImageAdminCalculated: DealAgencyPlanHeroImageEnum
  heroImageCached: AgencyConfigHeroImageCachedEnum
  heroImageVendor: AgencyConfigHeroImageVendorEnum
  heroImageVendorPossibleOptions: Array<Scalars['String']['output']>
  pageVisitReportsAdminCalculated: DealAgencyPlanPageVisitReportsEnum
  pageVisitReportsCached: AgencyConfigPageVisitReportsCachedEnum
  pageVisitReportsVendor: AgencyConfigPageVisitReportsVendorEnum
  pageVisitReportsVendorPossibleOptions: Array<Scalars['String']['output']>
  portfolioAdminCalculated: DealAgencyPlanPortfolioEnum
  portfolioCached: AgencyConfigPortfolioCachedEnum
  portfolioVendor: AgencyConfigPortfolioVendorEnum
  portfolioVendorPossibleOptions: Array<Scalars['String']['output']>
  profileClaimedAdminCalculated: DealAgencyPlanProfileClaimedEnum
  profileClaimedCached: AgencyConfigProfileClaimedCachedEnum
  profileClaimedVendor: AgencyConfigProfileClaimedVendorEnum
  profileClaimedVendorPossibleOptions: Array<Scalars['String']['output']>
  socialLinksAdminCalculated: DealAgencyPlanSocialLinksEnum
  socialLinksCached: AgencyConfigSocialLinksCachedEnum
  socialLinksVendor: AgencyConfigSocialLinksVendorEnum
  socialLinksVendorPossibleOptions: Array<Scalars['String']['output']>
  trustedPartnerSectionAdminCalculated: DealAgencyPlanTrustedPartnerSectionEnum
  trustedPartnerSectionCached: AgencyConfigTrustedPartnerSectionCachedEnum
  trustedPartnerSectionVendor: AgencyConfigTrustedPartnerSectionVendorEnum
  trustedPartnerSectionVendorPossibleOptions: Array<Scalars['String']['output']>
  widgetsAdminCalculated: DealAgencyPlanWidgetsEnum
  widgetsCached: AgencyConfigWidgetsCachedEnum
  widgetsVendor: AgencyConfigWidgetsVendorEnum
  widgetsVendorPossibleOptions: Array<Scalars['String']['output']>
}

/** Attributes for updating an agency config */
export type AgencyConfigAttributes = {
  badgesVendor?: InputMaybe<AgencyConfigBadgesVendorEnum>
  certificatesUspsVendor?: InputMaybe<AgencyConfigCertificatesUspsVendorEnum>
  ctaCustomQuoteVendor?: InputMaybe<AgencyConfigCtaCustomQuoteVendorEnum>
  ctaPrimaryVendor?: InputMaybe<AgencyConfigCtaPrimaryVendorEnum>
  ctaSecondaryVendor?: InputMaybe<AgencyConfigCtaSecondaryVendorEnum>
  descriptionLongVendor?: InputMaybe<AgencyConfigDescriptionLongVendorEnum>
  documentsVendor?: InputMaybe<AgencyConfigDocumentsVendorEnum>
  heroImageVendor?: InputMaybe<AgencyConfigHeroImageVendorEnum>
  pageVisitReportsVendor?: InputMaybe<AgencyConfigPageVisitReportsVendorEnum>
  portfolioVendor?: InputMaybe<AgencyConfigPortfolioVendorEnum>
  profileClaimedVendor?: InputMaybe<AgencyConfigProfileClaimedVendorEnum>
  socialLinksVendor?: InputMaybe<AgencyConfigSocialLinksVendorEnum>
  trustedPartnerSectionVendor?: InputMaybe<AgencyConfigTrustedPartnerSectionVendorEnum>
  widgetsVendor?: InputMaybe<AgencyConfigWidgetsVendorEnum>
}

export enum AgencyConfigBadgesCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigBadgesVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCertificatesUspsCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCertificatesUspsVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaCustomQuoteCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaCustomQuoteVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaPrimaryCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaPrimaryVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaSecondaryCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigCtaSecondaryVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigDescriptionLongCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigDescriptionLongVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigDocumentsCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigDocumentsVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigHeroImageCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigHeroImageVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigPageVisitReportsCachedEnum {
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum AgencyConfigPageVisitReportsVendorEnum {
  Automatic = 'automatic',
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum AgencyConfigPortfolioCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigPortfolioVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigProfileClaimedCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigProfileClaimedVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigSocialLinksCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigSocialLinksVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigTrustedPartnerSectionCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigTrustedPartnerSectionVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigWidgetsCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum AgencyConfigWidgetsVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export type AgencyFeature = {
  __typename?: 'AgencyFeature'
  category?: Maybe<Category>
  featureCategory?: Maybe<AgencyFeatureCategory>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nameTranslations: Array<Translation>
}

export type AgencyFeatureCategory = {
  __typename?: 'AgencyFeatureCategory'
  features: Array<AgencyFeature>
  name: Scalars['String']['output']
  nameTranslations: Array<Translation>
}

export type AgencySearchFilters = {
  /** Array of industry slugs */
  industries?: InputMaybe<Array<Scalars['String']['input']>>
  /** Array of city slugs */
  locations?: InputMaybe<Array<Scalars['String']['input']>>
  /** Array of product slugs */
  products?: InputMaybe<Array<Scalars['ID']['input']>>
  remote?: InputMaybe<Scalars['Boolean']['input']>
  term?: InputMaybe<Scalars['String']['input']>
}

export enum AgencySortingEnum {
  BadgesAndTitle = 'badges_and_title',
  CombinedScore = 'combined_score',
  /** @deprecated Use REVIEW_COUNT. Kept for backwards compatibility during frontend rollout. */
  ExternalReviews = 'external_reviews',
  ExternalScore = 'external_score',
  Id = 'id',
  InternalScore = 'internal_score',
  ReviewCount = 'review_count',
  Title = 'title',
}

export type AgencyTrait = {
  __typename?: 'AgencyTrait'
  description?: Maybe<Scalars['String']['output']>
  descriptionTranslations?: Maybe<Array<Translation>>
  id: Scalars['ID']['output']
  kind: AgencyTraitKindEnum
  position: Scalars['Int']['output']
  title?: Maybe<Scalars['String']['output']>
  titleTranslations?: Maybe<Array<Translation>>
}

export enum AgencyTraitKindEnum {
  Certificate = 'certificate',
  Usp = 'usp',
}

export type AlternativeProduct = {
  __typename?: 'AlternativeProduct'
  metaTagIndex?: Maybe<Scalars['Boolean']['output']>
  product: Product
}

export type AlternativeProductsResult = {
  __typename?: 'AlternativeProductsResult'
  alternatives: Array<AlternativeProduct>
  pagination: Pagination
}

export type AnalyticsIdentityCompany = {
  __typename?: 'AnalyticsIdentityCompany'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  planTier?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
}

export type AnalyticsIdentityFields = {
  accountType: AccountTypeEnum
  company?: Maybe<AnalyticsIdentityCompany>
}

export type Answer = {
  __typename?: 'Answer'
  question: Question
  surveyResponse: SurveyResponse
  upload?: Maybe<Asset>
  /** @deprecated This value is going to be removed */
  uploadUrl?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** Attributes for creating or updating an answer */
export type AnswerAttributes = {
  questionId?: InputMaybe<Scalars['ID']['input']>
  upload?: InputMaybe<Scalars['Upload']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type AnswerError = {
  __typename?: 'AnswerError'
  errors: Array<Scalars['String']['output']>
  questionId: Scalars['ID']['output']
  value?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ArchiveLead */
export type ArchiveLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of ArchiveLead. */
export type ArchiveLeadPayload = {
  __typename?: 'ArchiveLeadPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  lead: ManageLead
}

export enum ArrayMatchEnum {
  All = 'all',
  Any = 'any',
}

/** Running per-aspect average score across an agency's published universal reviews. */
export type AspectAverage = {
  __typename?: 'AspectAverage'
  average: Scalars['Float']['output']
  slug: Scalars['String']['output']
}

export type AspectFacet = {
  __typename?: 'AspectFacet'
  /** Localized display label (DE primary) */
  label: Scalars['String']['output']
  /** Reviews mentioning the aspect, neutral mentions included */
  mentionCount: Scalars['Int']['output']
  negativeCount: Scalars['Int']['output']
  positiveCount: Scalars['Int']['output']
  /** Positive share of positive and negative mentions (0-100), 0 when there are none */
  ratio: Scalars['Float']['output']
  slug: Scalars['String']['output']
}

export type AspectFilter = {
  sentiment?: InputMaybe<ReviewsExploreAspectSentiments>
  /** Stable aspect slug */
  slug: Scalars['String']['input']
}

/** A single per-aspect score on a published universal review. */
export type AspectScore = {
  __typename?: 'AspectScore'
  score: Scalars['Int']['output']
  slug: Scalars['String']['output']
}

export type Asset = {
  __typename?: 'Asset'
  /** @deprecated Use url instead */
  blobUrl: Scalars['String']['output']
  contentType: Scalars['String']['output']
  errors?: Maybe<Array<FieldError>>
  filename: Scalars['String']['output']
  id?: Maybe<Scalars['ID']['output']>
  name: Scalars['String']['output']
  nameTranslations: Array<Translation>
  position?: Maybe<Scalars['Int']['output']>
  previewFilename?: Maybe<Scalars['String']['output']>
  previewUrl?: Maybe<Scalars['String']['output']>
  size: Scalars['Float']['output']
  url: Scalars['String']['output']
}

export type AssetPreviewUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type AssetAttributes = {
  deleteCustomPreview?: InputMaybe<Scalars['Boolean']['input']>
  file?: InputMaybe<Scalars['Upload']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  nameTranslations?: InputMaybe<Array<TranslationAttributes>>
  position?: InputMaybe<Scalars['Int']['input']>
  preview?: InputMaybe<Scalars['Upload']['input']>
}

export type AssignedBadge = {
  __typename?: 'AssignedBadge'
  assignedRecordSlug: Scalars['String']['output']
  assignedRecordType: Scalars['String']['output']
  badgeName: Scalars['String']['output']
  badgeType: Scalars['String']['output']
  category?: Maybe<Category>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  timeframe?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type Attachable = {
  documents: Array<Asset>
  globalId: Scalars['ID']['output']
  hero?: Maybe<Asset>
  /** Custom poster image for the hero video, when set */
  heroVideoThumbnail?: Maybe<Asset>
  logo?: Maybe<Asset>
  screenshots: Array<Asset>
}

export type Banner = {
  __typename?: 'Banner'
  active: Scalars['Boolean']['output']
  campaign: PpcCampaign
  clickThroughUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  product?: Maybe<Product>
  viewUrl?: Maybe<Scalars['String']['output']>
}

export type Budget = {
  __typename?: 'Budget'
  additionalValue?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  endDate: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  remainingValue?: Maybe<Scalars['Float']['output']>
  startDate: Scalars['ISO8601Date']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  usedValue?: Maybe<Scalars['Float']['output']>
  value: Scalars['Float']['output']
}

export type Campaign = {
  __typename?: 'Campaign'
  amount?: Maybe<Scalars['Float']['output']>
  amountPublic?: Maybe<Scalars['Boolean']['output']>
  applicable?: Maybe<Scalars['Boolean']['output']>
  /** Distinct reviews linked to this campaign across all incentivization states. */
  associatedReviewsCount?: Maybe<Scalars['Int']['output']>
  available?: Maybe<Scalars['Boolean']['output']>
  budgetLimit?: Maybe<Scalars['Float']['output']>
  campaignType?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  descriptionTranslations: Array<Translation>
  enabled?: Maybe<Scalars['Boolean']['output']>
  errors?: Maybe<Array<FieldError>>
  hashValue?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  incentivizationType?: Maybe<IncentivizationCampaignIncentivizationTypeEnum>
  incentivizationsLimit?: Maybe<Scalars['Int']['output']>
  kind?: Maybe<Scalars['String']['output']>
  limitType?: Maybe<IncentivizationCampaignLimitTypeEnum>
  lostIncentivizationsCount?: Maybe<Scalars['Int']['output']>
  personalizations?: Maybe<Array<Personalization>>
  product?: Maybe<Product>
  requestedIncentivizationsCount?: Maybe<Scalars['Int']['output']>
  status?: Maybe<IncentivizationCampaignStatusEnum>
  title?: Maybe<Scalars['String']['output']>
  totalIncentivizationsCount?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  validFrom?: Maybe<Scalars['ISO8601Date']['output']>
  validTo?: Maybe<Scalars['ISO8601Date']['output']>
  winnable?: Maybe<Scalars['Boolean']['output']>
  wonIncentivizationsCount?: Maybe<Scalars['Int']['output']>
}

/** Attributes for updating an incentivization campaign */
export type CampaignAttributes = {
  amount?: InputMaybe<Scalars['Float']['input']>
  amountPublic?: InputMaybe<Scalars['Boolean']['input']>
  campaignType?: InputMaybe<Scalars['String']['input']>
  descriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  incentivizationType?: InputMaybe<IncentivizationCampaignIncentivizationTypeEnum>
  incentivizationsLimit?: InputMaybe<Scalars['Int']['input']>
  limitType?: InputMaybe<IncentivizationCampaignLimitTypeEnum>
  title?: InputMaybe<Scalars['String']['input']>
  validFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  validTo?: InputMaybe<Scalars['ISO8601Date']['input']>
}

/** Campaign result that may include personalization information */
export type CampaignResult = {
  __typename?: 'CampaignResult'
  /** The campaign */
  campaign: Campaign
  /** Campaign personalization if applicable */
  personalization?: Maybe<Personalization>
}

export type Category = {
  __typename?: 'Category'
  agencies: Array<Agency>
  averageCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  averageEaseOfSetup?: Maybe<Scalars['Float']['output']>
  averageEaseOfUse?: Maybe<Scalars['Float']['output']>
  averageRequirementsScore?: Maybe<Scalars['Float']['output']>
  descriptionAuthorCompany?: Maybe<Scalars['String']['output']>
  descriptionAuthorImage?: Maybe<Scalars['String']['output']>
  descriptionAuthorName?: Maybe<Scalars['String']['output']>
  descriptionAuthorPosition?: Maybe<Scalars['String']['output']>
  displayOrTitle: Scalars['String']['output']
  displayTitle: Scalars['String']['output']
  hidden: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  kind: CategoryKindEnum
  products: Array<Product>
  published: Scalars['Boolean']['output']
  relatedAgencies: Array<Agency>
  relatedCategories: Array<Category>
  relatedProducts: Array<Product>
  reviewCount?: Maybe<Scalars['Int']['output']>
  searchScore?: Maybe<Scalars['Float']['output']>
  seoData?: Maybe<SeoData>
  slug: Scalars['ID']['output']
  subcategories: Array<Category>
  subpages: Array<ProductListingPage>
  title: Scalars['String']['output']
  titleTranslations: Array<Translation>
  topCategory: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type CategoryProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  mainCategoryFilter?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<ExploreProductsSortingEnum>
}

export enum CategoryKindEnum {
  ForAgencies = 'for_agencies',
  ForProducts = 'for_products',
}

/** Autogenerated input type of ChangePricingPlans */
export type ChangePricingPlansInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  pricingPlansAttributes: Array<PricingPlanAttributes>
  productId: Scalars['ID']['input']
}

export type City = {
  __typename?: 'City'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['ID']['output']>
  synonyms?: Maybe<Array<Scalars['String']['output']>>
}

export type ClaimEmailEligibility = {
  __typename?: 'ClaimEmailEligibility'
  privateEmailDomain: Scalars['Boolean']['output']
  registrableDomain?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ClaimProfile */
export type ClaimProfileInput = {
  claimableId: Scalars['GlobalId']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  companyName: Scalars['String']['input']
  companySize: CompanySize
  companyWebsite: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
}

/** Autogenerated return type of ClaimProfile. */
export type ClaimProfilePayload = {
  __typename?: 'ClaimProfilePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  manageUrl?: Maybe<Scalars['String']['output']>
  reason?: Maybe<ClaimRejectionReason>
  status: ClaimStatus
}

export enum ClaimRejectionReason {
  /** Verification passed but provisioning Manage access failed; routed to manual review. */
  CreateManagerFailed = 'CREATE_MANAGER_FAILED',
  /** User, company website, and profile domains do not all match. */
  DomainMismatch = 'DOMAIN_MISMATCH',
  /** Multiple partner companies share the domain; routed to manual review. */
  MultiplePartnerCompaniesMatch = 'MULTIPLE_PARTNER_COMPANIES_MATCH',
  /** The target profile has no website to verify against. */
  NoProfileWebsite = 'NO_PROFILE_WEBSITE',
  /** The partner-company lookup against myomr failed. */
  PartnerCompanyLookupFailed = 'PARTNER_COMPANY_LOOKUP_FAILED',
  /** The user signed up with a personal/free email domain. */
  PrivateEmailDomain = 'PRIVATE_EMAIL_DOMAIN',
}

export enum ClaimStatus {
  /** The profile is already claimed. */
  AlreadyClaimed = 'ALREADY_CLAIMED',
  /** The user already manages this profile; redirect them to Manage. */
  AlreadyManager = 'ALREADY_MANAGER',
  /** Manager creation failed due to a downstream error. */
  CreateManagerFailed = 'CREATE_MANAGER_FAILED',
  /** Manage access was granted. */
  Granted = 'GRANTED',
  /** The claim was routed to manual review. */
  ManualReview = 'MANUAL_REVIEW',
}

export enum CompanySize {
  /** 1 to 5 employees. */
  Range_1_5 = 'RANGE_1_5',
  /** 6 to 25 employees. */
  Range_6_25 = 'RANGE_6_25',
  /** 26 to 50 employees. */
  Range_26_50 = 'RANGE_26_50',
  /** 51 to 100 employees. */
  Range_51_100 = 'RANGE_51_100',
  /** 101 to 250 employees. */
  Range_101_250 = 'RANGE_101_250',
  /** 251 to 500 employees. */
  Range_251_500 = 'RANGE_251_500',
  /** 501 to 1000 employees. */
  Range_501_1000 = 'RANGE_501_1000',
  /** More than 1000 employees. */
  Range_1000Plus = 'RANGE_1000_PLUS',
}

export type ComparisonAlternativesResult = {
  __typename?: 'ComparisonAlternativesResult'
  alternativesPagination: ComparisonPagination
  products: Array<Product>
  versusProducts?: Maybe<Array<VersusProduct>>
}

export type ComparisonPagination = {
  __typename?: 'ComparisonPagination'
  comparisonProductIndex?: Maybe<Scalars['Int']['output']>
  currentPage: Scalars['Int']['output']
  hasNextPage: Scalars['Boolean']['output']
  hasPrevPage: Scalars['Boolean']['output']
  nextPage?: Maybe<Scalars['Int']['output']>
  perPage: Scalars['Int']['output']
  prevPage?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type ContactRequest = {
  __typename?: 'ContactRequest'
  contactRequestType?: Maybe<ContactRequestContactRequestTypeEnum>
  contactable: Contactable
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  errors?: Maybe<Array<FieldError>>
  id?: Maybe<Scalars['ID']['output']>
  leadStatus?: Maybe<LeadStatusEnum>
  locked: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  /** @deprecated Use contactable instead */
  product?: Maybe<Product>
  senderCompany?: Maybe<Scalars['String']['output']>
  senderCompanyPosition?: Maybe<Scalars['String']['output']>
  senderCompanySize?: Maybe<Scalars['String']['output']>
  senderEmail: Scalars['String']['output']
  senderName: Scalars['String']['output']
  senderPhone?: Maybe<Scalars['String']['output']>
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum ContactRequestContactRequestTypeEnum {
  ContactForm = 'contact_form',
  CustomQuote = 'custom_quote',
  FileDownload = 'file_download',
  ReviewStarter = 'review_starter',
}

export enum ContactRequestSourceEnum {
  AgencyPage = 'agency_page',
  Assistant = 'assistant',
  ProductAlternativesPage = 'product_alternatives_page',
  ProductPage = 'product_page',
  ProductPricingPage = 'product_pricing_page',
}

export type Contactable = {
  globalId: Scalars['ID']['output']
}

export enum ContentHubDownvoteReasonEnum {
  NotWhatExpected = 'not_what_expected',
  OtherReason = 'other_reason',
  TooSpecific = 'too_specific',
  TooUnspecific = 'too_unspecific',
  WrongContent = 'wrong_content',
}

export type ContentHubVote = {
  __typename?: 'ContentHubVote'
  createdAt: Scalars['ISO8601DateTime']['output']
  downvoteOtherReason?: Maybe<Scalars['String']['output']>
  downvoteReason?: Maybe<ContentHubDownvoteReasonEnum>
  id: Scalars['ID']['output']
  slug: Scalars['String']['output']
  vote: Scalars['Int']['output']
}

/** Autogenerated input type of CreateContactRequest */
export type CreateContactRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  contactRequestType: Scalars['String']['input']
  /** Global ID of the contactable object */
  contactableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** Stores the user's marketing consent for the contacted product/agency */
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  senderCompany?: InputMaybe<Scalars['String']['input']>
  senderCompanyPosition?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Use senderCompanySizeEnum instead */
  senderCompanySize?: InputMaybe<Scalars['String']['input']>
  senderCompanySizeEnum?: InputMaybe<CompanySize>
  senderEmail: Scalars['String']['input']
  senderName: Scalars['String']['input']
  senderPhone?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<ContactRequestSourceEnum>
}

/** Autogenerated input type of CreateContentHubVote */
export type CreateContentHubVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  downvoteOtherReason?: InputMaybe<Scalars['String']['input']>
  downvoteReason?: InputMaybe<ContentHubDownvoteReasonEnum>
  slug: Scalars['String']['input']
  vote: Scalars['Int']['input']
}

/** Autogenerated return type of CreateContentHubVote. */
export type CreateContentHubVotePayload = {
  __typename?: 'CreateContentHubVotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors: Array<Scalars['String']['output']>
  vote?: Maybe<ContentHubVote>
}

/** Autogenerated input type of CreateDocumentDownloadRequest */
export type CreateDocumentDownloadRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  documentId: Scalars['ID']['input']
  /** Adds the user to the OMR Reviews Community. */
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>
  senderCompany?: InputMaybe<Scalars['String']['input']>
  senderEmail: Scalars['String']['input']
  senderName: Scalars['String']['input']
  source?: InputMaybe<ContactRequestSourceEnum>
}

/** Autogenerated return type of CreateDocumentDownloadRequest. */
export type CreateDocumentDownloadRequestPayload = {
  __typename?: 'CreateDocumentDownloadRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  fileUrl?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of Create */
export type CreateInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  screenshotAttributes: AssetAttributes
}

/** Autogenerated input type of CreateMarketingConsent */
export type CreateMarketingConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Slug of the product the consent is scoped to */
  productSlug: Scalars['ID']['input']
}

/** Autogenerated return type of CreateMarketingConsent. */
export type CreateMarketingConsentPayload = {
  __typename?: 'CreateMarketingConsentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CreatePageVisitSession */
export type CreatePageVisitSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  company: PageVisitCompany
  pageVisits: Array<PageVisit>
  sessionId: Scalars['ID']['input']
}

/** Autogenerated return type of CreatePageVisitSession. */
export type CreatePageVisitSessionPayload = {
  __typename?: 'CreatePageVisitSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors?: Maybe<Array<Error>>
  status?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of Create. */
export type CreatePayload = {
  __typename?: 'CreatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** All record screenshots after mutation */
  screenshots?: Maybe<Array<Asset>>
}

/** Autogenerated input type of CreateReviewSummaryVote */
export type CreateReviewSummaryVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  downvoteReason?: InputMaybe<Scalars['String']['input']>
  reviewSummaryId: Scalars['ID']['input']
  vote: ProductReviewSummaryVoteVoteEnum
}

/** Autogenerated input type of CreateSurveyResponseReminder */
export type CreateSurveyResponseReminderInput = {
  /** Optional campaign or personalization hash to embed in the review link */
  campaignHash?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
  sendCopyToVendor?: InputMaybe<Scalars['Boolean']['input']>
  surveyResponseId: Scalars['ID']['input']
}

/** Autogenerated input type of CreateSurveyResponseReminders */
export type CreateSurveyResponseRemindersInput = {
  /** Optional campaign or personalization hash to embed in the review link */
  campaignHash?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<ManageSurveyResponsesSearchFilters>
  message: Scalars['String']['input']
  productSlug: Scalars['ID']['input']
  sendCopyToVendor?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated input type of CreateUniversalReviewReminder */
export type CreateUniversalReviewReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
  sendCopyToVendor?: InputMaybe<Scalars['Boolean']['input']>
  universalReviewId: Scalars['ID']['input']
}

export type Currency = {
  __typename?: 'Currency'
  code: Scalars['String']['output']
  name: Scalars['String']['output']
  symbol: Scalars['String']['output']
}

export enum DealAgencyPlanBadgesEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanCertificatesUspsEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanCtaCustomQuoteEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanCtaPrimaryEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanCtaSecondaryEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanDescriptionLongEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanDocumentsEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanHeroImageEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanPageVisitReportsEnum {
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum DealAgencyPlanPortfolioEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanProfileClaimedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanSocialLinksEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanTrustedPartnerSectionEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealAgencyPlanWidgetsEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealPlanTypeEnum {
  Plus = 'plus',
  Premium = 'premium',
  PremiumReach = 'premium_reach',
}

export enum DealProductPlanAiVisibilityDashboardEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanBadgesEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanBoostInSearchEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanCtaCustomQuoteEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanCtaPrimaryEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanCtaSecondaryEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanDownloadsFileUploadEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanFileDownloadPassedThroughEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanHeroImageEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanPageVisitReportsEnum {
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum DealProductPlanPricingDisclaimerLinkEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanProfileClaimedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanReviewRemindersAllowedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanReviewRepliesAllowedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanSocialLinksEnum {
  No = 'no',
  Yes = 'yes',
}

export enum DealProductPlanWidgetsEnum {
  No = 'no',
  Yes = 'yes',
}

/** Autogenerated input type of Delete */
export type DeleteInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of Delete. */
export type DeletePayload = {
  __typename?: 'DeletePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** All record screenshots after mutation */
  screenshots?: Maybe<Array<Asset>>
}

export type Error = {
  __typename?: 'Error'
  code: Scalars['Int']['output']
  message: Scalars['String']['output']
}

export type ExploreProductsResult = {
  __typename?: 'ExploreProductsResult'
  averageCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  averageEaseOfSetup?: Maybe<Scalars['Float']['output']>
  averageEaseOfUse?: Maybe<Scalars['Float']['output']>
  averageRecommendationRating?: Maybe<Scalars['Float']['output']>
  averageRequirementsScore?: Maybe<Scalars['Float']['output']>
  averageRightDirection?: Maybe<Scalars['Float']['output']>
  companyFieldFacet: Array<KeywordFacet>
  marketSegmentFacet: Array<MarketSegmentFacet>
  pagination: Pagination
  products: Array<Product>
  recommendationRatingFacet: Array<RecommendationRatingFacet>
}

export enum ExploreProductsSortingEnum {
  Alphabetical = 'alphabetical',
  LowestPopularity = 'lowest_popularity',
  Popularity = 'popularity',
  Rating = 'rating',
  Relevance = 'relevance',
  WeightedScore = 'weighted_score',
}

export type ExternalRating = {
  __typename?: 'ExternalRating'
  count?: Maybe<Scalars['Int']['output']>
  score?: Maybe<Scalars['Float']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ExternalRatings = {
  __typename?: 'ExternalRatings'
  agenturtipp?: Maybe<ExternalRating>
  clutch?: Maybe<ExternalRating>
  goodfirms?: Maybe<ExternalRating>
  google?: Maybe<ExternalRating>
  kununu?: Maybe<ExternalRating>
  provenexperts?: Maybe<ExternalRating>
  sortlist?: Maybe<ExternalRating>
  trustpilot?: Maybe<ExternalRating>
}

export type Feature = {
  __typename?: 'Feature'
  featureCategoryId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type FieldError = {
  __typename?: 'FieldError'
  field: Scalars['String']['output']
  message: Scalars['String']['output']
  value?: Maybe<Scalars['String']['output']>
}

/** Available field keys for CSV export */
export enum FieldKeyEnum {
  /** Campaign name */
  CampaignName = 'campaign_name',
  /** Company name */
  CompanyName = 'company_name',
  /** Created at date */
  CreatedAt = 'created_at',
  /** First published date */
  FirstPublishedAt = 'first_published_at',
  /** Industry of the reviewer */
  Industry = 'industry',
  /** Invitation link */
  InvitationLink = 'invitation_link',
  /** Invitation message */
  InvitationMessage = 'invitation_message',
  /** Link to manager */
  Link = 'link',
  /** Negative feedback */
  Negative = 'negative',
  /** Positive feedback */
  Positive = 'positive',
  /** Problems encountered */
  Problems = 'problems',
  /** Published date */
  PublishedAt = 'published_at',
  /** Review purposes */
  Purpose = 'purpose',
  /** Rating information */
  Rating = 'rating',
  /** Reminder information */
  Reminder = 'reminder',
  /** Reply information */
  Reply = 'reply',
  /** Reply text content */
  ReplyText = 'reply_text',
  /** Reviewer first name */
  ReviewerFirstName = 'reviewer_first_name',
  /** State information */
  State = 'state',
  /** Review title */
  Title = 'title',
  /** Date information */
  UpdatedAt = 'updated_at',
}

export enum FilterByIsSuiteEnum {
  IsProduct = 'is_product',
  IsSuite = 'is_suite',
  IsSuiteOrIsProduct = 'is_suite_or_is_product',
}

export enum FilterByPublicationStatusEnum {
  Draft = 'draft',
  Published = 'published',
  PublishedOrDraft = 'published_or_draft',
}

export type Incentive = {
  __typename?: 'Incentive'
  amount?: Maybe<Scalars['Float']['output']>
  description: Scalars['String']['output']
  /** @deprecated Use slug instead */
  id: Scalars['ID']['output']
  inactiveDueToResponseLimit: Scalars['Boolean']['output']
  slug: Scalars['ID']['output']
  title: Scalars['String']['output']
  valid: Scalars['Boolean']['output']
}

export enum IncentivizationCampaignIncentivizationTypeEnum {
  Amazon = 'amazon',
  Donation = 'donation',
  Either = 'either',
  None = 'none',
  Wunsch = 'wunsch',
}

export enum IncentivizationCampaignLimitTypeEnum {
  Budget = 'budget',
  Incentivizations = 'incentivizations',
}

export enum IncentivizationCampaignPersonalizationLocaleEnum {
  De = 'de',
  En = 'en',
}

export enum IncentivizationCampaignStatusEnum {
  Active = 'active',
  Disabled = 'disabled',
  Inactive = 'inactive',
  Pending = 'pending',
}

/** Autogenerated input type of IncentivizeWithCampaign */
export type IncentivizeWithCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Campaign or personalization hash */
  hashValue: Scalars['String']['input']
  productSlug: Scalars['String']['input']
}

/** Autogenerated return type of IncentivizeWithCampaign. */
export type IncentivizeWithCampaignPayload = {
  __typename?: 'IncentivizeWithCampaignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  error?: Maybe<Scalars['String']['output']>
  requestedIncentivization: Scalars['Boolean']['output']
}

export type Industry = {
  __typename?: 'Industry'
  agencies: Array<Agency>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type KeywordFacet = {
  __typename?: 'KeywordFacet'
  docCount: Scalars['Int']['output']
  key: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export enum LeadHistoryKindEnum {
  Note = 'note',
  StatusChange = 'status_change',
}

export type LeadNote = {
  __typename?: 'LeadNote'
  authorName?: Maybe<Scalars['String']['output']>
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
}

export enum LeadStatusEnum {
  Contacted = 'contacted',
  Lost = 'lost',
  New = 'new',
  Won = 'won',
}

export enum LeadsContactRequestTypeEnum {
  All = 'all',
  ContactForm = 'contact_form',
  CustomQuote = 'custom_quote',
  FileDownload = 'file_download',
  ReviewStarter = 'review_starter',
}

export type LeadsContactRequestTypeFacet = {
  __typename?: 'LeadsContactRequestTypeFacet'
  docCount: Scalars['Int']['output']
  key: LeadsContactRequestTypeEnum
}

export enum LeadsSortByEnum {
  CreatedAt = 'created_at',
}

export type Link = {
  __typename?: 'Link'
  label?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Location = {
  __typename?: 'Location'
  city?: Maybe<Scalars['String']['output']>
  citySlug?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  fullAddress?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  position: Scalars['Int']['output']
  state?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ManageAccess = {
  __typename?: 'ManageAccess'
  hasAccess: Scalars['Boolean']['output']
  manageUrl?: Maybe<Scalars['String']['output']>
}

/** Attributes for updating an agency */
export type ManageAgencyAttributes = {
  agencyProductsAttributes?: InputMaybe<Array<ManageAgencyProductAttributes>>
  assignedCategoriesAttributes?: InputMaybe<Array<ManageAssignedCategoryAttributes>>
  assignedFeaturesAttributes?: InputMaybe<Array<ManageAssignedFeatureAttributes>>
  assignedIndustriesAttributes?: InputMaybe<Array<ManageAssignedIndustryAttributes>>
  configAttributes?: InputMaybe<AgencyConfigAttributes>
  contactFormRecipients?: InputMaybe<Array<Scalars['String']['input']>>
  ctaSecondaryLabelTranslations?: InputMaybe<Array<TranslationAttributes>>
  ctaSecondaryUrlTranslations?: InputMaybe<Array<TranslationAttributes>>
  descriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  heroImage?: InputMaybe<Scalars['Upload']['input']>
  heroVideo?: InputMaybe<Scalars['Upload']['input']>
  heroVideoThumbnail?: InputMaybe<Scalars['Upload']['input']>
  linkTextTranslations?: InputMaybe<Array<TranslationAttributes>>
  linkedin?: InputMaybe<Scalars['String']['input']>
  locationsAttributes?: InputMaybe<Array<ManageLocationAttributes>>
  logo?: InputMaybe<Scalars['Upload']['input']>
  pageVisitReportEmails?: InputMaybe<Array<Scalars['String']['input']>>
  remote?: InputMaybe<Scalars['Boolean']['input']>
  shortDescriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  title?: InputMaybe<Scalars['String']['input']>
  traitsAttributes?: InputMaybe<Array<TraitAttributes>>
  twitter?: InputMaybe<Scalars['String']['input']>
  urlTranslations?: InputMaybe<Array<TranslationAttributes>>
  vendorEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Attributes for updating an agency product */
export type ManageAgencyProductAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  adpPosition?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  productId?: InputMaybe<Scalars['ID']['input']>
}

/** Attributes for updating an assigned category */
export type ManageAssignedCategoryAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
}

/** Attributes for updating an assigned feature */
export type ManageAssignedFeatureAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  featureId?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
}

/** Attributes for updating an assigned industry */
export type ManageAssignedIndustryAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  industryId?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
}

export type ManageCreateSurveyResponseRemindersResult = {
  __typename?: 'ManageCreateSurveyResponseRemindersResult'
  failedCount: Scalars['Int']['output']
  successCount: Scalars['Int']['output']
}

/** Autogenerated input type of ManageDocumentDelete */
export type ManageDocumentDeleteInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated input type of ManageDocumentUpdate */
export type ManageDocumentUpdateInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  documentAttributes: Array<AssetAttributes>
}

/** Autogenerated input type of ManageDocumentsCreate */
export type ManageDocumentsCreateInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  documentAttributes: AssetAttributes
}

export type ManageExploreLeads = {
  __typename?: 'ManageExploreLeads'
  contactRequestTypeFacet: Array<LeadsContactRequestTypeFacet>
  pagination: Pagination
  results: Array<ContactRequest>
}

export type ManageExploreSurveyResponses = {
  __typename?: 'ManageExploreSurveyResponses'
  campaignsFacet: Array<KeywordFacet>
  pagination: Pagination
  purposesFacet: Array<KeywordFacet>
  recommendationRatingFacet: Array<RecommendationRatingFacet>
  reminderStatusFacet: Array<SurveyResponsesReminderStatusFacet>
  replyStatusFacet: Array<SurveyResponsesReplyStatusFacet>
  results: Array<ManageSurveyResponse>
  stateFacet: Array<SurveyResponsesStateFacet>
  viewFacet: Array<SurveyResponsesViewFacet>
}

export type ManageExploreUniversalReviews = {
  __typename?: 'ManageExploreUniversalReviews'
  pagination: Pagination
  ratingFacet: Array<RecommendationRatingFacet>
  reviews: Array<UniversalReview>
  statusFacet: Array<UniversalReviewStatusFacet>
}

/** Autogenerated input type of ManageIncentivizationCampaignCreate */
export type ManageIncentivizationCampaignCreateInput = {
  attributes: CampaignAttributes
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  productId: Scalars['ID']['input']
}

/** Autogenerated input type of ManageIncentivizationCampaignDelete */
export type ManageIncentivizationCampaignDeleteInput = {
  /** Campaign ID */
  campaign: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of ManageIncentivizationCampaignPersonalizationCreate */
export type ManageIncentivizationCampaignPersonalizationCreateInput = {
  attributes: PersonalizationAttributes
  /** Campaign ID */
  campaign: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of ManageIncentivizationCampaignPersonalizationDelete */
export type ManageIncentivizationCampaignPersonalizationDeleteInput = {
  /** Campaign personalization ID */
  campaignPersonalization: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of ManageIncentivizationCampaignPersonalizationUpdate */
export type ManageIncentivizationCampaignPersonalizationUpdateInput = {
  attributes: PersonalizationAttributes
  /** Campaign personalization ID */
  campaignPersonalization: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of ManageIncentivizationCampaignUpdate */
export type ManageIncentivizationCampaignUpdateInput = {
  attributes: CampaignAttributes
  /** Campaign ID */
  campaign: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

export type ManageInsightsAttributeIndexCompositeFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsAttributeIndexCompositeOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export enum ManageInsightsAttributeIndexCompositeOrderBy {
  ApixComposite = 'APIX_COMPOSITE',
  TotalMentions = 'TOTAL_MENTIONS',
}

export type ManageInsightsAttributeIndexCompositeResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsAttributeIndexCompositeResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsAttributeIndexCompositeRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsAttributeIndexCompositeRow = {
  __typename?: 'ManageInsightsAttributeIndexCompositeRow'
  apixComposite?: Maybe<Scalars['Float']['output']>
  attributesInComposite?: Maybe<Scalars['Int']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  totalMentions?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsAttributeIndexFilters = {
  attribute?: InputMaybe<ManageInsightsAttributeKey>
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsAttributeIndexOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export enum ManageInsightsAttributeIndexOrderBy {
  Apix = 'APIX',
  AttrRank = 'ATTR_RANK',
  TotalMentions = 'TOTAL_MENTIONS',
}

export type ManageInsightsAttributeIndexResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsAttributeIndexResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsAttributeIndexRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsAttributeIndexRow = {
  __typename?: 'ManageInsightsAttributeIndexRow'
  apix?: Maybe<Scalars['Float']['output']>
  attrRank?: Maybe<Scalars['Int']['output']>
  /** One of 15 fixed keys that Gemini extracts from review text in dbt: `ux`, `features`, `performance`, `reliability`, `support`, `pricing`, `onboarding`, `integrations`, `reporting`, `documentation`, `customization`, `collaboration`, `mobile`, `product_development`, `security`. The same keys on `attribute-index` and `attribute-sentiment`. */
  attribute?: Maybe<Scalars['String']['output']>
  categoryAttrTotalMentions?: Maybe<Scalars['Int']['output']>
  categoryAvgPositiveShare?: Maybe<Scalars['Float']['output']>
  /** One row per published category of the tool. The tool's own mention counts and `positive_share` repeat on each, so do not add them up across categories; `attr_rank`, `apix`, `tools_with_attr` and the `category_*` columns are that category's. */
  categorySlug?: Maybe<Scalars['String']['output']>
  mixedMentions?: Maybe<Scalars['Int']['output']>
  negativeMentions?: Maybe<Scalars['Int']['output']>
  positiveMentions?: Maybe<Scalars['Int']['output']>
  positiveShare?: Maybe<Scalars['Float']['output']>
  reviewsWithMention?: Maybe<Scalars['Int']['output']>
  toolsWithAttr?: Maybe<Scalars['Int']['output']>
  totalMentions?: Maybe<Scalars['Int']['output']>
}

/**
 * Which product attribute a review mention is about.
 *
 * The 15 keys Gemini extracts from review text in dbt, the same on `attribute-index`
 * and `attribute-sentiment`. Source of truth: the `accepted_values` test on
 * `int_reviews__attribute_sentiment.attribute` in `attribute_sentiment__models.yml`
 * in `data-orchestration`.
 */
export enum ManageInsightsAttributeKey {
  Collaboration = 'COLLABORATION',
  Customization = 'CUSTOMIZATION',
  Documentation = 'DOCUMENTATION',
  Features = 'FEATURES',
  Integrations = 'INTEGRATIONS',
  Mobile = 'MOBILE',
  Onboarding = 'ONBOARDING',
  Performance = 'PERFORMANCE',
  Pricing = 'PRICING',
  ProductDevelopment = 'PRODUCT_DEVELOPMENT',
  Reliability = 'RELIABILITY',
  Reporting = 'REPORTING',
  Security = 'SECURITY',
  Support = 'SUPPORT',
  Ux = 'UX',
}

export type ManageInsightsAttributeSentimentFilters = {
  attribute?: InputMaybe<ManageInsightsAttributeKey>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsAttributeSentimentOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsAttributeSentimentOrderBy {
  AvgStarsOfPositiveMentioners = 'AVG_STARS_OF_POSITIVE_MENTIONERS',
  Period = 'PERIOD',
  PositiveShare = 'POSITIVE_SHARE',
  TotalMentions = 'TOTAL_MENTIONS',
}

export type ManageInsightsAttributeSentimentResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsAttributeSentimentResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsAttributeSentimentRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsAttributeSentimentRow = {
  __typename?: 'ManageInsightsAttributeSentimentRow'
  /** One of 15 fixed keys that Gemini extracts from review text in dbt: `ux`, `features`, `performance`, `reliability`, `support`, `pricing`, `onboarding`, `integrations`, `reporting`, `documentation`, `customization`, `collaboration`, `mobile`, `product_development`, `security`. The same keys on `attribute-index` and `attribute-sentiment`. */
  attribute?: Maybe<Scalars['String']['output']>
  avgStarsOfPositiveMentioners?: Maybe<Scalars['Float']['output']>
  mixedMentions?: Maybe<Scalars['Int']['output']>
  negativeMentions?: Maybe<Scalars['Int']['output']>
  /** Mentions in reviews published in this month only, not a running total. */
  period?: Maybe<Scalars['ISO8601Date']['output']>
  positiveMentions?: Maybe<Scalars['Int']['output']>
  positiveShare?: Maybe<Scalars['Float']['output']>
  /** The tool's published reviews in this month, repeated on every attribute row of the month — sum one value per month, never per attribute. At least `reviews_with_mention`, so each share is within 0–1. */
  reviewCount?: Maybe<Scalars['Int']['output']>
  reviewsWithMention?: Maybe<Scalars['Int']['output']>
  /** Distinct reviews with a negative mention of the attribute in this month. */
  reviewsWithNegativeMention?: Maybe<Scalars['Int']['output']>
  /** Distinct reviews with a positive mention of the attribute in this month. */
  reviewsWithPositiveMention?: Maybe<Scalars['Int']['output']>
  totalMentions?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsBadgeProgressFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsBadgeProgressOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  targetRank?: InputMaybe<Scalars['Int']['input']>
}

export enum ManageInsightsBadgeProgressOrderBy {
  GapToTarget = 'GAP_TO_TARGET',
  RankInCategory = 'RANK_IN_CATEGORY',
  TargetRank = 'TARGET_RANK',
}

export type ManageInsightsBadgeProgressResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsBadgeProgressResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsBadgeProgressRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsBadgeProgressRow = {
  __typename?: 'ManageInsightsBadgeProgressRow'
  badgeNames?: Maybe<Array<Scalars['String']['output']>>
  categorySlug?: Maybe<Scalars['String']['output']>
  gapToTarget?: Maybe<Scalars['Float']['output']>
  hasBadge?: Maybe<Scalars['Boolean']['output']>
  omrScore?: Maybe<Scalars['Float']['output']>
  rankInCategory?: Maybe<Scalars['Int']['output']>
  recentReviewCount?: Maybe<Scalars['Int']['output']>
  targetRank?: Maybe<Scalars['Int']['output']>
  targetScore?: Maybe<Scalars['Float']['output']>
  targetToolSlug?: Maybe<Scalars['String']['output']>
  toolsInCategory?: Maybe<Scalars['Int']['output']>
  totalReviewCount?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsBatchResult = {
  __typename?: 'ManageInsightsBatchResult'
  /** One per request, in request order. */
  results: Array<ManageInsightsItemResult>
}

export type ManageInsightsBenchmarkTiersFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  measureName?: InputMaybe<ManageInsightsMeasureName>
  orderBy?: InputMaybe<ManageInsightsBenchmarkTiersOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsBenchmarkTiersOrderBy {
  CategoryPercentile = 'CATEGORY_PERCENTILE',
  MeasureValue = 'MEASURE_VALUE',
  Period = 'PERIOD',
  YouVsMedianIndex = 'YOU_VS_MEDIAN_INDEX',
}

export type ManageInsightsBenchmarkTiersResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsBenchmarkTiersResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsBenchmarkTiersRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsBenchmarkTiersRow = {
  __typename?: 'ManageInsightsBenchmarkTiersRow'
  categoryAvg?: Maybe<Scalars['Float']['output']>
  categoryMedian?: Maybe<Scalars['Float']['output']>
  categoryPercentile?: Maybe<Scalars['Float']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  mainCategoryOmrRank?: Maybe<Scalars['Int']['output']>
  measureName?: Maybe<Scalars['String']['output']>
  measureValue?: Maybe<Scalars['Float']['output']>
  measureValueDeltaPrev?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  rankedToolsInCategory?: Maybe<Scalars['Int']['output']>
  tier1Avg?: Maybe<Scalars['Float']['output']>
  tier1Min?: Maybe<Scalars['Float']['output']>
  tier2Avg?: Maybe<Scalars['Float']['output']>
  youVsMedianIndex?: Maybe<Scalars['Float']['output']>
  youVsTier1Index?: Maybe<Scalars['Float']['output']>
  youVsTier2Index?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsByMonthFilters = {
  companySlug?: InputMaybe<Scalars['String']['input']>
  demaskingSourceType?: InputMaybe<ManageInsightsDemaskingSourceType>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  mainCategorySlug?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<ManageInsightsByMonthOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  sector?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subjectType?: InputMaybe<ManageInsightsSubjectType>
}

export enum ManageInsightsByMonthOrderBy {
  IntentScore = 'INTENT_SCORE',
  Period = 'PERIOD',
  Visits = 'VISITS',
}

export type ManageInsightsByMonthResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsByMonthResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsIntentAggregateRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsByWeekFilters = {
  companySlug?: InputMaybe<Scalars['String']['input']>
  demaskingSourceType?: InputMaybe<ManageInsightsDemaskingSourceType>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  mainCategorySlug?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<ManageInsightsByWeekOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  sector?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subjectType?: InputMaybe<ManageInsightsSubjectType>
}

export enum ManageInsightsByWeekOrderBy {
  IntentScore = 'INTENT_SCORE',
  Period = 'PERIOD',
  Visits = 'VISITS',
}

export type ManageInsightsByWeekResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsByWeekResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsIntentAggregateRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCampaignPerformanceFilters = {
  campaignStatus?: InputMaybe<Scalars['String']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCampaignPerformanceOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export enum ManageInsightsCampaignPerformanceOrderBy {
  CampaignValidFrom = 'CAMPAIGN_VALID_FROM',
  Incentivizations = 'INCENTIVIZATIONS',
  StartedCount = 'STARTED_COUNT',
  SubmitRate = 'SUBMIT_RATE',
  WinRate = 'WIN_RATE',
  WonIncentivizationsCount = 'WON_INCENTIVIZATIONS_COUNT',
}

export type ManageInsightsCampaignPerformanceResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCampaignPerformanceResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCampaignPerformanceRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCampaignPerformanceRow = {
  __typename?: 'ManageInsightsCampaignPerformanceRow'
  campaignAmount?: Maybe<Scalars['Float']['output']>
  campaignId?: Maybe<Scalars['Int']['output']>
  campaignIsEnabled?: Maybe<Scalars['Boolean']['output']>
  campaignStatus?: Maybe<Scalars['String']['output']>
  campaignTitle?: Maybe<Scalars['String']['output']>
  campaignType?: Maybe<Scalars['String']['output']>
  campaignValidFrom?: Maybe<Scalars['ISO8601Date']['output']>
  campaignValidTo?: Maybe<Scalars['ISO8601Date']['output']>
  incentivizationType?: Maybe<Scalars['String']['output']>
  incentivizations?: Maybe<Scalars['Int']['output']>
  lostIncentivizationsCount?: Maybe<Scalars['Int']['output']>
  /** Published review on or after the start. */
  publishedCount?: Maybe<Scalars['Int']['output']>
  rejectedReviews?: Maybe<Scalars['Int']['output']>
  requestedIncentivizationsCount?: Maybe<Scalars['Int']['output']>
  /** Survey opened via the campaign link. */
  startedCount?: Maybe<Scalars['Int']['output']>
  /** submitted_count / started_count, lifetime. NULL when the campaign has no starts. */
  submitRate?: Maybe<Scalars['Float']['output']>
  /** First proposal on or after the start. */
  submittedCount?: Maybe<Scalars['Int']['output']>
  winRate?: Maybe<Scalars['Float']['output']>
  wonIncentivizationsCount?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsCategoryDemandFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  entityId: Scalars['String']['input']
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCategoryDemandOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsCategoryDemandOrderBy {
  IntentScore = 'INTENT_SCORE',
  PageviewsEstimated = 'PAGEVIEWS_ESTIMATED',
  Period = 'PERIOD',
  Sessions = 'SESSIONS',
}

export type ManageInsightsCategoryDemandResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCategoryDemandResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCategoryDemandRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCategoryDemandRow = {
  __typename?: 'ManageInsightsCategoryDemandRow'
  demaskedCompanies?: Maybe<Scalars['Int']['output']>
  demaskedCompaniesDeltaPrev?: Maybe<Scalars['Int']['output']>
  demaskedCompaniesDeltaYoy?: Maybe<Scalars['Int']['output']>
  intentScore?: Maybe<Scalars['Int']['output']>
  intentScoreDeltaPrev?: Maybe<Scalars['Int']['output']>
  intentScoreDeltaYoy?: Maybe<Scalars['Int']['output']>
  /** GA4 clientside pageviews, adjusted for opt-in — a modelled estimate, not a count. */
  pageviewsEstimated?: Maybe<Scalars['Float']['output']>
  /** Change against the previous period, on the GA4 estimate. */
  pageviewsEstimatedDeltaPrev?: Maybe<Scalars['Float']['output']>
  /** Change against the same period a year earlier, on the GA4 estimate. */
  pageviewsEstimatedDeltaYoy?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sessions?: Maybe<Scalars['Int']['output']>
  sessionsDeltaPrev?: Maybe<Scalars['Int']['output']>
  sessionsDeltaYoy?: Maybe<Scalars['Int']['output']>
  toolsWithTraffic?: Maybe<Scalars['Int']['output']>
  toolsWithTrafficDeltaPrev?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsCategoryFunnelFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCategoryFunnelOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subjectType?: InputMaybe<ManageInsightsSubjectType>
}

export enum ManageInsightsCategoryFunnelOrderBy {
  PageVisits = 'PAGE_VISITS',
  Period = 'PERIOD',
  SubjectTypeShare = 'SUBJECT_TYPE_SHARE',
}

export type ManageInsightsCategoryFunnelResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCategoryFunnelResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCategoryFunnelRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCategoryFunnelRow = {
  __typename?: 'ManageInsightsCategoryFunnelRow'
  /** The entity's whole funnel, serverside — the denominator `page_visits` is a slice of. */
  entityPageVisits?: Maybe<Scalars['Int']['output']>
  entityType?: Maybe<Scalars['String']['output']>
  /** Serverside page visits, one row per visit — an exact count. */
  pageVisits?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  subjectType?: Maybe<Scalars['String']['output']>
  subjectTypeShare?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsCitationEnginesFilters = {
  citedViaOmr?: InputMaybe<Scalars['Boolean']['input']>
  domain?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCitationEnginesOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsCitationEnginesOrderBy {
  DomainShare = 'DOMAIN_SHARE',
  Occurrences = 'OCCURRENCES',
  Period = 'PERIOD',
}

export type ManageInsightsCitationEnginesResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCitationEnginesResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCitationEnginesRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCitationEnginesRow = {
  __typename?: 'ManageInsightsCitationEnginesRow'
  citedUrlCount?: Maybe<Scalars['Int']['output']>
  citedViaOmr?: Maybe<Scalars['Boolean']['output']>
  domain?: Maybe<Scalars['String']['output']>
  domainShare?: Maybe<Scalars['Float']['output']>
  domainShareDeltaPrev?: Maybe<Scalars['Float']['output']>
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  occurrences?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsCitationSourcesFilters = {
  citedViaOmr?: InputMaybe<Scalars['Boolean']['input']>
  domain?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCitationSourcesOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsCitationSourcesOrderBy {
  DomainShare = 'DOMAIN_SHARE',
  Occurrences = 'OCCURRENCES',
  Period = 'PERIOD',
}

export type ManageInsightsCitationSourcesResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCitationSourcesResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCitationSourcesRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCitationSourcesRow = {
  __typename?: 'ManageInsightsCitationSourcesRow'
  citedUrlCount?: Maybe<Scalars['Int']['output']>
  citedViaOmr?: Maybe<Scalars['Boolean']['output']>
  domain?: Maybe<Scalars['String']['output']>
  domainShare?: Maybe<Scalars['Float']['output']>
  domainShareDeltaPrev?: Maybe<Scalars['Float']['output']>
  occurrences?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsClickoutRateFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsClickoutRateOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsClickoutRateOrderBy {
  CtrOut = 'CTR_OUT',
  CtrOutCategoryPercentile = 'CTR_OUT_CATEGORY_PERCENTILE',
  Period = 'PERIOD',
}

export type ManageInsightsClickoutRateResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsClickoutRateResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsClickoutRateRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsClickoutRateRow = {
  __typename?: 'ManageInsightsClickoutRateRow'
  categoryMedianCtrOut?: Maybe<Scalars['Float']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  clickouts?: Maybe<Scalars['Float']['output']>
  ctrOut?: Maybe<Scalars['Float']['output']>
  ctrOutCategoryPercentile?: Maybe<Scalars['Float']['output']>
  ctrOutDeltaPrev?: Maybe<Scalars['Float']['output']>
  ctrOutVsMedianIndex?: Maybe<Scalars['Float']['output']>
  ctrOutVsTop3Index?: Maybe<Scalars['Float']['output']>
  mainCategoryOmrRank?: Maybe<Scalars['Int']['output']>
  /** GA4 clientside pageviews, adjusted for opt-in — a modelled estimate, not a count. */
  pageviewsEstimated?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  rankedToolsInCategory?: Maybe<Scalars['Int']['output']>
  top3CtrOut?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsCompetitorDetailFilters = {
  competitorName?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCompetitorDetailOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsCompetitorDetailOrderBy {
  DetectionRate = 'DETECTION_RATE',
  Period = 'PERIOD',
  VisibilityScore = 'VISIBILITY_SCORE',
}

export type ManageInsightsCompetitorDetailResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCompetitorDetailResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCompetitorDetailRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCompetitorDetailRow = {
  __typename?: 'ManageInsightsCompetitorDetailRow'
  competitorMatchedBrandId?: Maybe<Scalars['String']['output']>
  competitorName?: Maybe<Scalars['String']['output']>
  detectionRate?: Maybe<Scalars['Float']['output']>
  detectionRateDeltaPrev?: Maybe<Scalars['Float']['output']>
  isOwnBrand?: Maybe<Scalars['Boolean']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  visibilityScore?: Maybe<Scalars['Float']['output']>
  visibilityScoreDeltaPrev?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsCovisitationFilters = {
  competitorSlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsCovisitationOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsCovisitationOrderBy {
  CovisitingSessions = 'COVISITING_SESSIONS',
  CovisitRank = 'COVISIT_RANK',
  CovisitRate = 'COVISIT_RATE',
  Period = 'PERIOD',
}

export type ManageInsightsCovisitationResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsCovisitationResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsCovisitationRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsCovisitationRow = {
  __typename?: 'ManageInsightsCovisitationRow'
  /** All sessions that viewed the tool, incl. single-tool ones. Traffic context. */
  baseSessions?: Maybe<Scalars['Int']['output']>
  /** Sessions that viewed the tool and at least one same-category competitor. The denominator of covisit_rate. Repeated on every competitor row of the month — sum one value per month, never per competitor. */
  comparingSessions?: Maybe<Scalars['Int']['output']>
  competitorSlug?: Maybe<Scalars['String']['output']>
  covisitRank?: Maybe<Scalars['Int']['output']>
  /** covisiting_sessions / comparing_sessions. Sessions that viewed only the tool are excluded. */
  covisitRate?: Maybe<Scalars['Float']['output']>
  covisitRateDeltaPrev?: Maybe<Scalars['Float']['output']>
  covisitingSessions?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

/**
 * The demasking providers that ever identified a visitor.
 *
 * Only `sales_viewer` is live (since 2024-03-07); the other three are retired but
 * still in history. Source of truth:
 * `sem_agg_reviews__tracking_demaskings.yml` in `data-orchestration`.
 */
export enum ManageInsightsDemaskingSourceType {
  Albacross = 'ALBACROSS',
  Leadfeeder = 'LEADFEEDER',
  Leadinfo = 'LEADINFO',
  SalesViewer = 'SALES_VIEWER',
}

export type ManageInsightsDetailFilters = {
  companySlug?: InputMaybe<Scalars['String']['input']>
  demaskingSourceType?: InputMaybe<ManageInsightsDemaskingSourceType>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  mainCategorySlug?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<ManageInsightsDetailOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  sector?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subjectType?: InputMaybe<ManageInsightsSubjectType>
}

export enum ManageInsightsDetailOrderBy {
  IntentScore = 'INTENT_SCORE',
  Period = 'PERIOD',
}

export type ManageInsightsDetailResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsDetailResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsDetailRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsDetailRow = {
  __typename?: 'ManageInsightsDetailRow'
  city?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companySlug?: Maybe<Scalars['String']['output']>
  companyWebsite?: Maybe<Scalars['String']['output']>
  demaskingSourceType?: Maybe<Scalars['String']['output']>
  /**
   * Deprecated: one value, `Uncategorized`, on every row since 2025. The eight real size bands stopped arriving in the same week as `linkedin_industry_category`. Never null, so a null check reads it as healthy — it is not.
   * @deprecated Deprecated: one value, `Uncategorized`, on every row since 2025. The eight real size bands stopped arriving in the same week as `linkedin_industry_category`. Never null, so a null check reads it as healthy — it is not.
   */
  employees?: Maybe<Scalars['String']['output']>
  intentScore?: Maybe<Scalars['Int']['output']>
  /**
   * Deprecated: no value has arrived since 2024-03-04, when the demasking provider changed. Null on any window a caller can ask for.
   * @deprecated Deprecated: no value has arrived since 2024-03-04, when the demasking provider changed. Null on any window a caller can ask for.
   */
  linkedinIndustryCategory?: Maybe<Scalars['String']['output']>
  linkedinUrl?: Maybe<Scalars['String']['output']>
  mainCategorySlug?: Maybe<Scalars['String']['output']>
  pageVisitId?: Maybe<Scalars['Int']['output']>
  pageVisitSessionId?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  recurring?: Maybe<Scalars['Int']['output']>
  sector?: Maybe<Scalars['String']['output']>
  subjectId?: Maybe<Scalars['String']['output']>
  subjectType?: Maybe<Scalars['String']['output']>
  toolTitle?: Maybe<Scalars['String']['output']>
}

export type ManageInsightsDetectionTrendsFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsDetectionTrendsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsDetectionTrendsOrderBy {
  DetectionRate = 'DETECTION_RATE',
  Period = 'PERIOD',
  Top3Rate = 'TOP3_RATE',
}

export type ManageInsightsDetectionTrendsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsDetectionTrendsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsDetectionTrendsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsDetectionTrendsRow = {
  __typename?: 'ManageInsightsDetectionTrendsRow'
  detectionRate?: Maybe<Scalars['Float']['output']>
  detectionRateDeltaPrev?: Maybe<Scalars['Float']['output']>
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  top3Rate?: Maybe<Scalars['Float']['output']>
  top3RateDeltaPrev?: Maybe<Scalars['Float']['output']>
  weeksOfHistory?: Maybe<Scalars['Int']['output']>
}

/**
 * Why the answer carries nothing usable — set only when it does not.
 *
 * The API deliberately does NOT distinguish "this id does not exist" from "this
 * id has no rows here": telling them apart costs a second query, and answering
 * it would let a caller enumerate which tools exist, which the uniform 403 on
 * the entitlement gate exists to prevent.
 *
 * `below_guardrail` is the one value that can appear NEXT TO rows. Small-n
 * suppression keeps the thin row and its counted facts and nulls only the
 * measures derived from the thin denominator, so an answer can be fully
 * suppressed while `row_count` is not zero. It is set only when every row lost a
 * measure, and only from a counted denominator present in the rows — never
 * inferred from an empty result, which is a different fact.
 */
export enum ManageInsightsEmptyReason {
  BelowGuardrail = 'BELOW_GUARDRAIL',
  NoData = 'NO_DATA',
  NoDataForPeriod = 'NO_DATA_FOR_PERIOD',
}

/**
 * The AI surfaces Rankscale tracks.
 *
 * Source of truth: `dim_rankscale__engines` in `data-orchestration`. It is a
 * superset of what the exposure tables hold — the facts take `engine_id` from the
 * Rankscale ingestion, not from the dim — so a member with no snapshots answers
 * 200 with no rows.
 */
export enum ManageInsightsEngineId {
  AnthropicClaude_3_5Haiku = 'ANTHROPIC_CLAUDE_3_5_HAIKU',
  AnthropicClaude_3_5Sonnet = 'ANTHROPIC_CLAUDE_3_5_SONNET',
  AnthropicClaude_4_5Haiku = 'ANTHROPIC_CLAUDE_4_5_HAIKU',
  BingCopilotGui = 'BING_COPILOT_GUI',
  ChatgptGui = 'CHATGPT_GUI',
  DeepseekChat = 'DEEPSEEK_CHAT',
  GoogleAiModeGui = 'GOOGLE_AI_MODE_GUI',
  GoogleAiOverview = 'GOOGLE_AI_OVERVIEW',
  GoogleGemini_15 = 'GOOGLE_GEMINI_15',
  GoogleGemini_20 = 'GOOGLE_GEMINI_20',
  GoogleGemini_25 = 'GOOGLE_GEMINI_25',
  GoogleGemini_30Flash = 'GOOGLE_GEMINI_30_FLASH',
  GoogleGemini_30Pro = 'GOOGLE_GEMINI_30_PRO',
  GoogleGeminiGui = 'GOOGLE_GEMINI_GUI',
  MistralLarge = 'MISTRAL_LARGE',
  OpenaiGpt_4O = 'OPENAI_GPT_4O',
  OpenaiGpt_5 = 'OPENAI_GPT_5',
  PerplexityGui = 'PERPLEXITY_GUI',
  PerplexitySonar = 'PERPLEXITY_SONAR',
  PerplexitySonarPro = 'PERPLEXITY_SONAR_PRO',
  PerplexitySonarReasoning = 'PERPLEXITY_SONAR_REASONING',
  PerplexitySonarReasoningPro = 'PERPLEXITY_SONAR_REASONING_PRO',
  XaiGrokGui = 'XAI_GROK_GUI',
}

/**
 * What the rows are about, echoed back so an answer identifies itself.
 *
 * A batch mixes metrics keyed on different id spaces (`tool_slug`, `tool_id`,
 * `brand_id`, `category_slug`, `entity_slug`); without this a client has to
 * remember which id it sent with which item.
 */
export type ManageInsightsEntityRef = {
  __typename?: 'ManageInsightsEntityRef'
  id: Scalars['String']['output']
  /** The filter field that named it, e.g. `tool_slug`. */
  idField: Scalars['String']['output']
  type: ManageInsightsEntityType
}

/** What kind of thing an `EntityRef` names. */
export enum ManageInsightsEntityType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Entity = 'ENTITY',
  Tool = 'TOOL',
}

/** What one insights metric answered. `rows` differ per metric and are selected through a fragment on the concrete type; everything else is a plain selection. */
export type ManageInsightsEnvelope = {
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

/**
 * How coarse a metric's periods are — the unit `start`/`end`/`as_of` count in.
 *
 * Declared per metric on its filters model, never inferred from the date column's
 * name: a column called `snapshot_date` can hold weekly periods, and a ranking
 * year is not a date at all.
 *
 * The declaration reaches the envelope through `QueryMeta` — the repository reads
 * it off the filters object it is already handed and passes it into the same
 * `select_snapshot` call that builds the SQL. So it is recorded next to the query
 * and is also readable statically, which is what `GET /v1/insights/catalog` needs:
 * a static document cannot run a query to find out.
 */
export enum ManageInsightsGrain {
  Day = 'DAY',
  Lifetime = 'LIFETIME',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type ManageInsightsIntentAggregateRow = {
  __typename?: 'ManageInsightsIntentAggregateRow'
  city?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companySlug?: Maybe<Scalars['String']['output']>
  companyWebsite?: Maybe<Scalars['String']['output']>
  demaskingSourceType?: Maybe<Scalars['String']['output']>
  /**
   * Deprecated: one value, `Uncategorized`, on every row since 2025. The eight real size bands stopped arriving in the same week as `linkedin_industry_category`. Never null, so a null check reads it as healthy — it is not.
   * @deprecated Deprecated: one value, `Uncategorized`, on every row since 2025. The eight real size bands stopped arriving in the same week as `linkedin_industry_category`. Never null, so a null check reads it as healthy — it is not.
   */
  employees?: Maybe<Scalars['String']['output']>
  intentScore?: Maybe<Scalars['Int']['output']>
  /**
   * Deprecated: no value has arrived since 2024-03-04, when the demasking provider changed. Null on any window a caller can ask for.
   * @deprecated Deprecated: no value has arrived since 2024-03-04, when the demasking provider changed. Null on any window a caller can ask for.
   */
  linkedinIndustryCategory?: Maybe<Scalars['String']['output']>
  mainCategorySlug?: Maybe<Scalars['String']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sector?: Maybe<Scalars['String']['output']>
  subjectType?: Maybe<Scalars['String']['output']>
  toolTitle?: Maybe<Scalars['String']['output']>
  visits?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsItemResult = {
  __typename?: 'ManageInsightsItemResult'
  /** Why this item was not answered; set when `status` is not 200. */
  error?: Maybe<Scalars['String']['output']>
  metric: Scalars['String']['output']
  /** The metric's payload when `status` is 200. */
  response?: Maybe<ManageInsightsEnvelope>
  /** HTTP status the single metric endpoint would have answered. */
  status: Scalars['Int']['output']
  surface: Scalars['String']['output']
}

/**
 * The measures `competition/benchmark-tiers` compares a tool on.
 *
 * Seven. The first six the warehouse carries for every tool — 813,353 rows each,
 * a complete cross product, all current to the latest month. So the set is
 * closed in fact and not only by intent, which is what makes an enum safe here
 * and leaves `measure_name` no reason to stay the last free-text filter on a
 * surface about to be published as a typed schema.
 *
 * `review_velocity` is the number of reviews first published in that calendar
 * month whose `purpose` names the row's category — not a trailing window, and the
 * running month counts to date. It equals `competition/review-growth.new_reviews`
 * for the same tool, category and month, and is 0 where that metric has no row.
 *
 * `review_count` is the cumulative number of reviews by `purpose` through that
 * month. It equals `competition/review-growth.cumulative_reviews`, not the
 * product-page total.
 */
export enum ManageInsightsMeasureName {
  AvgTimeOnSiteSeconds = 'AVG_TIME_ON_SITE_SECONDS',
  Clickouts = 'CLICKOUTS',
  Pageviews = 'PAGEVIEWS',
  ReviewCount = 'REVIEW_COUNT',
  ReviewVelocity = 'REVIEW_VELOCITY',
  Sessions = 'SESSIONS',
  StarRating = 'STAR_RATING',
}

export type ManageInsightsNewEntrantsFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  entityId: Scalars['String']['input']
  entryVia?: InputMaybe<Scalars['String']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsNewEntrantsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  toolSlug?: InputMaybe<Scalars['String']['input']>
}

export enum ManageInsightsNewEntrantsOrderBy {
  EntryMonth = 'ENTRY_MONTH',
}

export type ManageInsightsNewEntrantsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsNewEntrantsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsNewEntrantsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsNewEntrantsRow = {
  __typename?: 'ManageInsightsNewEntrantsRow'
  enteredViaReview?: Maybe<Scalars['Boolean']['output']>
  enteredViaTraffic?: Maybe<Scalars['Boolean']['output']>
  entryMonth?: Maybe<Scalars['ISO8601Date']['output']>
  entryVia?: Maybe<Scalars['String']['output']>
  firstReviewMonth?: Maybe<Scalars['ISO8601Date']['output']>
  firstTrafficMonth?: Maybe<Scalars['ISO8601Date']['output']>
  toolSlug?: Maybe<Scalars['String']['output']>
}

export type ManageInsightsNpsBySegmentFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsNpsBySegmentOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  segmentType?: InputMaybe<ManageInsightsSegmentType>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsNpsBySegmentOrderBy {
  Nps = 'NPS',
  Period = 'PERIOD',
  ReviewCount = 'REVIEW_COUNT',
}

export type ManageInsightsNpsBySegmentResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsNpsBySegmentResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsNpsBySegmentRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsNpsBySegmentRow = {
  __typename?: 'ManageInsightsNpsBySegmentRow'
  /** The tool's main category, a reviews-api `categories.id`. */
  categoryId?: Maybe<Scalars['String']['output']>
  categoryNps?: Maybe<Scalars['Float']['output']>
  categoryReviewCount?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 0 to 6. */
  detractors?: Maybe<Scalars['Int']['output']>
  /** Null when `review_count` is below 20. The warehouse has a value on every row. */
  nps?: Maybe<Scalars['Float']['output']>
  /** Recommendation score 7 or 8. */
  passives?: Maybe<Scalars['Int']['output']>
  /** Cumulative: every review published on or before this month's last day. */
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** Recommendation score 9 or 10. */
  promoters?: Maybe<Scalars['Int']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** `all` is the tool-wide row over every scored review; read it instead of adding the segment rows up. */
  segmentType?: Maybe<Scalars['String']['output']>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: Maybe<Scalars['String']['output']>
}

/** Sort direction for an ordered query. */
export enum ManageInsightsOrderDir {
  Asc = 'ASC',
  Desc = 'DESC',
}

/**
 * Which window the answer covers.
 *
 * `latest_only` is the default read: no window was asked for, so the newest
 * period that entity has is what came back — `as_of` on the envelope says which
 * one that was. `start`/`end` echo an explicit window (or the one a `period`
 * preset resolved to), inclusive.
 */
export type ManageInsightsPeriod = {
  __typename?: 'ManageInsightsPeriod'
  end?: Maybe<Scalars['ISO8601Date']['output']>
  grain: ManageInsightsGrain
  latestOnly: Scalars['Boolean']['output']
  start?: Maybe<Scalars['ISO8601Date']['output']>
}

/** Server-resolved time windows. Whole calendar periods only — the data is monthly. */
export enum ManageInsightsPeriodPreset {
  Last_3Months = 'LAST_3_MONTHS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_12Months = 'LAST_12_MONTHS',
  Latest = 'LATEST',
  Ytd = 'YTD',
}

export type ManageInsightsPositionMentionsFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsPositionMentionsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsPositionMentionsOrderBy {
  AvgPosition = 'AVG_POSITION',
  Citations = 'CITATIONS',
  Mentions = 'MENTIONS',
  Period = 'PERIOD',
}

export type ManageInsightsPositionMentionsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsPositionMentionsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsPositionMentionsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsPositionMentionsRow = {
  __typename?: 'ManageInsightsPositionMentionsRow'
  avgPosition?: Maybe<Scalars['Float']['output']>
  avgPositionDeltaPrev?: Maybe<Scalars['Float']['output']>
  citations?: Maybe<Scalars['Int']['output']>
  citationsDeltaPrev?: Maybe<Scalars['Int']['output']>
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  mentions?: Maybe<Scalars['Int']['output']>
  mentionsDeltaPrev?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsPricingLandscapeFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  entityId: Scalars['String']['input']
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsPricingLandscapeOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  priceDecile?: InputMaybe<Scalars['Int']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsPricingLandscapeOrderBy {
  AvgEntryPriceMonthlyEur = 'AVG_ENTRY_PRICE_MONTHLY_EUR',
  Period = 'PERIOD',
  PriceDecile = 'PRICE_DECILE',
}

export type ManageInsightsPricingLandscapeResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsPricingLandscapeResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsPricingLandscapeRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsPricingLandscapeRow = {
  __typename?: 'ManageInsightsPricingLandscapeRow'
  avgEntryPriceMonthlyEur?: Maybe<Scalars['Float']['output']>
  maxEntryPriceMonthlyEur?: Maybe<Scalars['Float']['output']>
  minEntryPriceMonthlyEur?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  priceDecile?: Maybe<Scalars['Int']['output']>
  productsInCategoryCount?: Maybe<Scalars['Int']['output']>
  productsInDecile?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsPricingPositionFilters = {
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export type ManageInsightsPricingPositionResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsPricingPositionResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsPricingPositionRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsPricingPositionRow = {
  __typename?: 'ManageInsightsPricingPositionRow'
  /** Cheapest paid plan, monthly EUR. Null when no EUR plan has a billing period. */
  entryPriceMonthlyEur?: Maybe<Scalars['Float']['output']>
  /** Entry-price percent rank in the primary category, 0-1. Null when the tool has no monthly entry price or the category has fewer than 5 priced products. */
  percentileInCategory?: Maybe<Scalars['Float']['output']>
  /** Human-readable pricing position; null when unranked. */
  positionLabel?: Maybe<Scalars['String']['output']>
  /** `least(cast(floor(percentile_in_category * 10) as int64) + 1, 10)`, 1-10 — the deciles `market/pricing-landscape` buckets the category into. Null when `percentile_in_category` is. */
  priceDecile?: Maybe<Scalars['Int']['output']>
  primaryCategorySlug?: Maybe<Scalars['String']['output']>
  /** Priced products in the primary category. */
  productsInCategoryCount?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsRankTrackingFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  isAlertWorthy?: InputMaybe<Scalars['Boolean']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsRankTrackingOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsRankTrackingOrderBy {
  MainCategoryOmrRank = 'MAIN_CATEGORY_OMR_RANK',
  MainRankDeltaPrev = 'MAIN_RANK_DELTA_PREV',
  Period = 'PERIOD',
  RankInCategory = 'RANK_IN_CATEGORY',
}

export type ManageInsightsRankTrackingResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRankTrackingResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRankTrackingRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRankTrackingRow = {
  __typename?: 'ManageInsightsRankTrackingRow'
  categorySlug?: Maybe<Scalars['String']['output']>
  enteredTop3?: Maybe<Scalars['Boolean']['output']>
  isAlertWorthy?: Maybe<Scalars['Boolean']['output']>
  leftTop3?: Maybe<Scalars['Boolean']['output']>
  mainCategoryOmrRank?: Maybe<Scalars['Int']['output']>
  /** This week's rank minus the previous week's, so a positive value means the tool moved down: the opposite sign of `rank_change` on `ranking/*`. Null when the previous week has no row; the rank archive starts on 2026-09-11, so the week of 2026-09-07 has none. */
  mainRankDeltaPrev?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  rankInCategory?: Maybe<Scalars['Int']['output']>
  /** This week's rank minus the previous week's, so a positive value means the tool moved down: the opposite sign of `rank_change` on `ranking/*`. Null when the previous week has no row; the rank archive starts on 2026-09-11, so the week of 2026-09-07 has none. */
  websiteRankDeltaPrev?: Maybe<Scalars['Int']['output']>
}

/**
 * One tool's placement across every ranked year.
 *
 * Id in the body, like every other insights metric — not a path param.
 *
 * Extends `StrictFilters` rather than `BaseModel`: this was the one metric with
 * neither `limit` nor `order_by`, which made it the only body a client could not
 * treat like the other 37. Ranked years accrue, so "however many there are, newest
 * first" stops being the only useful answer.
 */
export type ManageInsightsRankingByYearFilters = {
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sort column; defaults to newest year first. */
  orderBy?: InputMaybe<ManageInsightsRankingByYearOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

/**
 * Whitelisted sort columns for one tool's ranked years.
 *
 * `tool_title` is absent on purpose, unlike the leaderboard's whitelist: this
 * read is one tool, so sorting by its own name orders nothing. `numeric_year` is
 * the default and the axis the answer is actually about.
 */
export enum ManageInsightsRankingByYearOrderBy {
  NumericYear = 'NUMERIC_YEAR',
  Rank = 'RANK',
  Rating = 'RATING',
  ReviewCount = 'REVIEW_COUNT',
}

/**
 * Every ranked year for one tool, newest first.
 *
 * Rows are `RankingRowBase` — no `position`. This is one tool's timeline, not a
 * slice of a sorted list, so a row index would read as a placement and be wrong
 * (every tool's newest year would come back as `position: 1`). The placement is
 * `rank`.
 *
 * Deliberately not a `PagedResponse`: the answer is bounded by the number of
 * ranked years (six today), so there is nothing to page.
 */
export type ManageInsightsRankingByYearResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRankingByYearResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRankingRowBase>
  surface: Scalars['String']['output']
  toolSlug: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

/**
 * Filter/sort/page knobs for one leaderboard request.
 *
 * `year` defaults to the most recent ranked year *for the selected filters*
 * rather than being required. With `category` set that is the most recent year
 * THAT CATEGORY was ranked, which is not always the current year — 273 of 662
 * categories peak before 2026. The resolved year is echoed back on the response
 * (`RankingResponse.year`) so a caller never has to guess which one it got.
 */
export type ManageInsightsRankingFilters = {
  /** Restrict to one category slug. */
  category?: InputMaybe<Scalars['String']['input']>
  /** Page size (max rows returned). */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Rows to skip before the page. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sort column (leaderboard UI's four). */
  orderBy?: InputMaybe<ManageInsightsRankingOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Also return this tool's row and its position when it falls outside the requested page. Subject to the other filters, including `q`. */
  pinTool?: InputMaybe<Scalars['String']['input']>
  /** Free-text search over the tool name (case-insensitive substring). Narrows `total_count`, and also constrains `pin_tool`. */
  q?: InputMaybe<Scalars['String']['input']>
  /** Ranking year. Omit for the most recent. */
  year?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Whitelisted sort columns for the tool-ranking leaderboard.
 *
 * The four sortable columns of the leaderboard UI. `rank` is the default; the
 * other three re-sort the same rows without changing any tool's `rank` value,
 * which stays the placement the warehouse assigned.
 */
export enum ManageInsightsRankingOrderBy {
  Rank = 'RANK',
  Rating = 'RATING',
  ReviewCount = 'REVIEW_COUNT',
  ToolTitle = 'TOOL_TITLE',
}

/**
 * One page of the leaderboard, plus the pinned row when one was requested.
 *
 * `pinned` may also appear inside `rows` when the pinned tool happens to fall on
 * the requested page — callers should render it in its pinned slot and not
 * assume it is absent from the page.
 */
export type ManageInsightsRankingResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRankingResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  /**
   * Whether another page exists after this one.
   *
   * `computed_field`, not a bare `@property`: a plain property is invisible to
   * `model_dump()`, so the envelope would advertise it in the docstring while
   * every HTTP client had to recompute it.
   */
  hasMore: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  metric: Scalars['String']['output']
  offset: Scalars['Int']['output']
  pinned?: Maybe<ManageInsightsRankingRow>
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRankingRow>
  surface: Scalars['String']['output']
  totalCount: Scalars['Int']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
  /** The ranking year actually served — the resolved one when `year` was omitted. */
  year?: Maybe<Scalars['Int']['output']>
}

/** A leaderboard row, which has a position within the sorted list. */
export type ManageInsightsRankingRow = {
  __typename?: 'ManageInsightsRankingRow'
  category?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  /** 1-5. */
  customerSupportScore?: Maybe<Scalars['Float']['output']>
  /** 1-5. */
  easeOfSetup?: Maybe<Scalars['Float']['output']>
  /** 1-5. */
  easeOfUse?: Maybe<Scalars['Float']['output']>
  isSuite?: Maybe<Scalars['Boolean']['output']>
  /** Ranking year. */
  numericYear: Scalars['Int']['output']
  /** Bayesian-smoothed score, 1-5. */
  omrScore?: Maybe<Scalars['Float']['output']>
  /** 1-based position under the CURRENT sort/search — not the same as `rank`. */
  position: Scalars['Int']['output']
  /** Placement within the year, 1 = best. */
  rank?: Maybe<Scalars['Int']['output']>
  /** Positive = moved up vs last year. */
  rankChange?: Maybe<Scalars['Int']['output']>
  /** Year star rating, 1-5. */
  rating?: Maybe<Scalars['Float']['output']>
  /** All-time star rating, 1-5. */
  ratingAvg?: Maybe<Scalars['Float']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** Tool slug. */
  tool: Scalars['String']['output']
  /** Tool display name. */
  toolTitle?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

/**
 * One tool's placement for one year.
 *
 * Rating fields carry NO `ge`/`le` bounds on purpose. They are 1-5 by
 * construction in the warehouse, but this is a read-only response model: a
 * single out-of-range value would raise `ValidationError` and 500 the WHOLE
 * page rather than the one row. The dbt contract enforces column names, not
 * value ranges, so bounding here buys nothing and risks an availability cliff.
 */
export type ManageInsightsRankingRowBase = {
  __typename?: 'ManageInsightsRankingRowBase'
  category?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  /** 1-5. */
  customerSupportScore?: Maybe<Scalars['Float']['output']>
  /** 1-5. */
  easeOfSetup?: Maybe<Scalars['Float']['output']>
  /** 1-5. */
  easeOfUse?: Maybe<Scalars['Float']['output']>
  isSuite?: Maybe<Scalars['Boolean']['output']>
  /** Ranking year. */
  numericYear: Scalars['Int']['output']
  /** Bayesian-smoothed score, 1-5. */
  omrScore?: Maybe<Scalars['Float']['output']>
  /** Placement within the year, 1 = best. */
  rank?: Maybe<Scalars['Int']['output']>
  /** Positive = moved up vs last year. */
  rankChange?: Maybe<Scalars['Int']['output']>
  /** Year star rating, 1-5. */
  rating?: Maybe<Scalars['Float']['output']>
  /** All-time star rating, 1-5. */
  ratingAvg?: Maybe<Scalars['Float']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** Tool slug. */
  tool: Scalars['String']['output']
  /** Tool display name. */
  toolTitle?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ManageInsightsRatingHistoryFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsRatingHistoryOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsRatingHistoryOrderBy {
  Period = 'PERIOD',
}

export type ManageInsightsRatingHistoryResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRatingHistoryResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRatingHistoryRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRatingHistoryRow = {
  __typename?: 'ManageInsightsRatingHistoryRow'
  /** 0–5, the latest snapshot of the week; the product page's Ø rating at that time */
  averageRecommendationRating?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** vs. the previous week; NULL on the first week */
  ratingDeltaPrev?: Maybe<Scalars['Float']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsRatingMonthlyFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsRatingMonthlyOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsRatingMonthlyOrderBy {
  Period = 'PERIOD',
}

export type ManageInsightsRatingMonthlyResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRatingMonthlyResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRatingMonthlyRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRatingMonthlyRow = {
  __typename?: 'ManageInsightsRatingMonthlyRow'
  /** Mean of the month, 1–7; NULL when no review of the month rated it. */
  avgCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  /** Mean of the month, 1–7; NULL when no review of the month rated it. */
  avgEaseOfSetup?: Maybe<Scalars['Float']['output']>
  /** Mean of the month, 1–7; NULL when no review of the month rated it. */
  avgEaseOfUse?: Maybe<Scalars['Float']['output']>
  /** Mean of the month, 1–7; NULL when no review of the month rated it. */
  avgRequirementsScore?: Maybe<Scalars['Float']['output']>
  /** Mean of the month over the main category's reviews, 1–7; NULL when the category had no rated review that month. */
  categoryAvgCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  /** Mean of the month over the main category's reviews, 1–7; NULL when the category had no rated review that month. */
  categoryAvgEaseOfSetup?: Maybe<Scalars['Float']['output']>
  /** Mean of the month over the main category's reviews, 1–7; NULL when the category had no rated review that month. */
  categoryAvgEaseOfUse?: Maybe<Scalars['Float']['output']>
  /** Mean of the month over the main category's reviews, 1–7; NULL when the category had no rated review that month. */
  categoryAvgRequirementsScore?: Maybe<Scalars['Float']['output']>
  /** Main-category reviews of the month that rated it; the weight of the mean. */
  categoryCustomerSupportScoreCount?: Maybe<Scalars['Int']['output']>
  /** Main-category reviews of the month that rated it; the weight of the mean. */
  categoryEaseOfSetupCount?: Maybe<Scalars['Int']['output']>
  /** Main-category reviews of the month that rated it; the weight of the mean. */
  categoryEaseOfUseCount?: Maybe<Scalars['Int']['output']>
  /** Main-category reviews of the month that rated it; the weight of the mean. */
  categoryRequirementsScoreCount?: Maybe<Scalars['Int']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  /** Reviews of the month that rated it; the weight of the mean. */
  customerSupportScoreCount?: Maybe<Scalars['Int']['output']>
  /** Reviews of the month that rated it; the weight of the mean. */
  easeOfSetupCount?: Maybe<Scalars['Int']['output']>
  /** Reviews of the month that rated it; the weight of the mean. */
  easeOfUseCount?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** Reviews of the month that rated it; the weight of the mean. */
  requirementsScoreCount?: Maybe<Scalars['Int']['output']>
  /** Published reviews first published in the month; 0 in a quiet month. */
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 0–2. */
  reviewsBad?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 9–10. */
  reviewsBest?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 7–8. */
  reviewsBetter?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 5–6. */
  reviewsGood?: Maybe<Scalars['Int']['output']>
  /** Recommendation score 3–4. */
  reviewsWorse?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsRatingSummaryFilters = {
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export type ManageInsightsRatingSummaryResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRatingSummaryResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRatingSummaryRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRatingSummaryRow = {
  __typename?: 'ManageInsightsRatingSummaryRow'
  /** 0–5, null without reviews; the product page's Ø rating */
  averageRecommendationRating?: Maybe<Scalars['Float']['output']>
  avgCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  avgEaseOfSetup?: Maybe<Scalars['Float']['output']>
  avgEaseOfUse?: Maybe<Scalars['Float']['output']>
  avgRequirementsScore?: Maybe<Scalars['Float']['output']>
  categoryAvgCustomerSupportScore?: Maybe<Scalars['Float']['output']>
  categoryAvgEaseOfSetup?: Maybe<Scalars['Float']['output']>
  categoryAvgEaseOfUse?: Maybe<Scalars['Float']['output']>
  categoryAvgRequirementsScore?: Maybe<Scalars['Float']['output']>
  isSuite?: Maybe<Scalars['Boolean']['output']>
  mainCategorySlug?: Maybe<Scalars['String']['output']>
  /** Published reviews with a vendor reply, an outdated reply included. NULL for suites. */
  repliedReviewCount?: Maybe<Scalars['Int']['output']>
  /** replied_review_count / review_count. NULL for suites and for tools without reviews. */
  replyRate?: Maybe<Scalars['Float']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  reviewsBad?: Maybe<Scalars['Int']['output']>
  reviewsBest?: Maybe<Scalars['Int']['output']>
  reviewsBetter?: Maybe<Scalars['Int']['output']>
  reviewsGood?: Maybe<Scalars['Int']['output']>
  reviewsWorse?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsRecentFilters = {
  companySlug?: InputMaybe<Scalars['String']['input']>
  demaskingSourceType?: InputMaybe<ManageInsightsDemaskingSourceType>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  mainCategorySlug?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<ManageInsightsRecentOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  sector?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subjectType?: InputMaybe<ManageInsightsSubjectType>
}

export enum ManageInsightsRecentOrderBy {
  IntentScore = 'INTENT_SCORE',
  Period = 'PERIOD',
  Visits = 'VISITS',
}

export type ManageInsightsRecentResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRecentResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsIntentAggregateRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRecurringVisitorShareFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsRecurringVisitorShareOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsRecurringVisitorShareOrderBy {
  Period = 'PERIOD',
  RecurringShare = 'RECURRING_SHARE',
}

export type ManageInsightsRecurringVisitorShareResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsRecurringVisitorShareResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsRecurringVisitorShareRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsRecurringVisitorShareRow = {
  __typename?: 'ManageInsightsRecurringVisitorShareRow'
  /** Serverside page visits, one row per visit — an exact count. */
  pageVisits?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** Serverside visits by a returning company, a subset of `page_visits`. */
  recurringPageVisits?: Maybe<Scalars['Int']['output']>
  recurringShare?: Maybe<Scalars['Float']['output']>
}

/** One metric to read, named by the key. Exactly one key may be given: the key is the metric, so a request cannot name one metric and filter for another. Identifiers the product owns (`entityId` on a tool or brand metric) are absent on purpose — they come from `productSlug`. */
export type ManageInsightsRequest = {
  /** `ai-visibility/citation-engines` */
  aiVisibilityCitationEngines?: InputMaybe<ManageInsightsCitationEnginesFilters>
  /** `ai-visibility/citation-sources` */
  aiVisibilityCitationSources?: InputMaybe<ManageInsightsCitationSourcesFilters>
  /** `ai-visibility/competitor-detail` */
  aiVisibilityCompetitorDetail?: InputMaybe<ManageInsightsCompetitorDetailFilters>
  /** `ai-visibility/detection-trends` */
  aiVisibilityDetectionTrends?: InputMaybe<ManageInsightsDetectionTrendsFilters>
  /** `ai-visibility/position-mentions` */
  aiVisibilityPositionMentions?: InputMaybe<ManageInsightsPositionMentionsFilters>
  /** `ai-visibility/sentiment-by-engine` */
  aiVisibilitySentimentByEngine?: InputMaybe<ManageInsightsSentimentByEngineFilters>
  /** `ai-visibility/sentiment-keywords` */
  aiVisibilitySentimentKeywords?: InputMaybe<ManageInsightsSentimentKeywordsFilters>
  /** `ai-visibility/share-of-model` */
  aiVisibilityShareOfModel?: InputMaybe<ManageInsightsShareOfModelFilters>
  /** `ai-visibility/vs-competitors` */
  aiVisibilityVsCompetitors?: InputMaybe<ManageInsightsVsCompetitorsFilters>
  /** `buyer/nps-by-segment` */
  buyerNpsBySegment?: InputMaybe<ManageInsightsNpsBySegmentFilters>
  /** `buyer/recurring-visitor-share` */
  buyerRecurringVisitorShare?: InputMaybe<ManageInsightsRecurringVisitorShareFilters>
  /** `buyer/reviewer-mix` */
  buyerReviewerMix?: InputMaybe<ManageInsightsReviewerMixFilters>
  /** `buyer/segmented-ratings` */
  buyerSegmentedRatings?: InputMaybe<ManageInsightsSegmentedRatingsFilters>
  /** `buyer/visiting-companies` */
  buyerVisitingCompanies?: InputMaybe<ManageInsightsVisitingCompaniesFilters>
  /** `buyer/visitor-reviewer-gap` */
  buyerVisitorReviewerGap?: InputMaybe<ManageInsightsVisitorReviewerGapFilters>
  /** `competition/attribute-index` */
  competitionAttributeIndex?: InputMaybe<ManageInsightsAttributeIndexFilters>
  /** `competition/attribute-index-composite` */
  competitionAttributeIndexComposite?: InputMaybe<ManageInsightsAttributeIndexCompositeFilters>
  /** `competition/attribute-sentiment` */
  competitionAttributeSentiment?: InputMaybe<ManageInsightsAttributeSentimentFilters>
  /** `competition/badge-progress` */
  competitionBadgeProgress?: InputMaybe<ManageInsightsBadgeProgressFilters>
  /** `competition/benchmark-tiers` */
  competitionBenchmarkTiers?: InputMaybe<ManageInsightsBenchmarkTiersFilters>
  /** `competition/clickout-rate` */
  competitionClickoutRate?: InputMaybe<ManageInsightsClickoutRateFilters>
  /** `competition/covisitation` */
  competitionCovisitation?: InputMaybe<ManageInsightsCovisitationFilters>
  /** `competition/pricing-position` */
  competitionPricingPosition?: InputMaybe<ManageInsightsPricingPositionFilters>
  /** `competition/rank-tracking` */
  competitionRankTracking?: InputMaybe<ManageInsightsRankTrackingFilters>
  /** `competition/review-freshness` */
  competitionReviewFreshness?: InputMaybe<ManageInsightsReviewFreshnessFilters>
  /** `competition/review-growth` */
  competitionReviewGrowth?: InputMaybe<ManageInsightsToolReviewGrowthFilters>
  /** `competition/share-of-voice` */
  competitionShareOfVoice?: InputMaybe<ManageInsightsShareOfVoiceFilters>
  /** `competition/share-of-voice-competitors` */
  competitionShareOfVoiceCompetitors?: InputMaybe<ManageInsightsShareOfVoiceCompetitorsFilters>
  /** `competition/share-of-voice-window` */
  competitionShareOfVoiceWindow?: InputMaybe<ManageInsightsShareOfVoiceWindowFilters>
  /** `intent/by-month` */
  intentByMonth?: InputMaybe<ManageInsightsByMonthFilters>
  /** `intent/by-week` */
  intentByWeek?: InputMaybe<ManageInsightsByWeekFilters>
  /** `intent/detail` */
  intentDetail?: InputMaybe<ManageInsightsDetailFilters>
  /** `intent/recent` */
  intentRecent?: InputMaybe<ManageInsightsRecentFilters>
  /** `market/category-demand` */
  marketCategoryDemand?: InputMaybe<ManageInsightsCategoryDemandFilters>
  /** `market/category-funnel` */
  marketCategoryFunnel?: InputMaybe<ManageInsightsCategoryFunnelFilters>
  /** `market/new-entrants` */
  marketNewEntrants?: InputMaybe<ManageInsightsNewEntrantsFilters>
  /** `market/pricing-landscape` */
  marketPricingLandscape?: InputMaybe<ManageInsightsPricingLandscapeFilters>
  /** `market/review-growth` */
  marketReviewGrowth?: InputMaybe<ManageInsightsReviewGrowthFilters>
  /** `ranking/by-year` */
  rankingByYear?: InputMaybe<ManageInsightsRankingByYearFilters>
  /** `ranking/tools` */
  rankingTools?: InputMaybe<ManageInsightsRankingFilters>
  /** `vendor/campaign-performance` */
  vendorCampaignPerformance?: InputMaybe<ManageInsightsCampaignPerformanceFilters>
  /** `vendor/rating-history` */
  vendorRatingHistory?: InputMaybe<ManageInsightsRatingHistoryFilters>
  /** `vendor/rating-monthly` */
  vendorRatingMonthly?: InputMaybe<ManageInsightsRatingMonthlyFilters>
  /** `vendor/rating-summary` */
  vendorRatingSummary?: InputMaybe<ManageInsightsRatingSummaryFilters>
  /** `vendor/tool-switches` */
  vendorToolSwitches?: InputMaybe<ManageInsightsToolSwitchesFilters>
  /** `vendor/tool-switches-lifetime` */
  vendorToolSwitchesLifetime?: InputMaybe<ManageInsightsToolSwitchesLifetimeFilters>
}

export type ManageInsightsReviewFreshnessFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsReviewFreshnessOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsReviewFreshnessOrderBy {
  OutdatedReviewShare = 'OUTDATED_REVIEW_SHARE',
  OutdatedShareCategoryPercentile = 'OUTDATED_SHARE_CATEGORY_PERCENTILE',
  Period = 'PERIOD',
}

export type ManageInsightsReviewFreshnessResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsReviewFreshnessResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsReviewFreshnessRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsReviewFreshnessRow = {
  __typename?: 'ManageInsightsReviewFreshnessRow'
  categoryMedianOutdatedShare?: Maybe<Scalars['Float']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  newReviewCountByPurpose?: Maybe<Scalars['Int']['output']>
  outdatedReviewCountByPurpose?: Maybe<Scalars['Int']['output']>
  outdatedReviewShare?: Maybe<Scalars['Float']['output']>
  outdatedShareCategoryPercentile?: Maybe<Scalars['Float']['output']>
  /** The share as of this month's last day (today for the running month) minus the share as of the previous month's last day, both recomputed from publish dates, so it exists even when the previous month has no row. */
  outdatedShareDeltaPrev?: Maybe<Scalars['Float']['output']>
  outdatedShareVsMedianDiff?: Maybe<Scalars['Float']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** A review counts for the categories its `purpose` names, never for their parent categories — unlike reviews-api's `review_count_by_purpose`. */
  reviewCountByPurpose?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsReviewGrowthFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  entityId: Scalars['String']['input']
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsReviewGrowthOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsReviewGrowthOrderBy {
  CumulativeReviews = 'CUMULATIVE_REVIEWS',
  NewReviews = 'NEW_REVIEWS',
  Period = 'PERIOD',
}

export type ManageInsightsReviewGrowthResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsReviewGrowthResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsReviewGrowthRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsReviewGrowthRow = {
  __typename?: 'ManageInsightsReviewGrowthRow'
  /** Running total of `new_reviews`, so a review counts only for the categories its `purpose` names and reviews with no first-publish date are not counted. */
  cumulativeReviews?: Maybe<Scalars['Int']['output']>
  /** Reviews first published this month. A review counts for the categories its `purpose` names, never for their parent categories, so a category leaves out reviews that name only its sub-categories. Reviews with no first-publish date, nearly all published before 2023, are not counted. */
  newReviews?: Maybe<Scalars['Int']['output']>
  newReviewsDeltaPrev?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsReviewerMixFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsReviewerMixOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  segmentType?: InputMaybe<ManageInsightsSegmentType>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsReviewerMixOrderBy {
  OverUnderIndex = 'OVER_UNDER_INDEX',
  Period = 'PERIOD',
  ReviewCount = 'REVIEW_COUNT',
}

export type ManageInsightsReviewerMixResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsReviewerMixResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsReviewerMixRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsReviewerMixRow = {
  __typename?: 'ManageInsightsReviewerMixRow'
  categoryDimReviews?: Maybe<Scalars['Int']['output']>
  /** The tool's main category, a reviews-api `categories.id`. */
  categoryId?: Maybe<Scalars['String']['output']>
  categoryReviewCount?: Maybe<Scalars['Int']['output']>
  categoryShare?: Maybe<Scalars['Float']['output']>
  overUnderIndex?: Maybe<Scalars['Float']['output']>
  /** Cumulative: every review published on or before this month's last day. */
  period?: Maybe<Scalars['ISO8601Date']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  segmentType?: Maybe<Scalars['String']['output']>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: Maybe<Scalars['String']['output']>
  toolDimReviews?: Maybe<Scalars['Int']['output']>
  toolShare?: Maybe<Scalars['Float']['output']>
}

/**
 * Which reviewer dimension a segmented row splits by.
 *
 * SQL literals in the three `agg_reviews__consumer_*` dbt models, so the set cannot
 * grow without a dbt change. `seniority` is the warehouse spelling of what the
 * reviews endpoints call `job_function` (`_DIMENSION_TO_SEGMENT_TYPE` in
 * `src/models/filters.py`). `all` is every scored review of the tool; only
 * `nps-by-segment` has such rows.
 */
export enum ManageInsightsSegmentType {
  All = 'ALL',
  CompanySize = 'COMPANY_SIZE',
  Industry = 'INDUSTRY',
  Seniority = 'SENIORITY',
}

export type ManageInsightsSegmentedRatingsFilters = {
  /** A reviews-api `categories.id`. */
  categoryId?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsSegmentedRatingsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  segmentType?: InputMaybe<ManageInsightsSegmentType>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsSegmentedRatingsOrderBy {
  SegAvgNpsScore = 'SEG_AVG_NPS_SCORE',
  SegAvgStarRating = 'SEG_AVG_STAR_RATING',
  SegRank = 'SEG_RANK',
}

export type ManageInsightsSegmentedRatingsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsSegmentedRatingsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsSegmentedRatingsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsSegmentedRatingsRow = {
  __typename?: 'ManageInsightsSegmentedRatingsRow'
  /** A reviews-api `categories.id`, one row per published category of the tool. The tool's own figures repeat on each; `seg_rank` and `qualifying_tools_in_cell` are that category's. A suite tool or an unpublished tool has no rows, although `reviewer-mix` answers for it. */
  categoryId?: Maybe<Scalars['String']['output']>
  /** Cumulative: every review published on or before this month's last day. */
  period?: Maybe<Scalars['ISO8601Date']['output']>
  qualifyingToolsInCell?: Maybe<Scalars['Int']['output']>
  /** The mean recommendation score, 0 to 10, not an NPS. `nps-by-segment.nps` is the NPS (-100 to 100). */
  segAvgNpsScore?: Maybe<Scalars['Float']['output']>
  segAvgStarRating?: Maybe<Scalars['Float']['output']>
  segRank?: Maybe<Scalars['Int']['output']>
  /** Only reviews eligible for the site ranking, so it can be lower than `reviewer-mix.review_count`. */
  segReviewCount?: Maybe<Scalars['Int']['output']>
  segmentType?: Maybe<Scalars['String']['output']>
  /** `company_size`: a reviews-api `company_size` code — `0_10`, `11_50`, `51_100`, `101_200`, `201_500`, `501_1000`, `1001_2000`, `2001_5000`, `5001_10000`, `10001_`. `seniority`: `C-Level`, `Leadership` or `Manager`, by the first keyword match in the free-text job title, checked in that order in dbt; every other non-empty title is `Individual Contributor`. `industry`: the reviews-api industry name (`Marketing and Advertising`), not its slug. */
  segmentValue?: Maybe<Scalars['String']['output']>
}

export type ManageInsightsSentimentByEngineFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsSentimentByEngineOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsSentimentByEngineOrderBy {
  Period = 'PERIOD',
  SentimentScore = 'SENTIMENT_SCORE',
}

export type ManageInsightsSentimentByEngineResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsSentimentByEngineResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsSentimentByEngineRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsSentimentByEngineRow = {
  __typename?: 'ManageInsightsSentimentByEngineRow'
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sentimentScore?: Maybe<Scalars['Float']['output']>
  sentimentScore0100?: Maybe<Scalars['Float']['output']>
  sentimentScoreDeltaPrev?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsSentimentKeywordsFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  isOwnBrand?: InputMaybe<Scalars['Boolean']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsSentimentKeywordsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  sentimentClass?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsSentimentKeywordsOrderBy {
  KeywordCount = 'KEYWORD_COUNT',
  KeywordRank = 'KEYWORD_RANK',
  Period = 'PERIOD',
}

export type ManageInsightsSentimentKeywordsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsSentimentKeywordsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsSentimentKeywordsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsSentimentKeywordsRow = {
  __typename?: 'ManageInsightsSentimentKeywordsRow'
  distinctKeywordsInWeek?: Maybe<Scalars['Int']['output']>
  isOwnBrand?: Maybe<Scalars['Boolean']['output']>
  keyword?: Maybe<Scalars['String']['output']>
  keywordCount?: Maybe<Scalars['Int']['output']>
  keywordCountDeltaPrev?: Maybe<Scalars['Int']['output']>
  keywordRank?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sentimentClass?: Maybe<Scalars['String']['output']>
  subjectName?: Maybe<Scalars['String']['output']>
}

export type ManageInsightsShareOfModelFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsShareOfModelOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsShareOfModelOrderBy {
  Period = 'PERIOD',
  ShareOfModel = 'SHARE_OF_MODEL',
}

export type ManageInsightsShareOfModelResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsShareOfModelResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsShareOfModelRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsShareOfModelRow = {
  __typename?: 'ManageInsightsShareOfModelRow'
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  mentions?: Maybe<Scalars['Int']['output']>
  peerMentionsTotal?: Maybe<Scalars['Int']['output']>
  peersInSet?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  shareIsReliable?: Maybe<Scalars['Boolean']['output']>
  shareOfModel?: Maybe<Scalars['Float']['output']>
  shareOfModelDeltaPrev?: Maybe<Scalars['Float']['output']>
}

export type ManageInsightsShareOfVoiceCompetitorRow = {
  __typename?: 'ManageInsightsShareOfVoiceCompetitorRow'
  /** Pageviews of the whole category over the window — a modelled estimate. "Other" = this minus the tool's and the shown competitors' pageviews. */
  categoryPageviews?: Maybe<Scalars['Float']['output']>
  /** tool_pageviews / category_pageviews; null when the category has none. */
  sovPageviews?: Maybe<Scalars['Float']['output']>
  /** The tool's real place in the category, so the ranks can have gaps. */
  sovPageviewsRank?: Maybe<Scalars['Int']['output']>
  /** GA4 clientside pageviews on the tool's profile in this category over the window, adjusted for opt-in — a modelled estimate, not a count. 0 without traffic. */
  toolPageviews?: Maybe<Scalars['Float']['output']>
  toolSlug?: Maybe<Scalars['String']['output']>
  windowEndDate?: Maybe<Scalars['ISO8601Date']['output']>
  windowStartDate?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsShareOfVoiceCompetitorsFilters = {
  /** A category the tool belongs to. */
  categorySlug: Scalars['String']['input']
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsShareOfVoiceCompetitorsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** The timeframe window key, not a `PeriodPreset`: dbt owns its bounds, and `latest` is the running window, not the newest snapshot. */
  period: ManageInsightsWindowKey
}

export enum ManageInsightsShareOfVoiceCompetitorsOrderBy {
  SovPageviewsRank = 'SOV_PAGEVIEWS_RANK',
}

export type ManageInsightsShareOfVoiceCompetitorsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsShareOfVoiceCompetitorsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsShareOfVoiceCompetitorRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsShareOfVoiceFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsShareOfVoiceOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsShareOfVoiceOrderBy {
  Period = 'PERIOD',
  SovPageviews = 'SOV_PAGEVIEWS',
  SovSessions = 'SOV_SESSIONS',
  SovSessionsCategoryPercentile = 'SOV_SESSIONS_CATEGORY_PERCENTILE',
}

export type ManageInsightsShareOfVoiceResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsShareOfVoiceResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsShareOfVoiceRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsShareOfVoiceRow = {
  __typename?: 'ManageInsightsShareOfVoiceRow'
  categoryPageviews?: Maybe<Scalars['Float']['output']>
  categorySessions?: Maybe<Scalars['Int']['output']>
  categorySlug?: Maybe<Scalars['String']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sovPageviews?: Maybe<Scalars['Float']['output']>
  sovPageviewsDeltaPrev?: Maybe<Scalars['Float']['output']>
  sovSessions?: Maybe<Scalars['Float']['output']>
  sovSessionsCategoryPercentile?: Maybe<Scalars['Float']['output']>
  sovSessionsDeltaPrev?: Maybe<Scalars['Float']['output']>
  toolPageviews?: Maybe<Scalars['Float']['output']>
  toolSessions?: Maybe<Scalars['Int']['output']>
  toolsWithTraffic?: Maybe<Scalars['Int']['output']>
}

/** One tool, one category, one window. No date knobs: the window is the key. */
export type ManageInsightsShareOfVoiceWindowFilters = {
  /** A category the tool belongs to. */
  categorySlug: Scalars['String']['input']
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** The timeframe window key, not a `PeriodPreset`: dbt owns its bounds, and `latest` is the running window, not the newest snapshot. */
  period: ManageInsightsWindowKey
}

export type ManageInsightsShareOfVoiceWindowResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsShareOfVoiceWindowResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsShareOfVoiceWindowRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsShareOfVoiceWindowRow = {
  __typename?: 'ManageInsightsShareOfVoiceWindowRow'
  /** Pageviews of the whole category over the window — a modelled estimate. "Other" = this minus the tool's and the shown competitors' pageviews. */
  categoryPageviews?: Maybe<Scalars['Float']['output']>
  previousCategoryPageviews?: Maybe<Scalars['Float']['output']>
  /** True when the category has data for every month of the previous window. */
  previousComplete?: Maybe<Scalars['Boolean']['output']>
  previousEndDate?: Maybe<Scalars['ISO8601Date']['output']>
  /** The share in the previous window; null when the category had none. */
  previousSovPageviews?: Maybe<Scalars['Float']['output']>
  previousStartDate?: Maybe<Scalars['ISO8601Date']['output']>
  previousToolPageviews?: Maybe<Scalars['Float']['output']>
  /** tool_pageviews / category_pageviews; null when the category has none. */
  sovPageviews?: Maybe<Scalars['Float']['output']>
  /** Place in the category by pageviews, 1 = most; ties broken by tool slug. */
  sovPageviewsRank?: Maybe<Scalars['Int']['output']>
  /** GA4 clientside pageviews on the tool's profile in this category over the window, adjusted for opt-in — a modelled estimate, not a count. 0 without traffic. */
  toolPageviews?: Maybe<Scalars['Float']['output']>
  windowEndDate?: Maybe<Scalars['ISO8601Date']['output']>
  windowStartDate?: Maybe<Scalars['ISO8601Date']['output']>
}

/**
 * Page types a visit can land on. Shared: `intent/*` and `market/category-funnel`.
 *
 * Source of truth: the dbt seed `seeds/reviews/auxiliary/reviews_subject_types.csv`.
 * The funnel table holds only the six funnel types, so the other nine answer 200
 * with no rows there.
 */
export enum ManageInsightsSubjectType {
  Agency = 'AGENCY',
  AgencyCategory = 'AGENCY_CATEGORY',
  Alternative = 'ALTERNATIVE',
  Article = 'ARTICLE',
  Author = 'AUTHOR',
  Category = 'CATEGORY',
  Compare = 'COMPARE',
  Festival = 'FESTIVAL',
  FestivalExhibitor = 'FESTIVAL_EXHIBITOR',
  FestivalSpeaker = 'FESTIVAL_SPEAKER',
  Growthhub = 'GROWTHHUB',
  Product = 'PRODUCT',
  ProductAllReviews = 'PRODUCT_ALL_REVIEWS',
  ProductPricing = 'PRODUCT_PRICING',
  Public = 'PUBLIC',
}

export type ManageInsightsToolReviewGrowthFilters = {
  categorySlug?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsReviewGrowthOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type ManageInsightsToolReviewGrowthResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsToolReviewGrowthResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsToolReviewGrowthRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsToolReviewGrowthRow = {
  __typename?: 'ManageInsightsToolReviewGrowthRow'
  categorySlug?: Maybe<Scalars['String']['output']>
  /** Running total of `new_reviews`. It omits reviews with no first-publish date, so at the newest month it can be lower than `review-freshness.review_count_by_purpose`. The `review-freshness` counts are point-in-time snapshots, not historical. */
  cumulativeReviews?: Maybe<Scalars['Int']['output']>
  /** Reviews first published this month. A review counts for the categories its `purpose` names, never for their parent categories — unlike reviews-api's `review_count_by_purpose`. Reviews with no first-publish date, nearly all published before 2023, are not counted. */
  newReviews?: Maybe<Scalars['Int']['output']>
  newReviewsDeltaPrev?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
}

export type ManageInsightsToolSwitchesFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsToolSwitchesOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type ManageInsightsToolSwitchesLifetimeFilters = {
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsToolSwitchesLifetimeOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
}

export enum ManageInsightsToolSwitchesLifetimeOrderBy {
  Reviewers = 'REVIEWERS',
}

export type ManageInsightsToolSwitchesLifetimeResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsToolSwitchesLifetimeResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsToolSwitchesLifetimeRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsToolSwitchesLifetimeRow = {
  __typename?: 'ManageInsightsToolSwitchesLifetimeRow'
  /** Reviews whose reviewer answered the switch question; repeated on every row. */
  answeredCount?: Maybe<Scalars['Int']['output']>
  /** Distinct reviewers who named this source; 0 on the `none` row. */
  reviewers?: Maybe<Scalars['Int']['output']>
  /** The current slug of a tool listed on OMR Reviews, `other` for tools named as free text, or `none` on the row that only carries the totals. */
  source?: Maybe<Scalars['String']['output']>
  /** Reviews whose reviewer switched and named at least one source; repeated on every row. */
  sourcedCount?: Maybe<Scalars['Int']['output']>
  /** Reviews whose reviewer answered yes; repeated on every row. */
  switchedCount?: Maybe<Scalars['Int']['output']>
  /** Display name of the listed tool; NULL for `other`, `none` and tools deleted from the platform. */
  switchedFromToolTitle?: Maybe<Scalars['String']['output']>
  /** `product` for a listed tool, `other` for free text, `none` for the totals-only row. */
  switchedFromType?: Maybe<Scalars['String']['output']>
}

export enum ManageInsightsToolSwitchesOrderBy {
  Period = 'PERIOD',
  Reviewers = 'REVIEWERS',
}

export type ManageInsightsToolSwitchesResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsToolSwitchesResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsToolSwitchesRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsToolSwitchesRow = {
  __typename?: 'ManageInsightsToolSwitchesRow'
  /** Reviews whose reviewer answered the switch question; repeated on every row. */
  answeredCount?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  /** Distinct reviewers who named this source; 0 on the `none` row. */
  reviewers?: Maybe<Scalars['Int']['output']>
  /** The current slug of a tool listed on OMR Reviews, `other` for tools named as free text, or `none` on the row that only carries the totals. */
  source?: Maybe<Scalars['String']['output']>
  /** Reviews whose reviewer switched and named at least one source; repeated on every row. */
  sourcedCount?: Maybe<Scalars['Int']['output']>
  /** Reviews whose reviewer answered yes; repeated on every row. */
  switchedCount?: Maybe<Scalars['Int']['output']>
  /** Display name of the listed tool; NULL for `other`, `none` and tools deleted from the platform. */
  switchedFromToolTitle?: Maybe<Scalars['String']['output']>
  /** `product` for a listed tool, `other` for free text, `none` for the totals-only row. */
  switchedFromType?: Maybe<Scalars['String']['output']>
}

/**
 * Keyed by `tool_slug`, not `tool_id` like this surface's older siblings.
 *
 * `tool_slug` is what the Insights Hub sends and what the entitlement gate
 * resolves an owner from; SUPPLY-574 brings the other four in line.
 */
export type ManageInsightsVisitingCompaniesFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsVisitingCompaniesOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsVisitingCompaniesOrderBy {
  DemaskedCompanies = 'DEMASKED_COMPANIES',
  Period = 'PERIOD',
  Visits = 'VISITS',
}

export type ManageInsightsVisitingCompaniesResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsVisitingCompaniesResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsVisitingCompaniesRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

/**
 * Counts only — no `company_name` / `company_slug` / `linkedin_url` here.
 *
 * The identity behind these counts is `intent/detail`, which is gated
 * separately. `vendor_self_visits` is the vendor reading its own listing:
 * excluded from `demasked_companies` and `visits`, and reported apart so the
 * numbers reconcile against `intent/by-month`, which excludes nothing.
 */
export type ManageInsightsVisitingCompaniesRow = {
  __typename?: 'ManageInsightsVisitingCompaniesRow'
  demaskedCompanies?: Maybe<Scalars['Int']['output']>
  demaskedCompaniesDeltaPrev?: Maybe<Scalars['Int']['output']>
  demaskedCompaniesDeltaYoy?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  vendorSelfVisits?: Maybe<Scalars['Int']['output']>
  visits?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsVisitorReviewerGapFilters = {
  canonicalBand?: InputMaybe<Scalars['String']['input']>
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ManageInsightsVisitorReviewerGapOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsVisitorReviewerGapOrderBy {
  CanonicalSort = 'CANONICAL_SORT',
  Period = 'PERIOD',
  ReviewerShare = 'REVIEWER_SHARE',
}

export type ManageInsightsVisitorReviewerGapResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsVisitorReviewerGapResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsVisitorReviewerGapRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

/**
 * Reviewer-side size distribution only — the visitor half is unavailable.
 *
 * `visiting_companies`, `total_visiting_companies`, `visitor_share` and
 * `gap_pp` were removed: the demasking provider switched to sales_viewer on
 * 2024-03-07 and has supplied no company size since, so all four could only
 * ever answer 0 or NULL.
 */
export type ManageInsightsVisitorReviewerGapRow = {
  __typename?: 'ManageInsightsVisitorReviewerGapRow'
  canonicalBand?: Maybe<Scalars['String']['output']>
  canonicalSort?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  reviewerShare?: Maybe<Scalars['Float']['output']>
  sizedReviews?: Maybe<Scalars['Int']['output']>
  totalSizedReviews?: Maybe<Scalars['Int']['output']>
}

export type ManageInsightsVsCompetitorsFilters = {
  /** Inclusive range end (optional). */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  engineId?: InputMaybe<ManageInsightsEngineId>
  /** Max rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>
  lineType?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<ManageInsightsVsCompetitorsOrderBy>
  /** Sort direction. */
  orderDir?: InputMaybe<ManageInsightsOrderDir>
  /** Server-resolved window, mutually exclusive with start_date/end_date: last_N_months = the N complete months before the current one; ytd = 1 Jan to today; latest = the default latest-snapshot read. */
  period?: InputMaybe<ManageInsightsPeriodPreset>
  /** Inclusive range start (optional). */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export enum ManageInsightsVsCompetitorsOrderBy {
  DetectionRate = 'DETECTION_RATE',
  Period = 'PERIOD',
  VisibilityScore = 'VISIBILITY_SCORE',
}

export type ManageInsightsVsCompetitorsResponse = ManageInsightsEnvelope & {
  __typename?: 'ManageInsightsVsCompetitorsResponse'
  /** Newest period in `rows`. Null without rows, on lifetime metrics, `ranking/*` and the `share-of-voice-*` window metrics. */
  asOf?: Maybe<Scalars['ISO8601Date']['output']>
  emptyReason?: Maybe<ManageInsightsEmptyReason>
  entity?: Maybe<ManageInsightsEntityRef>
  metric: Scalars['String']['output']
  rowCount: Scalars['Int']['output']
  rows: Array<ManageInsightsVsCompetitorsRow>
  surface: Scalars['String']['output']
  /** True when `limit` cut the answer short, so `rows` is a prefix rather than the whole result. Do not derive a total from a truncated answer — raise `limit` or narrow the filters. */
  truncated: Scalars['Boolean']['output']
  window?: Maybe<ManageInsightsPeriod>
}

export type ManageInsightsVsCompetitorsRow = {
  __typename?: 'ManageInsightsVsCompetitorsRow'
  avgPosition?: Maybe<Scalars['Float']['output']>
  citations?: Maybe<Scalars['Int']['output']>
  competitorMatchedBrandId?: Maybe<Scalars['String']['output']>
  competitorName?: Maybe<Scalars['String']['output']>
  detectionRate?: Maybe<Scalars['Float']['output']>
  detectionRateDeltaPrev?: Maybe<Scalars['Float']['output']>
  engineId?: Maybe<Scalars['String']['output']>
  engineIsActive?: Maybe<Scalars['Boolean']['output']>
  lineType?: Maybe<Scalars['String']['output']>
  mentions?: Maybe<Scalars['Int']['output']>
  period?: Maybe<Scalars['ISO8601Date']['output']>
  sentimentScore?: Maybe<Scalars['Float']['output']>
  top3Rate?: Maybe<Scalars['Float']['output']>
  visibilityPercentileVsCompetitors?: Maybe<Scalars['Float']['output']>
  visibilityScore?: Maybe<Scalars['Float']['output']>
  visibilityScoreDeltaPrev?: Maybe<Scalars['Float']['output']>
}

/**
 * An Insights Hub timeframe window, read by its key rather than by dates.
 *
 * Source of truth: `int_reviews__insights_windows` in `data-orchestration`, the
 * `window_key` column of `agg_reviews__competition_share_of_voice_window`. dbt owns
 * the bounds, so this API never computes them: `latest` is the running month up to
 * today, `last_N_months` the N complete months before it, `ytd` 1 January up to today.
 * Same tokens as `PeriodPreset`, but `latest` here is a window, not "the newest
 * snapshot".
 */
export enum ManageInsightsWindowKey {
  Last_3Months = 'LAST_3_MONTHS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_12Months = 'LAST_12_MONTHS',
  Latest = 'LATEST',
  Ytd = 'YTD',
}

export type ManageLead = {
  __typename?: 'ManageLead'
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  contactRequests: Array<ContactRequest>
  history: Array<ManageLeadHistoryEntry>
  id: Scalars['ID']['output']
  latestRequestAt: Scalars['ISO8601DateTime']['output']
  notes: Array<LeadNote>
  senderCompany?: Maybe<Scalars['String']['output']>
  senderCompanyPosition?: Maybe<Scalars['String']['output']>
  senderEmail: Scalars['String']['output']
  senderName: Scalars['String']['output']
  senderPhone?: Maybe<Scalars['String']['output']>
  status: LeadStatusEnum
  statusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ManageLeadHistoryEntry = {
  __typename?: 'ManageLeadHistoryEntry'
  actorName?: Maybe<Scalars['String']['output']>
  body?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  fromStatus?: Maybe<LeadStatusEnum>
  id: Scalars['ID']['output']
  kind: LeadHistoryKindEnum
  toStatus?: Maybe<LeadStatusEnum>
}

export type ManageLeadsExportCsv = {
  __typename?: 'ManageLeadsExportCsv'
  /** Errors that occurred during CSV export */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** URL to the exported CSV file */
  fileUrl?: Maybe<Scalars['String']['output']>
}

export enum ManageLeadsFieldKeyEnum {
  ContactRequestType = 'contact_request_type',
  CreatedAt = 'created_at',
  Message = 'message',
  SenderCompany = 'sender_company',
  SenderCompanyPosition = 'sender_company_position',
  SenderEmail = 'sender_email',
  SenderName = 'sender_name',
  SenderPhone = 'sender_phone',
}

export type ManageLeadsFieldsEntry = {
  /** Field to export */
  key: ManageLeadsFieldKeyEnum
  /** Column header to print for this field */
  name: Scalars['String']['input']
}

export type ManageLeadsSearchFilters = {
  /** When false (default) returns active leads only; true returns archived leads only. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  contactRequestType?: InputMaybe<Array<ContactRequestContactRequestTypeEnum>>
  /** Lead pipeline statuses to include. Empty or omitted returns every status. */
  status?: InputMaybe<Array<LeadStatusEnum>>
}

export type ManageLocationAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
}

export type ManageMutation = {
  __typename?: 'ManageMutation'
  addLeadNote?: Maybe<AddLeadNotePayload>
  archiveLead?: Maybe<ArchiveLeadPayload>
  changePricingPlans?: Maybe<Array<PricingPlan>>
  /** Create a new vendor campaign */
  createCampaign: Campaign
  /** Create a new campaign personalization */
  createCampaignPersonalization: Personalization
  /** Mutation to create product document. Returns all product documents after changes. */
  createDocument: Array<Asset>
  createScreenshot?: Maybe<CreatePayload>
  createSurveyResponseReminder?: Maybe<ManageSurveyResponseReminder>
  createSurveyResponseReminders?: Maybe<ManageCreateSurveyResponseRemindersResult>
  createUniversalReviewReminder?: Maybe<UniversalReviewReminder>
  /** Delete a vendor campaign */
  deleteCampaign: Campaign
  /** Delete a campaign personalization */
  deleteCampaignPersonalization: Personalization
  /** Mutation to delete product documents. Returns all product documents after changes. */
  deleteDocuments: Array<Asset>
  deleteReviewReply?: Maybe<ReviewReply>
  deleteScreenshots?: Maybe<DeletePayload>
  setLeadStatus?: Maybe<SetLeadStatusPayload>
  unarchiveLead?: Maybe<UnarchiveLeadPayload>
  updateAgency?: Maybe<UpdateAgencyPayload>
  updateBudget?: Maybe<Budget>
  /** Update an existing vendor campaign */
  updateCampaign: Campaign
  /** Update an existing campaign personalization */
  updateCampaignPersonalization: Personalization
  /** Mutation to update product documents. Returns all product documents after changes. */
  updateDocuments: Array<Asset>
  updateProduct?: Maybe<UpdateProductPayload>
  updateScreenshots?: Maybe<UpdatePayload>
  upsertReviewReply?: Maybe<ReviewReply>
}

export type ManageMutationAddLeadNoteArgs = {
  input: AddLeadNoteInput
}

export type ManageMutationArchiveLeadArgs = {
  input: ArchiveLeadInput
}

export type ManageMutationChangePricingPlansArgs = {
  input: ChangePricingPlansInput
}

export type ManageMutationCreateCampaignArgs = {
  input: ManageIncentivizationCampaignCreateInput
}

export type ManageMutationCreateCampaignPersonalizationArgs = {
  input: ManageIncentivizationCampaignPersonalizationCreateInput
}

export type ManageMutationCreateDocumentArgs = {
  input: ManageDocumentsCreateInput
}

export type ManageMutationCreateScreenshotArgs = {
  input: CreateInput
}

export type ManageMutationCreateSurveyResponseReminderArgs = {
  input: CreateSurveyResponseReminderInput
}

export type ManageMutationCreateSurveyResponseRemindersArgs = {
  input: CreateSurveyResponseRemindersInput
}

export type ManageMutationCreateUniversalReviewReminderArgs = {
  input: CreateUniversalReviewReminderInput
}

export type ManageMutationDeleteCampaignArgs = {
  input: ManageIncentivizationCampaignDeleteInput
}

export type ManageMutationDeleteCampaignPersonalizationArgs = {
  input: ManageIncentivizationCampaignPersonalizationDeleteInput
}

export type ManageMutationDeleteDocumentsArgs = {
  input: ManageDocumentDeleteInput
}

export type ManageMutationDeleteReviewReplyArgs = {
  input: ManageReviewRepliesDeleteInput
}

export type ManageMutationDeleteScreenshotsArgs = {
  input: DeleteInput
}

export type ManageMutationSetLeadStatusArgs = {
  input: SetLeadStatusInput
}

export type ManageMutationUnarchiveLeadArgs = {
  input: UnarchiveLeadInput
}

export type ManageMutationUpdateAgencyArgs = {
  input: UpdateAgencyInput
}

export type ManageMutationUpdateBudgetArgs = {
  input: UpdateBudgetInput
}

export type ManageMutationUpdateCampaignArgs = {
  input: ManageIncentivizationCampaignUpdateInput
}

export type ManageMutationUpdateCampaignPersonalizationArgs = {
  input: ManageIncentivizationCampaignPersonalizationUpdateInput
}

export type ManageMutationUpdateDocumentsArgs = {
  input: ManageDocumentUpdateInput
}

export type ManageMutationUpdateProductArgs = {
  input: UpdateProductInput
}

export type ManageMutationUpdateScreenshotsArgs = {
  input: UpdateInput
}

export type ManageMutationUpsertReviewReplyArgs = {
  input: ManageReviewRepliesUpsertInput
}

export type ManageOptions = {
  __typename?: 'ManageOptions'
  cities: Array<City>
  currencies: Array<Currency>
  industries: Array<Industry>
  pricingSubscriptionModes: Array<PricingSubscriptionMode>
  pricingTextOptions: Array<PricingTextOption>
}

export type ManageQuery = {
  __typename?: 'ManageQuery'
  agencies?: Maybe<Array<Agency>>
  agency: Agency
  contactRequests: Array<ContactRequest>
  currentUser: ManageUser
  incentivizationCampaign: Campaign
  incentivizationCampaigns: Array<Campaign>
  insights: ManageInsightsBatchResult
  lead: ManageLead
  leads?: Maybe<ManageExploreLeads>
  leadsExportCsv: ManageLeadsExportCsv
  options: ManageOptions
  product: Product
  products?: Maybe<Array<Product>>
  surveyResponse: ManageSurveyResponse
  surveyResponses?: Maybe<ManageExploreSurveyResponses>
  surveyResponsesExportCsv: ManageSurveyResponsesExportCsv
  topProductsRanking: ManageTopProductsRanking
  topRatedBadgeProgress: ManageTopRatedBadgeProgress
  universalReview: UniversalReview
  universalReviews: ManageExploreUniversalReviews
  universalReviewsExportCsv: ManageUniversalReviewsExportCsv
}

export type ManageQueryAgencyArgs = {
  id: Scalars['ID']['input']
}

export type ManageQueryContactRequestsArgs = {
  contactRequestType?: InputMaybe<ContactRequestContactRequestTypeEnum>
  contactableId?: InputMaybe<Scalars['GlobalId']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type ManageQueryIncentivizationCampaignArgs = {
  campaign: Scalars['ID']['input']
}

export type ManageQueryIncentivizationCampaignsArgs = {
  product: Scalars['ID']['input']
  statuses?: InputMaybe<Array<IncentivizationCampaignStatusEnum>>
}

export type ManageQueryInsightsArgs = {
  productSlug: Scalars['ID']['input']
  requests: Array<ManageInsightsRequest>
}

export type ManageQueryLeadArgs = {
  id: Scalars['ID']['input']
}

export type ManageQueryLeadsArgs = {
  contactableId?: InputMaybe<Scalars['GlobalId']['input']>
  filters?: InputMaybe<ManageLeadsSearchFilters>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<LeadsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
}

export type ManageQueryLeadsExportCsvArgs = {
  contactableId: Scalars['GlobalId']['input']
  fields: Array<ManageLeadsFieldsEntry>
  filters?: InputMaybe<ManageLeadsSearchFilters>
  sortBy?: InputMaybe<LeadsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
}

export type ManageQueryProductArgs = {
  id: Scalars['ID']['input']
}

export type ManageQuerySurveyResponseArgs = {
  id: Scalars['ID']['input']
}

export type ManageQuerySurveyResponsesArgs = {
  filters?: InputMaybe<ManageSurveyResponsesSearchFilters>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  productSlug?: InputMaybe<Scalars['ID']['input']>
  sortBy?: InputMaybe<SurveyResponsesSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  view?: InputMaybe<SurveyResponsesViewEnum>
}

export type ManageQuerySurveyResponsesExportCsvArgs = {
  fields: Array<ManageSurveyResponsesFieldsEntry>
  filters?: InputMaybe<ManageSurveyResponsesSearchFilters>
  productSlug: Scalars['String']['input']
  view?: InputMaybe<SurveyResponsesViewEnum>
}

export type ManageQueryTopProductsRankingArgs = {
  orderBy?: InputMaybe<ManageTopProductsRankingOrderBy>
  orderDir?: InputMaybe<SortDirectionEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  productSlug: Scalars['ID']['input']
  search?: InputMaybe<Scalars['String']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type ManageQueryTopRatedBadgeProgressArgs = {
  id: Scalars['ID']['input']
}

export type ManageQueryUniversalReviewArgs = {
  id: Scalars['ID']['input']
}

export type ManageQueryUniversalReviewsArgs = {
  filters?: InputMaybe<ManageUniversalReviewsSearchFilters>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<ManageUniversalReviewsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  subjectId: Scalars['GlobalId']['input']
}

export type ManageQueryUniversalReviewsExportCsvArgs = {
  fields: Array<ManageUniversalReviewsFieldsEntry>
  filters?: InputMaybe<ManageUniversalReviewsSearchFilters>
  sortBy?: InputMaybe<ManageUniversalReviewsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  subjectId: Scalars['GlobalId']['input']
}

/** Autogenerated input type of ManageReviewRepliesDelete */
export type ManageReviewRepliesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** ID or slug of the review reply */
  id: Scalars['ID']['input']
}

/** Autogenerated input type of ManageReviewRepliesUpsert */
export type ManageReviewRepliesUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  notifyReviewer?: InputMaybe<Scalars['Boolean']['input']>
  personalized?: InputMaybe<Scalars['Boolean']['input']>
  /** Reply message */
  reply: Scalars['String']['input']
  /** ID or slug of a product review */
  reviewId?: InputMaybe<Scalars['ID']['input']>
  /** Public ID of a universal (e.g. agency) review */
  universalReviewId?: InputMaybe<Scalars['ID']['input']>
}

export type ManageSurveyResponse = {
  __typename?: 'ManageSurveyResponse'
  aasmState: Scalars['String']['output']
  anonymous: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  firstPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  /** @deprecated No longer used */
  incentive?: Maybe<Incentive>
  kind: SurveyResponseKinds
  manualReminderDisabled: Scalars['Boolean']['output']
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  purposes: Array<Category>
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedReason?: Maybe<SurveyResponseRejectedReasons>
  /** @deprecated Use manualReminderDisabled instead */
  reminderDisabled: Scalars['Boolean']['output']
  reminders: Array<ManageSurveyResponseReminder>
  requestedCampaign?: Maybe<Campaign>
  requestedCampaignPersonalizations?: Maybe<Array<Personalization>>
  review?: Maybe<Review>
  reviewerCompany?: Maybe<Scalars['String']['output']>
  reviewerCompanySize?: Maybe<Scalars['String']['output']>
  reviewerFirstName?: Maybe<Scalars['String']['output']>
  reviewerIndustry?: Maybe<Scalars['String']['output']>
  reviewerPosition?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  video?: Maybe<Asset>
}

export type ManageSurveyResponseReminder = {
  __typename?: 'ManageSurveyResponseReminder'
  automatic: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  reminderType: SurveyResponseReminderReminderTypes
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: SurveyResponseReminderStatuses
  surveyResponse: ManageSurveyResponse
  userId?: Maybe<Scalars['Int']['output']>
}

export type ManageSurveyResponsesExportCsv = {
  __typename?: 'ManageSurveyResponsesExportCsv'
  /** Errors that occurred during CSV export */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** URL to the exported CSV file */
  fileUrl?: Maybe<Scalars['String']['output']>
}

/** Entry for selecting fields for CSV export */
export type ManageSurveyResponsesFieldsEntry = {
  /** The key/identifier of the field */
  key: FieldKeyEnum
  /** The display name of the field */
  name: Scalars['String']['input']
}

export type ManageSurveyResponsesSearchFilters = {
  campaignId?: InputMaybe<Array<Scalars['ID']['input']>>
  purposes?: InputMaybe<Array<Scalars['String']['input']>>
  rating?: InputMaybe<Array<RecommendationRatingKeyEnum>>
  reminderStatus?: InputMaybe<Array<SurveyResponsesReminderStatusEnum>>
  replyStatus?: InputMaybe<Array<SurveyResponsesReplyStatusEnum>>
  state?: InputMaybe<Array<SurveyResponsesStateEnum>>
  term?: InputMaybe<Scalars['String']['input']>
  updatedSince?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  updatedTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ManageTopProductsRanking = {
  __typename?: 'ManageTopProductsRanking'
  pagination: Pagination
  /**
   * The requested tool's own row, also when it is outside this page. Null when the tool has
   * no placement this year. It also appears in `results` when it falls on this page.
   *
   */
  pinned?: Maybe<ManageTopProductsRankingRow>
  results: Array<ManageTopProductsRankingRow>
  /** The ranking year served: the requested one, or the latest when none was requested. */
  year?: Maybe<Scalars['Int']['output']>
}

export enum ManageTopProductsRankingOrderBy {
  /** Placement within the year, 1 = best. The default. */
  Rank = 'RANK',
  /** The year's star rating (1-5). */
  Rating = 'RATING',
  /** Number of published reviews counting towards the year. */
  ReviewCount = 'REVIEW_COUNT',
  /** Tool name. */
  ToolTitle = 'TOOL_TITLE',
}

export type ManageTopProductsRankingRow = {
  __typename?: 'ManageTopProductsRankingRow'
  /** The ranking year these numbers belong to. */
  numericYear: Scalars['Int']['output']
  /** 1-based index under the current sort and search. */
  position?: Maybe<Scalars['Int']['output']>
  /** Placement within the year, 1 = best. */
  rank?: Maybe<Scalars['Int']['output']>
  /** The year's star rating (1-5). */
  rating?: Maybe<Scalars['Float']['output']>
  /** Published reviews counting towards this year. */
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** Tool slug. */
  tool: Scalars['String']['output']
  /** Tool name. */
  toolTitle?: Maybe<Scalars['String']['output']>
}

export type ManageTopRatedBadgeProgress = {
  __typename?: 'ManageTopRatedBadgeProgress'
  /** Average recommendation score (0–10); null when there are no reviews. */
  averageScore?: Maybe<Scalars['Float']['output']>
  /** Whether the product currently meets the Top Rated badge rule. */
  eligible: Scalars['Boolean']['output']
  /** Average recommendation score a product must reach to earn the badge. */
  minimumAverageScore: Scalars['Int']['output']
  /** Reviews a product must reach to earn the badge. */
  minimumReviewCount: Scalars['Int']['output']
  /** Published reviews in the current quarter so far. */
  reviewCount: Scalars['Int']['output']
}

export type ManageUniversalReviewsExportCsv = {
  __typename?: 'ManageUniversalReviewsExportCsv'
  /** Errors that occurred during CSV export */
  errors?: Maybe<Array<Scalars['String']['output']>>
  /** URL to the exported CSV file */
  fileUrl?: Maybe<Scalars['String']['output']>
}

export enum ManageUniversalReviewsFieldKeyEnum {
  Anonymous = 'anonymous',
  CompanyField = 'company_field',
  CompanyName = 'company_name',
  CompanyPosition = 'company_position',
  CompanySize = 'company_size',
  CreatedAt = 'created_at',
  CurrentStatus = 'current_status',
  FirstPublishedAt = 'first_published_at',
  Kind = 'kind',
  Link = 'link',
  Locale = 'locale',
  Negative = 'negative',
  NpsScore = 'nps_score',
  Positive = 'positive',
  Problems = 'problems',
  PublishedAt = 'published_at',
  Reminder = 'reminder',
  Reply = 'reply',
  ReplyText = 'reply_text',
  ReviewerName = 'reviewer_name',
  Statement = 'statement',
  Title = 'title',
  UpdatedAt = 'updated_at',
}

export type ManageUniversalReviewsFieldsEntry = {
  /** Field to export */
  key: ManageUniversalReviewsFieldKeyEnum
  /** Column header to print for this field */
  name: Scalars['String']['input']
}

export type ManageUniversalReviewsSearchFilters = {
  rating?: InputMaybe<Array<RecommendationRatingKeyEnum>>
  status?: InputMaybe<Array<UniversalReviewStates>>
  updatedSince?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  updatedTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum ManageUniversalReviewsSortByEnum {
  Company = 'company',
  Date = 'date',
  Rating = 'rating',
  Reviewer = 'reviewer',
}

export type ManageUser = AnalyticsIdentityFields & {
  __typename?: 'ManageUser'
  accountType: AccountTypeEnum
  company?: Maybe<AnalyticsIdentityCompany>
  hasAccessToOmrViewer: Scalars['Boolean']['output']
}

export type MarketSegmentFacet = {
  __typename?: 'MarketSegmentFacet'
  docCount: Scalars['Int']['output']
  key: MarketSegmentKeyEnum
}

export enum MarketSegmentKeyEnum {
  Enterprise = 'enterprise',
  Medium = 'medium',
  Small = 'small',
}

export type MechanicalFailure = {
  __typename?: 'MechanicalFailure'
  code: Scalars['String']['output']
  minLength: Scalars['Int']['output']
  section: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  claimProfile?: Maybe<ClaimProfilePayload>
  createContactRequest?: Maybe<ContactRequest>
  createContentHubVote?: Maybe<CreateContentHubVotePayload>
  createDocumentDownloadRequest?: Maybe<CreateDocumentDownloadRequestPayload>
  createMarketingConsent?: Maybe<CreateMarketingConsentPayload>
  createPageVisitSession?: Maybe<CreatePageVisitSessionPayload>
  createReviewSummaryVote?: Maybe<Vote>
  incentivizeWithCampaign?: Maybe<IncentivizeWithCampaignPayload>
  manage: ManageMutation
  operations: OperationsMutation
  processSurveyResponse?: Maybe<ProcessSurveyResponsePayload>
  processUniversalReview?: Maybe<ProcessUniversalReviewPayload>
  recordPpcShadowDiff?: Maybe<RecordPpcShadowDiffPayload>
  respondToTakedown?: Maybe<RespondToTakedownPayload>
  unwatchSubject?: Maybe<UnwatchSubjectPayload>
  updateCompanySlug?: Maybe<UpdateCompanySlugPayload>
  watchSubject?: Maybe<WatchSubjectPayload>
}

export type MutationClaimProfileArgs = {
  input: ClaimProfileInput
}

export type MutationCreateContactRequestArgs = {
  input: CreateContactRequestInput
}

export type MutationCreateContentHubVoteArgs = {
  input: CreateContentHubVoteInput
}

export type MutationCreateDocumentDownloadRequestArgs = {
  input: CreateDocumentDownloadRequestInput
}

export type MutationCreateMarketingConsentArgs = {
  input: CreateMarketingConsentInput
}

export type MutationCreatePageVisitSessionArgs = {
  input: CreatePageVisitSessionInput
}

export type MutationCreateReviewSummaryVoteArgs = {
  input: CreateReviewSummaryVoteInput
}

export type MutationIncentivizeWithCampaignArgs = {
  input: IncentivizeWithCampaignInput
}

export type MutationProcessSurveyResponseArgs = {
  input: ProcessSurveyResponseInput
}

export type MutationProcessUniversalReviewArgs = {
  input: ProcessUniversalReviewInput
}

export type MutationRecordPpcShadowDiffArgs = {
  input: RecordPpcShadowDiffInput
}

export type MutationRespondToTakedownArgs = {
  input: RespondToTakedownInput
}

export type MutationUnwatchSubjectArgs = {
  input: UnwatchSubjectInput
}

export type MutationUpdateCompanySlugArgs = {
  input: UpdateCompanySlugInput
}

export type MutationWatchSubjectArgs = {
  input: WatchSubjectInput
}

export enum MutationsWatchItemBaseMutationSubjects {
  Product = 'Product',
}

export type MyReview = {
  __typename?: 'MyReview'
  /** How many required questions carry a value, out of the total. Values are not validated, so a full count does not mean the review can be submitted. */
  completion?: Maybe<MyReviewCompletion>
  incentiveStatus: MyReviewIncentiveStatus
  lastDraftedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** 1-based rank among the subject's published reviews, newest first. */
  publishedPosition?: Maybe<Scalars['Int']['output']>
  /** Reviewer's 0-10 recommendation score. Null unless the review is live. */
  recommendationScore?: Maybe<Scalars['Int']['output']>
  /** True only when the rejection is one the reviewer can fix themselves. */
  resubmittable: Scalars['Boolean']['output']
  /** Same id the public reviews queries return for this review. */
  reviewId?: Maybe<Scalars['ID']['output']>
  reviewReply?: Maybe<ReviewReply>
  state: MyReviewState
  subject: ReviewSubject
  title?: Maybe<Scalars['String']['output']>
}

export type MyReviewCompletion = {
  __typename?: 'MyReviewCompletion'
  answered: Scalars['Int']['output']
  required: Scalars['Int']['output']
}

export enum MyReviewIncentiveStatus {
  Lost = 'lost',
  None = 'none',
  Requested = 'requested',
  Won = 'won',
}

export enum MyReviewState {
  Depublished = 'depublished',
  Drafted = 'drafted',
  InRevision = 'in_revision',
  Proposed = 'proposed',
  Published = 'published',
  Rejected = 'rejected',
  Stale = 'stale',
}

export type OperationsMutation = {
  __typename?: 'OperationsMutation'
  updateProductDescription?: Maybe<UpdateProductDescriptionPayload>
}

export type OperationsMutationUpdateProductDescriptionArgs = {
  input: UpdateProductDescriptionInput
}

export type PageVisit = {
  agencyCategorySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  agencySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  productSlugs?: InputMaybe<Array<Scalars['String']['input']>>
  subjectId?: InputMaybe<Scalars['String']['input']>
  subjectType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type PageVisitCompany = {
  address?: InputMaybe<Scalars['String']['input']>
  alexaRank?: InputMaybe<Scalars['Int']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companyWebsite?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  employees?: InputMaybe<Scalars['String']['input']>
  financialReport?: InputMaybe<Scalars['String']['input']>
  financialReportCurrency?: InputMaybe<Scalars['String']['input']>
  foundedYear?: InputMaybe<Scalars['Int']['input']>
  linkedinIndustryCategory?: InputMaybe<Scalars['String']['input']>
  linkedinIndustryCode?: InputMaybe<Scalars['String']['input']>
  linkedinUrl?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  sector?: InputMaybe<Scalars['String']['input']>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type PaginatedReviews = {
  __typename?: 'PaginatedReviews'
  aspects: Array<AspectFacet>
  frequentWords: Array<Scalars['String']['output']>
  /** Review count per market segment. Ignores the market segment filter, respects all others. */
  marketSegments: Array<MarketSegmentFacet>
  pagination: Pagination
  purposes: Array<ReviewsPurposeType>
  reviews: Array<Review>
  statistics: ReviewStatistics
}

export type PaginatedUniversalReviews = {
  __typename?: 'PaginatedUniversalReviews'
  aspects: Array<AspectFacet>
  pagination: Pagination
  reviews: Array<UniversalReview>
}

export type Pagination = {
  __typename?: 'Pagination'
  currentPage: Scalars['Int']['output']
  hasNextPage: Scalars['Boolean']['output']
  hasPrevPage: Scalars['Boolean']['output']
  perPage: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type Personalization = {
  __typename?: 'Personalization'
  campaign: Campaign
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  errors?: Maybe<Array<FieldError>>
  hashValue?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  inviteMessage: Scalars['String']['output']
  locale: IncentivizationCampaignPersonalizationLocaleEnum
  lostIncentivizationsCount: Scalars['Int']['output']
  requestedIncentivizationsCount: Scalars['Int']['output']
  totalIncentivizationsCount: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  wonIncentivizationsCount: Scalars['Int']['output']
}

/** Attributes for updating a campaign personalization */
export type PersonalizationAttributes = {
  inviteMessage?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<IncentivizationCampaignPersonalizationLocaleEnum>
}

export type Placement = {
  __typename?: 'Placement'
  active: Scalars['Boolean']['output']
  banners: Array<Banner>
  dataKey?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  pageSlug: Scalars['String']['output']
  railsServingEnabled: Scalars['Boolean']['output']
  slotIndex: Scalars['Int']['output']
}

export type PopularProducts = {
  __typename?: 'PopularProducts'
  category: Category
  products: Array<Product>
}

export type PpcCampaign = {
  __typename?: 'PpcCampaign'
  epomId: Scalars['BigInt']['output']
}

export type PpcConversionValue = {
  __typename?: 'PpcConversionValue'
  campaignId: Scalars['BigInt']['output']
  currency: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type PricingPlan = {
  __typename?: 'PricingPlan'
  billingPeriod?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  descriptionTranslations: Array<Translation>
  errors?: Maybe<Array<FieldError>>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  nameTranslations: Array<Translation>
  perkList?: Maybe<Array<Scalars['String']['output']>>
  perksTranslations: Array<Translation>
  position?: Maybe<Scalars['Int']['output']>
  priceCents?: Maybe<Scalars['Int']['output']>
  priceCurrency?: Maybe<Scalars['String']['output']>
  priceCurrencySymbol?: Maybe<Scalars['String']['output']>
  priceTextValue?: Maybe<Scalars['String']['output']>
  pricingSubscriptionModeId?: Maybe<Scalars['ID']['output']>
  pricingTextOptionId?: Maybe<Scalars['ID']['output']>
  productId: Scalars['ID']['output']
  promoted: Scalars['Boolean']['output']
  promotedLabel?: Maybe<PromotedLabelEnum>
  startingPrice: Scalars['Boolean']['output']
  titleIcon?: Maybe<TitleIconEnum>
}

export type PricingPlanAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated Use descriptionTranslations instead */
  description?: InputMaybe<Scalars['String']['input']>
  descriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** @deprecated Use nameTranslations instead */
  name?: InputMaybe<Scalars['String']['input']>
  nameTranslations?: InputMaybe<Array<TranslationAttributes>>
  /** @deprecated Use perksTranslations instead */
  perks?: InputMaybe<Array<Scalars['String']['input']>>
  perksTranslations?: InputMaybe<Array<TranslationAttributes>>
  position?: InputMaybe<Scalars['Int']['input']>
  priceCents?: InputMaybe<Scalars['Int']['input']>
  priceCurrency?: InputMaybe<Scalars['String']['input']>
  pricingSubscriptionModeId?: InputMaybe<Scalars['String']['input']>
  pricingTextOptionId?: InputMaybe<Scalars['String']['input']>
  promoted?: InputMaybe<Scalars['Boolean']['input']>
  promotedLabel?: InputMaybe<PromotedLabelEnum>
  startingPrice?: InputMaybe<Scalars['Boolean']['input']>
  titleIcon?: InputMaybe<TitleIconEnum>
}

export type PricingSubscriptionMode = {
  __typename?: 'PricingSubscriptionMode'
  id: Scalars['ID']['output']
  inDays?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  nameTranslations: Array<Translation>
}

export type PricingTextOption = {
  __typename?: 'PricingTextOption'
  free: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nameTranslations: Array<Translation>
}

/** Autogenerated input type of ProcessSurveyResponse */
export type ProcessSurveyResponseInput = {
  answers: Array<AnswerAttributes>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /**
   * Incentive hashed slug
   * @deprecated replaced with incentivizeWithCampaign
   */
  incentive?: InputMaybe<Scalars['String']['input']>
  /** @deprecated replaced with incentivizeWithCampaign */
  incentiveGroup?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>
  productSlug: Scalars['String']['input']
  /** @deprecated replaced with incentivizeWithCampaign */
  source?: InputMaybe<Scalars['String']['input']>
  submitted?: InputMaybe<Scalars['Boolean']['input']>
  surveyId: Scalars['ID']['input']
  /** @deprecated replaced with incentivizeWithCampaign */
  trigger?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of ProcessSurveyResponse. */
export type ProcessSurveyResponsePayload = {
  __typename?: 'ProcessSurveyResponsePayload'
  answerErrors?: Maybe<Array<AnswerError>>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors?: Maybe<Array<Scalars['String']['output']>>
  surveyResponse?: Maybe<SurveyResponse>
}

/** Autogenerated input type of ProcessUniversalReview */
export type ProcessUniversalReviewInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>
  answers: Array<UniversalReviewAnswerAttributes>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>
  subjectSlug: Scalars['ID']['input']
  subjectType: ReviewSubjectTypeEnum
  submitted?: InputMaybe<Scalars['Boolean']['input']>
  /** Survey slug (surveys have no numeric public id). Resolved by Uss::SurveyResolver; ignored once the review is moderated. */
  surveyId?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of ProcessUniversalReview. */
export type ProcessUniversalReviewPayload = {
  __typename?: 'ProcessUniversalReviewPayload'
  answerErrors?: Maybe<Array<UniversalAnswerError>>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors?: Maybe<Array<Scalars['String']['output']>>
  review?: Maybe<UniversalReview>
}

export type Product = Attachable &
  Contactable & {
    __typename?: 'Product'
    alternativesFooterDescription?: Maybe<Scalars['String']['output']>
    /** @deprecated Please use config.ctaCustomQuoteCached instead */
    alwaysShowLink: Scalars['Boolean']['output']
    anytimeSupport?: Maybe<ProductAnytimeSupportEnum>
    assignedBadges: Array<AssignedBadge>
    atpSeoData?: Maybe<SeoData>
    averageCustomerSupportScore?: Maybe<Scalars['Float']['output']>
    averageEaseOfSetup?: Maybe<Scalars['Float']['output']>
    averageEaseOfUse?: Maybe<Scalars['Float']['output']>
    averageRecommendationRating?: Maybe<Scalars['Float']['output']>
    averageRequirementsScore?: Maybe<Scalars['Float']['output']>
    averageRightDirection?: Maybe<Scalars['Float']['output']>
    /**
     * Deprecated alias of ppcBulletPoints.
     * @deprecated Renamed to ppcBulletPoints
     */
    bulletPoints?: Maybe<Array<Scalars['String']['output']>>
    categories: Array<Category>
    categoryTags: Array<ProductCategoryTag>
    cloud?: Maybe<ProductCloudEnum>
    companySlug?: Maybe<Scalars['String']['output']>
    config: ProductConfig
    contactFormRecipients?: Maybe<Array<Scalars['String']['output']>>
    /** @deprecated Please use ctaSecondary.label */
    ctaLabel?: Maybe<Scalars['String']['output']>
    ctaPrimaryHide: Scalars['Boolean']['output']
    ctaSecondary?: Maybe<Link>
    ctaSecondaryLabelTranslations: Array<Translation>
    ctaSecondaryUrlTranslations: Array<Translation>
    /** @deprecated Please use ctaSecondary.url */
    ctaUrl?: Maybe<Scalars['String']['output']>
    currentBudget?: Maybe<Budget>
    /** @deprecated Please use config instead */
    dealPlanType?: Maybe<DealPlanTypeEnum>
    /** @deprecated Please use mainCategory.slug */
    defaultCategoryId: Scalars['ID']['output']
    description?: Maybe<Scalars['String']['output']>
    descriptionTranslations: Array<Translation>
    disclaimerText?: Maybe<Scalars['String']['output']>
    disclaimerTextTranslations: Array<Translation>
    disclaimerUrl?: Maybe<Scalars['String']['output']>
    disclaimerUrlTranslations: Array<Translation>
    documents: Array<Asset>
    errors?: Maybe<Array<FieldError>>
    euCompanyAffiliated?: Maybe<ProductEuCompanyAffiliatedEnum>
    euLocation?: Maybe<ProductEuLocationEnum>
    euStandardContract?: Maybe<ProductEuStandardContractEnum>
    expiredAssignedBadges: Array<AssignedBadge>
    featureCategories: Array<ProductFeatureCategory>
    features: Array<Feature>
    freeDemo: Scalars['Boolean']['output']
    freeMode?: Maybe<Scalars['String']['output']>
    freePlanAvailable?: Maybe<Scalars['Boolean']['output']>
    freeTrial: Scalars['Boolean']['output']
    germanLocation?: Maybe<ProductGermanLocationEnum>
    germanSupport?: Maybe<ProductGermanSupportEnum>
    globalFeatures: Array<ProductGlobalFeature>
    globalId: Scalars['ID']['output']
    hasPaidPlan?: Maybe<Scalars['Boolean']['output']>
    hero?: Maybe<Asset>
    /** Custom poster image for the hero video, when set */
    heroVideoThumbnail?: Maybe<Asset>
    id: Scalars['ID']['output']
    isSuite: Scalars['Boolean']['output']
    linkText?: Maybe<Scalars['String']['output']>
    linkTextTranslations: Array<Translation>
    linkedin?: Maybe<Scalars['String']['output']>
    logo?: Maybe<Asset>
    mainCategory: Category
    negativeReview?: Maybe<Review>
    noPricingPlans?: Maybe<Scalars['Boolean']['output']>
    noPricingPlansHint?: Maybe<Scalars['String']['output']>
    noPricingPlansHintTranslations: Array<Translation>
    onPremise?: Maybe<ProductOnPremiseEnum>
    pageVisitReportEmails?: Maybe<Array<Scalars['String']['output']>>
    positiveReview?: Maybe<Review>
    /** Product PPC highlight bullet points (Perks) for the current locale; falls back to the review summary bullets when unset. */
    ppcBulletPoints?: Maybe<Array<Scalars['String']['output']>>
    pricingPlans: Array<PricingPlan>
    pricingSeoData?: Maybe<SeoData>
    pricingUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
    productSuites: Array<Product>
    published?: Maybe<Scalars['Boolean']['output']>
    publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
    purposes: Array<Category>
    qualityState?: Maybe<Scalars['String']['output']>
    questionAnswerSet?: Maybe<ProductAnswerSet>
    rankscaleUrl?: Maybe<Scalars['String']['output']>
    /** Total number of reviews */
    reviewCount: Scalars['Int']['output']
    /** Number of reviews in given category */
    reviewCountInCategory?: Maybe<Scalars['Int']['output']>
    reviewSummary?: Maybe<ReviewSummary>
    schemaMarkupType: ProductSchemaMarkupTypeEnum
    screenshots: Array<Asset>
    searchScore?: Maybe<Scalars['Float']['output']>
    seoData?: Maybe<SeoData>
    shortDescription?: Maybe<Scalars['String']['output']>
    shortDescriptionTranslations: Array<Translation>
    showDisclaimer?: Maybe<Scalars['Boolean']['output']>
    slug: Scalars['ID']['output']
    suiteProducts: Array<Product>
    title: Scalars['String']['output']
    toolPartners: Array<ToolPartner>
    topProduct?: Maybe<Scalars['Boolean']['output']>
    trialPeriod?: Maybe<Scalars['Float']['output']>
    trialUnit?: Maybe<ProductTrialUnitEnum>
    twitter?: Maybe<Scalars['String']['output']>
    updatedAt: Scalars['ISO8601DateTime']['output']
    url?: Maybe<Scalars['String']['output']>
    urlTranslations: Array<Translation>
    usesNewSurvey?: Maybe<Scalars['Boolean']['output']>
    vendorEmailAddresses?: Maybe<Array<Scalars['String']['output']>>
    /** False for anonymous callers and for users with no watchlist. */
    watchedByCurrentUser: Scalars['Boolean']['output']
  }

export type ProductReviewCountInCategoryArgs = {
  categoryId: Scalars['ID']['input']
}

export type ProductAnswer = {
  __typename?: 'ProductAnswer'
  answer: Scalars['String']['output']
  aspectSlugs: Array<Scalars['String']['output']>
  evidenceSource: ProductAnswerEvidenceSourceEnum
  key: Scalars['String']['output']
  kind: ProductAnswerKindEnum
  /** Distinct reviews behind the answer, out of reviewsCount. */
  mentionCount: Scalars['Int']['output']
  negativeCount: Scalars['Int']['output']
  position: Scalars['Int']['output']
  positiveCount: Scalars['Int']['output']
  question: Scalars['String']['output']
  sentiment: ProductAnswerSentimentEnum
}

export enum ProductAnswerEvidenceSourceEnum {
  Aspects = 'aspects',
  CompanySize = 'company_size',
  Industry = 'industry',
}

export enum ProductAnswerKindEnum {
  Standard = 'standard',
  Verdict = 'verdict',
}

export enum ProductAnswerSentimentEnum {
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive',
}

export type ProductAnswerSet = {
  __typename?: 'ProductAnswerSet'
  /** Answered questions, verdict first; empty unless the verdict is answered. */
  answers: Array<ProductAnswer>
  generatedAt: Scalars['ISO8601DateTime']['output']
  /** Average rating out of 5 the answers were written against. */
  rating?: Maybe<Scalars['Float']['output']>
  /** Published reviews the counts are taken from. */
  reviewsCount: Scalars['Int']['output']
}

export enum ProductAnytimeSupportEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

/** Attributes for updating a product */
export type ProductAttributes = {
  anytimeSupport?: InputMaybe<ProductAnytimeSupportEnum>
  cloud?: InputMaybe<ProductCloudEnum>
  configAttributes?: InputMaybe<ProductConfigAttributes>
  contactFormRecipients?: InputMaybe<Array<Scalars['String']['input']>>
  ctaPrimaryHide?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated Use ctaSecondaryLabelTranslations instead */
  ctaSecondaryLabel?: InputMaybe<Scalars['String']['input']>
  ctaSecondaryLabelTranslations?: InputMaybe<Array<TranslationAttributes>>
  /** @deprecated Use ctaSecondaryUrlTranslations instead */
  ctaSecondaryUrl?: InputMaybe<Scalars['String']['input']>
  ctaSecondaryUrlTranslations?: InputMaybe<Array<TranslationAttributes>>
  /** @deprecated Use descriptionTranslations instead */
  description?: InputMaybe<Scalars['String']['input']>
  descriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  /** @deprecated Use disclaimerTextTranslations instead */
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  disclaimerTextTranslations?: InputMaybe<Array<TranslationAttributes>>
  /** @deprecated Use disclaimerUrlTranslations instead */
  disclaimerUrl?: InputMaybe<Scalars['String']['input']>
  disclaimerUrlTranslations?: InputMaybe<Array<TranslationAttributes>>
  euCompanyAffiliated?: InputMaybe<ProductEuCompanyAffiliatedEnum>
  euLocation?: InputMaybe<ProductEuLocationEnum>
  euStandardContract?: InputMaybe<ProductEuStandardContractEnum>
  freeDemo?: InputMaybe<Scalars['Boolean']['input']>
  freeTrial?: InputMaybe<Scalars['Boolean']['input']>
  germanLocation?: InputMaybe<ProductGermanLocationEnum>
  germanSupport?: InputMaybe<ProductGermanSupportEnum>
  heroImage?: InputMaybe<Scalars['Upload']['input']>
  heroVideo?: InputMaybe<Scalars['Upload']['input']>
  heroVideoThumbnail?: InputMaybe<Scalars['Upload']['input']>
  /** @deprecated Use linkTextTranslations instead */
  linkText?: InputMaybe<Scalars['String']['input']>
  linkTextTranslations?: InputMaybe<Array<TranslationAttributes>>
  linkedin?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['Upload']['input']>
  noPricingPlans?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated Use noPricingPlansHintTranslations instead */
  noPricingPlansHint?: InputMaybe<Scalars['String']['input']>
  noPricingPlansHintTranslations?: InputMaybe<Array<TranslationAttributes>>
  onPremise?: InputMaybe<ProductOnPremiseEnum>
  pageVisitReportEmails?: InputMaybe<Array<Scalars['String']['input']>>
  /** @deprecated Use shortDescriptionTranslations instead */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  shortDescriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  showDisclaimer?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  trialPeriod?: InputMaybe<Scalars['Float']['input']>
  trialUnit?: InputMaybe<ProductTrialUnitEnum>
  twitter?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Use urlTranslations instead */
  url?: InputMaybe<Scalars['String']['input']>
  urlTranslations?: InputMaybe<Array<TranslationAttributes>>
  vendorEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ProductBadge = {
  __typename?: 'ProductBadge'
  assignedRecordSlug: Scalars['String']['output']
  assignedRecordType: Scalars['String']['output']
  badgeName: Scalars['String']['output']
  badgeType: Scalars['String']['output']
  category?: Maybe<Category>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  product: Product
  timeframe?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ProductCategoryTag = {
  __typename?: 'ProductCategoryTag'
  id: Scalars['ID']['output']
  published: Scalars['Boolean']['output']
  slug: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export enum ProductCloudEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

export type ProductConfig = {
  __typename?: 'ProductConfig'
  aiVisibilityDashboardAdminCalculated: DealProductPlanAiVisibilityDashboardEnum
  aiVisibilityDashboardCached: ProductConfigAiVisibilityDashboardCachedEnum
  aiVisibilityDashboardVendor: ProductConfigAiVisibilityDashboardVendorEnum
  aiVisibilityDashboardVendorPossibleOptions: Array<Scalars['String']['output']>
  badgesAdminCalculated: DealProductPlanBadgesEnum
  badgesCached: ProductConfigBadgesCachedEnum
  badgesVendor: ProductConfigBadgesVendorEnum
  badgesVendorPossibleOptions: Array<Scalars['String']['output']>
  boostInSearchAdminCalculated: DealProductPlanBoostInSearchEnum
  boostInSearchCached: ProductConfigBoostInSearchCachedEnum
  boostInSearchVendor: ProductConfigBoostInSearchVendorEnum
  boostInSearchVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaCustomQuoteAdminCalculated: DealProductPlanCtaCustomQuoteEnum
  ctaCustomQuoteCached: ProductConfigCtaCustomQuoteCachedEnum
  ctaCustomQuoteVendor: ProductConfigCtaCustomQuoteVendorEnum
  ctaCustomQuoteVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaPrimaryAdminCalculated: DealProductPlanCtaPrimaryEnum
  ctaPrimaryCached: ProductConfigCtaPrimaryCachedEnum
  ctaPrimaryVendor: ProductConfigCtaPrimaryVendorEnum
  ctaPrimaryVendorPossibleOptions: Array<Scalars['String']['output']>
  ctaSecondaryAdminCalculated: DealProductPlanCtaSecondaryEnum
  ctaSecondaryCached: ProductConfigCtaSecondaryCachedEnum
  ctaSecondaryVendor: ProductConfigCtaSecondaryVendorEnum
  ctaSecondaryVendorPossibleOptions: Array<Scalars['String']['output']>
  downloadsFileUploadAdminCalculated: DealProductPlanDownloadsFileUploadEnum
  downloadsFileUploadCached: ProductConfigDownloadsFileUploadCachedEnum
  downloadsFileUploadVendor: ProductConfigDownloadsFileUploadVendorEnum
  downloadsFileUploadVendorPossibleOptions: Array<Scalars['String']['output']>
  errors?: Maybe<Array<FieldError>>
  fileDownloadPassedThroughAdminCalculated: DealProductPlanFileDownloadPassedThroughEnum
  fileDownloadPassedThroughCached: ProductConfigFileDownloadPassedThroughCachedEnum
  fileDownloadPassedThroughVendor: ProductConfigFileDownloadPassedThroughVendorEnum
  fileDownloadPassedThroughVendorPossibleOptions: Array<Scalars['String']['output']>
  heroImageAdminCalculated: DealProductPlanHeroImageEnum
  heroImageCached: ProductConfigHeroImageCachedEnum
  heroImageVendor: ProductConfigHeroImageVendorEnum
  heroImageVendorPossibleOptions: Array<Scalars['String']['output']>
  pageVisitReportsAdminCalculated: DealProductPlanPageVisitReportsEnum
  pageVisitReportsCached: ProductConfigPageVisitReportsCachedEnum
  pageVisitReportsVendor: ProductConfigPageVisitReportsVendorEnum
  pageVisitReportsVendorPossibleOptions: Array<Scalars['String']['output']>
  pricingDisclaimerLinkAdminCalculated: DealProductPlanPricingDisclaimerLinkEnum
  pricingDisclaimerLinkCached: ProductConfigPricingDisclaimerLinkCachedEnum
  pricingDisclaimerLinkVendor: ProductConfigPricingDisclaimerLinkVendorEnum
  pricingDisclaimerLinkVendorPossibleOptions: Array<Scalars['String']['output']>
  profileClaimedAdminCalculated: DealProductPlanProfileClaimedEnum
  profileClaimedCached: ProductConfigProfileClaimedCachedEnum
  profileClaimedVendor: ProductConfigProfileClaimedVendorEnum
  profileClaimedVendorPossibleOptions: Array<Scalars['String']['output']>
  reviewRemindersAllowedAdminCalculated: DealProductPlanReviewRemindersAllowedEnum
  reviewRemindersAllowedCached: ProductConfigReviewRemindersAllowedCachedEnum
  reviewRemindersAllowedVendor: ProductConfigReviewRemindersAllowedVendorEnum
  reviewRemindersAllowedVendorPossibleOptions: Array<Scalars['String']['output']>
  reviewRepliesAllowedAdminCalculated: DealProductPlanReviewRepliesAllowedEnum
  reviewRepliesAllowedCached: ProductConfigReviewRepliesAllowedCachedEnum
  reviewRepliesAllowedVendor: ProductConfigReviewRepliesAllowedVendorEnum
  reviewRepliesAllowedVendorPossibleOptions: Array<Scalars['String']['output']>
  socialLinksAdminCalculated: DealProductPlanSocialLinksEnum
  socialLinksCached: ProductConfigSocialLinksCachedEnum
  socialLinksVendor: ProductConfigSocialLinksVendorEnum
  socialLinksVendorPossibleOptions: Array<Scalars['String']['output']>
  widgetsAdminCalculated: DealProductPlanWidgetsEnum
  widgetsCached: ProductConfigWidgetsCachedEnum
  widgetsVendor: ProductConfigWidgetsVendorEnum
  widgetsVendorPossibleOptions: Array<Scalars['String']['output']>
}

export enum ProductConfigAiVisibilityDashboardCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigAiVisibilityDashboardVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

/** Attributes for updating a product config */
export type ProductConfigAttributes = {
  aiVisibilityDashboardVendor?: InputMaybe<ProductConfigAiVisibilityDashboardVendorEnum>
  badgesVendor?: InputMaybe<ProductConfigBadgesVendorEnum>
  boostInSearchVendor?: InputMaybe<ProductConfigBoostInSearchVendorEnum>
  ctaCustomQuoteVendor?: InputMaybe<ProductConfigCtaCustomQuoteVendorEnum>
  ctaPrimaryVendor?: InputMaybe<ProductConfigCtaPrimaryVendorEnum>
  ctaSecondaryVendor?: InputMaybe<ProductConfigCtaSecondaryVendorEnum>
  downloadsFileUploadVendor?: InputMaybe<ProductConfigDownloadsFileUploadVendorEnum>
  fileDownloadPassedThroughVendor?: InputMaybe<ProductConfigFileDownloadPassedThroughVendorEnum>
  heroImageVendor?: InputMaybe<ProductConfigHeroImageVendorEnum>
  pageVisitReportsVendor?: InputMaybe<ProductConfigPageVisitReportsVendorEnum>
  pricingDisclaimerLinkVendor?: InputMaybe<ProductConfigPricingDisclaimerLinkVendorEnum>
  profileClaimedVendor?: InputMaybe<ProductConfigProfileClaimedVendorEnum>
  reviewRemindersAllowedVendor?: InputMaybe<ProductConfigReviewRemindersAllowedVendorEnum>
  reviewRepliesAllowedVendor?: InputMaybe<ProductConfigReviewRepliesAllowedVendorEnum>
  socialLinksVendor?: InputMaybe<ProductConfigSocialLinksVendorEnum>
  widgetsVendor?: InputMaybe<ProductConfigWidgetsVendorEnum>
}

export enum ProductConfigBadgesCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigBadgesVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigBoostInSearchCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigBoostInSearchVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaCustomQuoteCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaCustomQuoteVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaPrimaryCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaPrimaryVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaSecondaryCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigCtaSecondaryVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigDownloadsFileUploadCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigDownloadsFileUploadVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigFileDownloadPassedThroughCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigFileDownloadPassedThroughVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigHeroImageCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigHeroImageVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigPageVisitReportsCachedEnum {
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum ProductConfigPageVisitReportsVendorEnum {
  Automatic = 'automatic',
  Basic = 'basic',
  Extended = 'extended',
  None = 'none',
}

export enum ProductConfigPricingDisclaimerLinkCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigPricingDisclaimerLinkVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigProfileClaimedCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigProfileClaimedVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigReviewRemindersAllowedCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigReviewRemindersAllowedVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigReviewRepliesAllowedCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigReviewRepliesAllowedVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigSocialLinksCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigSocialLinksVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigWidgetsCachedEnum {
  No = 'no',
  Yes = 'yes',
}

export enum ProductConfigWidgetsVendorEnum {
  Automatic = 'automatic',
  No = 'no',
  Yes = 'yes',
}

export enum ProductEuCompanyAffiliatedEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
}

export enum ProductEuLocationEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

export enum ProductEuStandardContractEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
}

export type ProductFeatureCategory = {
  __typename?: 'ProductFeatureCategory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export enum ProductGermanLocationEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

export enum ProductGermanSupportEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

export type ProductGlobalFeature = {
  __typename?: 'ProductGlobalFeature'
  extractedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  slug: Scalars['String']['output']
  value?: Maybe<Scalars['JSON']['output']>
}

export type ProductListingPage = {
  __typename?: 'ProductListingPage'
  /** List of filters that are overwritten for this listing */
  appliedFilters: Array<Scalars['String']['output']>
  category: Category
  linkText?: Maybe<Scalars['String']['output']>
  path: Scalars['String']['output']
  seoData: SeoData
}

export enum ProductOnPremiseEnum {
  No = 'no',
  NoInfo = 'no_info',
  Yes = 'yes',
  YesConditional = 'yes_conditional',
}

export enum ProductReviewSummaryVoteVoteEnum {
  Down = 'down',
  Up = 'up',
}

export enum ProductSchemaMarkupTypeEnum {
  Product = 'product',
  SoftwareApplication = 'software_application',
}

export type ProductSitemapEntry = {
  __typename?: 'ProductSitemapEntry'
  atpMetaNoindex: Scalars['Boolean']['output']
  hasPricingPlans: Scalars['Boolean']['output']
  pricingUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  slug: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum ProductTrialUnitEnum {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export enum PromotedLabelEnum {
  Popular = 'popular',
  Recommended = 'recommended',
  TopOffer = 'top_offer',
}

export type QualityScore = {
  __typename?: 'QualityScore'
  band: Scalars['String']['output']
  mechanicalFailures: Array<MechanicalFailure>
  notes: Array<Scalars['String']['output']>
  overall: Scalars['Int']['output']
  sections: Array<SectionScore>
}

export type Query = {
  __typename?: 'Query'
  agencies: AgenciesResult
  agency: Agency
  agencyFeatures?: Maybe<Array<AgencyFeature>>
  alternativeProducts?: Maybe<AlternativeProductsResult>
  assignedBadge?: Maybe<AssignedBadge>
  campaignByHash: CampaignResult
  campaignFromIncentive?: Maybe<Campaign>
  categories: Array<Category>
  category: Category
  claimEmailEligibility: ClaimEmailEligibility
  exploreAgencies: Result
  exploreProducts?: Maybe<ExploreProductsResult>
  featureCategories?: Maybe<Array<ProductFeatureCategory>>
  listProducts: Array<Product>
  manage?: Maybe<ManageQuery>
  manageAccess: ManageAccess
  myReviews: Array<MyReview>
  ping?: Maybe<Scalars['String']['output']>
  popularProducts?: Maybe<Array<PopularProducts>>
  ppcConversionValue?: Maybe<PpcConversionValue>
  ppcPlacementsForPage: Array<Placement>
  product?: Maybe<Product>
  /** @deprecated Use assignedBadge instead */
  productBadge?: Maybe<ProductBadge>
  productListingPage?: Maybe<ProductListingPage>
  productSlugs?: Maybe<Array<Scalars['ID']['output']>>
  /** @deprecated Use exploreProducts instead */
  products?: Maybe<ExploreProductsResult>
  /** @deprecated Use listProducts instead */
  productsByCompany: Array<Product>
  productsForComparison?: Maybe<ComparisonAlternativesResult>
  review?: Maybe<Review>
  reviews?: Maybe<PaginatedReviews>
  scoreSurveyDraft?: Maybe<QualityScore>
  /** Search and filter products for reviews */
  search: SearchResult
  /**
   * Search and filter products for reviews
   * @deprecated Use search instead
   */
  searchProducts: SearchResult
  seoProducts: Array<ProductSitemapEntry>
  seoVersusProducts: Array<VersusProductSitemapEntry>
  survey?: Maybe<Survey>
  topProducts?: Maybe<Array<Product>>
  universalSurveyForSubject?: Maybe<UniversalSurveyForSubjectPayload>
  vendorProducts?: Maybe<VendorProductsResult>
  /** AVB products */
  versusProducts?: Maybe<VersusProductsResult>
  /** The signed-in reviewer's watch items, newest first. */
  watchItems: Array<WatchItem>
}

export type QueryAgenciesArgs = {
  categorySlug?: InputMaybe<Scalars['ID']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  productSlug?: InputMaybe<Scalars['ID']['input']>
  slug?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAgencyArgs = {
  slug: Scalars['ID']['input']
}

export type QueryAgencyFeaturesArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryAlternativeProductsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  slug: Scalars['ID']['input']
}

export type QueryAssignedBadgeArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignByHashArgs = {
  hashValue: Scalars['String']['input']
}

export type QueryCampaignFromIncentiveArgs = {
  incentiveHashedSlug: Scalars['String']['input']
  productSlug: Scalars['String']['input']
}

export type QueryCategoriesArgs = {
  filterHidden?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<CategoryKindEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>
  parentCategory?: InputMaybe<Scalars['ID']['input']>
  sortByReviewCount?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCategoryArgs = {
  slug: Scalars['ID']['input']
}

export type QueryExploreAgenciesArgs = {
  categorySlug?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<AgencySearchFilters>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<AgencySortingEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
}

export type QueryExploreProductsArgs = {
  anytimeSupport?: InputMaybe<ProductAnytimeSupportEnum>
  categorySlug?: InputMaybe<Scalars['ID']['input']>
  cloud?: InputMaybe<ProductCloudEnum>
  euCompanyAffiliated?: InputMaybe<ProductEuCompanyAffiliatedEnum>
  euLocation?: InputMaybe<ProductEuLocationEnum>
  euStandardContract?: InputMaybe<ProductEuStandardContractEnum>
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>
  freePlanAvailable?: InputMaybe<Scalars['Boolean']['input']>
  germanLocation?: InputMaybe<ProductGermanLocationEnum>
  germanSupport?: InputMaybe<ProductGermanSupportEnum>
  listingPagePath?: InputMaybe<Scalars['String']['input']>
  marketSegments?: InputMaybe<Array<MarketSegmentKeyEnum>>
  onPremise?: InputMaybe<ProductOnPremiseEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  profileClaimed?: InputMaybe<Scalars['Boolean']['input']>
  recommendationRatings?: InputMaybe<Array<RecommendationRatingKeyEnum>>
  showInArticleWidget?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<ExploreProductsSortingEnum>
  term?: InputMaybe<Scalars['String']['input']>
}

export type QueryFeatureCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  product?: InputMaybe<Scalars['ID']['input']>
}

export type QueryListProductsArgs = {
  agencySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  companySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  slugs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryManageAccessArgs = {
  claimableId: Scalars['GlobalId']['input']
}

export type QueryPopularProductsArgs = {
  categoryLimit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPpcConversionValueArgs = {
  campaignId: Scalars['BigInt']['input']
}

export type QueryPpcPlacementsForPageArgs = {
  slug: Scalars['String']['input']
}

export type QueryProductArgs = {
  slug: Scalars['ID']['input']
  status?: InputMaybe<FilterByPublicationStatusEnum>
}

export type QueryProductBadgeArgs = {
  id: Scalars['ID']['input']
}

export type QueryProductListingPageArgs = {
  category: Scalars['ID']['input']
  path: Scalars['String']['input']
}

export type QueryProductsArgs = {
  anytimeSupport?: InputMaybe<ProductAnytimeSupportEnum>
  categorySlug?: InputMaybe<Scalars['ID']['input']>
  cloud?: InputMaybe<ProductCloudEnum>
  euCompanyAffiliated?: InputMaybe<ProductEuCompanyAffiliatedEnum>
  euLocation?: InputMaybe<ProductEuLocationEnum>
  euStandardContract?: InputMaybe<ProductEuStandardContractEnum>
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>
  freePlanAvailable?: InputMaybe<Scalars['Boolean']['input']>
  germanLocation?: InputMaybe<ProductGermanLocationEnum>
  germanSupport?: InputMaybe<ProductGermanSupportEnum>
  listingPagePath?: InputMaybe<Scalars['String']['input']>
  marketSegments?: InputMaybe<Array<MarketSegmentKeyEnum>>
  onPremise?: InputMaybe<ProductOnPremiseEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  profileClaimed?: InputMaybe<Scalars['Boolean']['input']>
  recommendationRatings?: InputMaybe<Array<RecommendationRatingKeyEnum>>
  showInArticleWidget?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<ExploreProductsSortingEnum>
  term?: InputMaybe<Scalars['String']['input']>
}

export type QueryProductsByCompanyArgs = {
  agencySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  companySlugs?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  slugs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryProductsForComparisonArgs = {
  comparedProduct: Scalars['ID']['input']
  perPage?: InputMaybe<Scalars['Int']['input']>
  perSideMin?: InputMaybe<Scalars['Int']['input']>
  product: Scalars['ID']['input']
}

export type QueryReviewArgs = {
  slug: Scalars['ID']['input']
}

export type QueryReviewsArgs = {
  filters?: InputMaybe<ReviewsSearchFilters>
  product: Scalars['ID']['input']
}

export type QueryScoreSurveyDraftArgs = {
  productSlug: Scalars['ID']['input']
}

export type QuerySearchArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>
  filterByIsSuite?: InputMaybe<FilterByIsSuiteEnum>
  filterByPublicationStatus?: InputMaybe<FilterByPublicationStatusEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SearchSortingEnum>
  term: Scalars['String']['input']
}

export type QuerySearchProductsArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>
  filterByIsSuite?: InputMaybe<FilterByIsSuiteEnum>
  filterByPublicationStatus?: InputMaybe<FilterByPublicationStatusEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SearchSortingEnum>
  term: Scalars['String']['input']
}

export type QuerySurveyArgs = {
  productSlug: Scalars['ID']['input']
}

export type QueryUniversalSurveyForSubjectArgs = {
  subjectSlug: Scalars['ID']['input']
  subjectType: ReviewSubjectTypeEnum
  surveyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryVersusProductsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type Question = {
  __typename?: 'Question'
  constraints?: Maybe<Scalars['JSON']['output']>
  dependentOptions?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  inputType?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  position?: Maybe<Scalars['Int']['output']>
  questionType?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  selectOptions?: Maybe<Scalars['JSON']['output']>
  title: Scalars['String']['output']
}

export type RecommendationRatingFacet = {
  __typename?: 'RecommendationRatingFacet'
  docCount: Scalars['Int']['output']
  key: RecommendationRatingKeyEnum
}

export enum RecommendationRatingKeyEnum {
  Bad = 'bad',
  Best = 'best',
  Better = 'better',
  Good = 'good',
  Worse = 'worse',
}

/** Autogenerated input type of RecordPpcShadowDiff */
export type RecordPpcShadowDiffInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hygraphDecision: Scalars['JSON']['input']
  pageSlug: Scalars['String']['input']
}

/** Autogenerated return type of RecordPpcShadowDiff. */
export type RecordPpcShadowDiffPayload = {
  __typename?: 'RecordPpcShadowDiffPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors: Array<Scalars['String']['output']>
}

/** A visible select option on a rendered question. */
export type RenderedOption = {
  __typename?: 'RenderedOption'
  /** Residual answer-dependent predicate AST. nil means always show; a non-null Hash must be re-evaluated client-side against the live answer map. References only `answer.<question_slug>` fields. */
  condition?: Maybe<Scalars['JSON']['output']>
  constraints?: Maybe<Scalars['JSON']['output']>
  label?: Maybe<Scalars['String']['output']>
  slug: Scalars['ID']['output']
}

/** A visible page in the rendered survey tree. */
export type RenderedPage = {
  __typename?: 'RenderedPage'
  /** Residual answer-dependent predicate AST. nil means always show; a non-null Hash must be re-evaluated client-side against the live answer map. References only `answer.<question_slug>` fields. */
  condition?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  position: Scalars['Int']['output']
  sections: Array<RenderedSection>
  slug: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** A question that survived visibility filtering on the rendered survey tree. */
export type RenderedQuestion = {
  __typename?: 'RenderedQuestion'
  answerType: Scalars['String']['output']
  /** Residual answer-dependent predicate AST. nil means always show; a non-null Hash must be re-evaluated client-side against the live answer map. References only `answer.<question_slug>` fields. */
  condition?: Maybe<Scalars['JSON']['output']>
  constraints?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  inputType: Scalars['String']['output']
  placeholder?: Maybe<Scalars['String']['output']>
  required: Scalars['Boolean']['output']
  scaleMax?: Maybe<Scalars['Int']['output']>
  scaleMin?: Maybe<Scalars['Int']['output']>
  scaleStep?: Maybe<Scalars['Float']['output']>
  selectOptions: Array<RenderedOption>
  slug: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** A visible section under a rendered page (base or pack-injected). */
export type RenderedSection = {
  __typename?: 'RenderedSection'
  /** Residual answer-dependent predicate AST. nil means always show; a non-null Hash must be re-evaluated client-side against the live answer map. References only `answer.<question_slug>` fields. */
  condition?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  position: Scalars['Int']['output']
  questions: Array<RenderedQuestion>
  slug: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** A universal survey rendered for a specific (subject, reviewer, current_answers) tuple. */
export type RenderedSurvey = {
  __typename?: 'RenderedSurvey'
  pages: Array<RenderedPage>
  slug: Scalars['ID']['output']
}

/** Autogenerated input type of RespondToTakedown */
export type RespondToTakedownInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  statement: Scalars['String']['input']
  token: Scalars['String']['input']
}

/** Autogenerated return type of RespondToTakedown. */
export type RespondToTakedownPayload = {
  __typename?: 'RespondToTakedownPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type Result = {
  __typename?: 'Result'
  industries: Array<AgencyAttributeFilterFacet>
  locations: Array<AgencyAttributeFilterFacet>
  otherCities?: Maybe<Array<AgencyCitiesFacet>>
  pagination: Pagination
  products: Array<AgencyAttributeFilterFacet>
  remote: Array<AgencyAttributeFilterFacet>
  results: Array<Agency>
}

export type Review = {
  __typename?: 'Review'
  anonymous: Scalars['Boolean']['output']
  /** Aspect tags for this review (visible aspects only), with confirming quotes */
  aspects: Array<ReviewAspect>
  campaign?: Maybe<Campaign>
  companyField?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companyPosition: Scalars['String']['output']
  companySize?: Maybe<Scalars['String']['output']>
  customerSupportScore?: Maybe<Scalars['Int']['output']>
  easeOfSetup?: Maybe<Scalars['Int']['output']>
  easeOfUse?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use slug instead */
  id: Scalars['ID']['output']
  incentive: Scalars['Boolean']['output']
  negative?: Maybe<Scalars['String']['output']>
  personalizations?: Maybe<Array<Personalization>>
  positive?: Maybe<Scalars['String']['output']>
  problems?: Maybe<Scalars['String']['output']>
  product: Product
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  purpose: Array<Scalars['String']['output']>
  purposes: Array<Category>
  recommendationScore: Scalars['Int']['output']
  requirementsScore?: Maybe<Scalars['Int']['output']>
  reviewReply?: Maybe<ReviewReply>
  reviewerFirstName?: Maybe<Scalars['String']['output']>
  /** @deprecated Use reviewerFirstName instead */
  reviewerFirstname?: Maybe<Scalars['String']['output']>
  reviewerLastName?: Maybe<Scalars['String']['output']>
  /** @deprecated Use reviewerLastName instead */
  reviewerName?: Maybe<Scalars['String']['output']>
  rightDirection?: Maybe<ReviewRightDirectionEnum>
  searchScore?: Maybe<Scalars['Float']['output']>
  slug: Scalars['ID']['output']
  sticky?: Maybe<Scalars['Boolean']['output']>
  title: Scalars['String']['output']
  transcript?: Maybe<Scalars['String']['output']>
  video?: Maybe<Asset>
}

/** One answer row on a universal review (typed convenience fields are preferred for known slugs). */
export type ReviewAnswer = {
  __typename?: 'ReviewAnswer'
  answerType?: Maybe<Scalars['String']['output']>
  inputType?: Maybe<Scalars['String']['output']>
  questionSlug: Scalars['String']['output']
  recordReferences?: Maybe<Array<UniversalAnswerRecordReference>>
  value?: Maybe<Scalars['String']['output']>
}

export type ReviewAspect = {
  __typename?: 'ReviewAspect'
  /** Verbatim confirming lines from this review */
  quotes: Array<Scalars['String']['output']>
  sentiment: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type ReviewReply = {
  __typename?: 'ReviewReply'
  id?: Maybe<Scalars['ID']['output']>
  outdated?: Maybe<Scalars['Boolean']['output']>
  personalized?: Maybe<Scalars['Boolean']['output']>
  reply: Scalars['String']['output']
  senderName?: Maybe<Scalars['String']['output']>
}

export enum ReviewRightDirectionEnum {
  DontKnow = 'dont_know',
  No = 'no',
  Yes = 'yes',
}

export type ReviewStatistics = {
  __typename?: 'ReviewStatistics'
  recommendationScoreBad: Scalars['Int']['output']
  recommendationScoreBest: Scalars['Int']['output']
  recommendationScoreBetter: Scalars['Int']['output']
  recommendationScoreGood: Scalars['Int']['output']
  recommendationScoreWorse: Scalars['Int']['output']
}

/** The subject of a review or a watch item: an Agency or a Product. */
export type ReviewSubject = Agency | Product

export enum ReviewSubjectTypeEnum {
  Agency = 'Agency',
  Product = 'Product',
}

export type ReviewSummary = {
  __typename?: 'ReviewSummary'
  /** A list of 3–5 positive highlight bullet points for the current locale (no ✅ prefix) */
  bulletPoints?: Maybe<Array<Scalars['String']['output']>>
  createdAt: Scalars['ISO8601DateTime']['output']
  errors?: Maybe<Array<FieldError>>
  id: Scalars['ID']['output']
  /** A list of keywords for the current locale */
  keywords?: Maybe<Array<Scalars['String']['output']>>
  lastGeneratedAt: Scalars['ISO8601DateTime']['output']
  /** The paragraph summary for the current locale */
  paragraphSummary: Scalars['String']['output']
  reviewsCountAtGeneration: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum ReviewsExploreAspectSentiments {
  Any = 'any',
  Negative = 'negative',
  Positive = 'positive',
}

export type ReviewsPurposeType = {
  __typename?: 'ReviewsPurposeType'
  count: Scalars['Int']['output']
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  total: Scalars['Int']['output']
}

export type ReviewsSearchFilters = {
  aspectMatch?: InputMaybe<ArrayMatchEnum>
  aspects?: InputMaybe<Array<AspectFilter>>
  companyField?: InputMaybe<Scalars['String']['input']>
  keywordMatch?: InputMaybe<ArrayMatchEnum>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  marketSegments?: InputMaybe<Array<MarketSegmentKeyEnum>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  /** Suite products slugs */
  products?: InputMaybe<Array<Scalars['ID']['input']>>
  publishedFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  publishedTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  purposeMatch?: InputMaybe<ArrayMatchEnum>
  purposes?: InputMaybe<Array<Scalars['String']['input']>>
  recommendationRatings?: InputMaybe<Array<RecommendationRatingKeyEnum>>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<ReviewsSearchSortingEnum>
}

export enum ReviewsSearchSortingEnum {
  Date = 'date',
  DateAsc = 'date_asc',
  Rating = 'rating',
  RatingAsc = 'rating_asc',
  Relevance = 'relevance',
  /** @deprecated Use relevance instead */
  WeightedScore = 'weighted_score',
}

export type SearchResult = {
  __typename?: 'SearchResult'
  agencies: Array<Agency>
  categories: Array<Category>
  pagination: Pagination
  products: Array<Product>
}

export enum SearchSortingEnum {
  Alphabetical = 'alphabetical',
  LowestPopularity = 'lowest_popularity',
  Popularity = 'popularity',
  Relevance = 'relevance',
  WeightedScore = 'weighted_score',
}

export type SectionScore = {
  __typename?: 'SectionScore'
  key: Scalars['String']['output']
  notes: Array<Scalars['String']['output']>
  rating: Scalars['Int']['output']
  reasoning: Scalars['String']['output']
}

export type SeoData = {
  __typename?: 'SeoData'
  bottomSectionBody?: Maybe<Scalars['String']['output']>
  bottomSectionHeadline?: Maybe<Scalars['String']['output']>
  canonicalTag?: Maybe<Scalars['String']['output']>
  h1?: Maybe<Scalars['String']['output']>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaNoindex: Scalars['Boolean']['output']
  metaTitle?: Maybe<Scalars['String']['output']>
  topSectionBody?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of SetLeadStatus */
export type SetLeadStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  status: LeadStatusEnum
}

/** Autogenerated return type of SetLeadStatus. */
export type SetLeadStatusPayload = {
  __typename?: 'SetLeadStatusPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  lead: ManageLead
}

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export type Survey = {
  __typename?: 'Survey'
  id: Scalars['ID']['output']
  sections: Array<SurveySection>
  surveyResponse?: Maybe<SurveyResponse>
}

export type SurveyResponse = {
  __typename?: 'SurveyResponse'
  answers?: Maybe<Array<Answer>>
  firstPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** @deprecated No longer used */
  incentive?: Maybe<Incentive>
  marketingConsentVisible: Scalars['Boolean']['output']
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  survey: Survey
}

export enum SurveyResponseKinds {
  Text = 'text',
  Video = 'video',
}

export enum SurveyResponseRejectedReasons {
  AiGenerated = 'ai_generated',
  FakePerson = 'fake_person',
  FakeToolUse = 'fake_tool_use',
  IncorrectCompany = 'incorrect_company',
  InsufficientChanges = 'insufficient_changes',
  Invalid = 'invalid',
  NegativeReview = 'negative_review',
  OfferExpired = 'offer_expired',
  PrivateUse = 'private_use',
  SelfReview = 'self_review',
  TooThin = 'too_thin',
}

export enum SurveyResponseReminderReminderTypes {
  Drafted = 'drafted',
  Old = 'old',
  Rejected = 'rejected',
  Stale = 'stale',
}

export enum SurveyResponseReminderStatuses {
  Queued = 'queued',
  Sent = 'sent',
}

export enum SurveyResponsesReminderStatusEnum {
  Blank = 'blank',
  SentAutomatic = 'sent_automatic',
  SentManual = 'sent_manual',
}

export type SurveyResponsesReminderStatusFacet = {
  __typename?: 'SurveyResponsesReminderStatusFacet'
  docCount: Scalars['Int']['output']
  key: SurveyResponsesReminderStatusEnum
}

export enum SurveyResponsesReplyStatusEnum {
  Blank = 'blank',
  Outdated = 'outdated',
  Sent = 'sent',
}

export type SurveyResponsesReplyStatusFacet = {
  __typename?: 'SurveyResponsesReplyStatusFacet'
  docCount: Scalars['Int']['output']
  key: SurveyResponsesReplyStatusEnum
}

export enum SurveyResponsesSortByEnum {
  Score = '_score',
  CreatedAt = 'created_at',
  RecommendationScore = 'recommendation_score',
  ReviewerCompany = 'reviewer_company',
  ReviewerName = 'reviewer_name',
  UpdatedAt = 'updated_at',
}

export enum SurveyResponsesStateEnum {
  Drafted = 'drafted',
  InRevision = 'in_revision',
  Proposed = 'proposed',
  Published = 'published',
  Rejected = 'rejected',
  Stale = 'stale',
}

export type SurveyResponsesStateFacet = {
  __typename?: 'SurveyResponsesStateFacet'
  docCount: Scalars['Int']['output']
  key: SurveyResponsesStateEnum
}

export enum SurveyResponsesViewEnum {
  All = 'all',
  Outdated = 'outdated',
  OutdatedRemindable = 'outdated_remindable',
}

export type SurveyResponsesViewFacet = {
  __typename?: 'SurveyResponsesViewFacet'
  docCount: Scalars['Int']['output']
  key: SurveyResponsesViewEnum
}

export type SurveySection = {
  __typename?: 'SurveySection'
  id: Scalars['ID']['output']
  parentSurveySection?: Maybe<SurveySection>
  position?: Maybe<Scalars['Int']['output']>
  questions?: Maybe<Array<Question>>
  sectionId: Scalars['ID']['output']
  sectionType?: Maybe<Scalars['String']['output']>
  sections?: Maybe<Array<SurveySection>>
  survey?: Maybe<Survey>
  title?: Maybe<Scalars['String']['output']>
}

export enum TitleIconEnum {
  AwardIcon = 'AwardIcon',
  BriefcaseBusinessIcon = 'BriefcaseBusinessIcon',
  Building2Icon = 'Building2Icon',
  ClockIcon = 'ClockIcon',
  CoinsIcon = 'CoinsIcon',
  HandshakeIcon = 'HandshakeIcon',
  RocketIcon = 'RocketIcon',
  UserIcon = 'UserIcon',
  UsersIcon = 'UsersIcon',
}

export type ToolPartner = {
  __typename?: 'ToolPartner'
  adpPosition: Scalars['Int']['output']
  agency: Agency
  id: Scalars['ID']['output']
  product: Product
  trustedPartner: Scalars['Boolean']['output']
}

/** Attributes for agency traits (USPs and certificates) */
export type TraitAttributes = {
  /** Set to true to delete this trait */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>
  descriptionTranslations?: InputMaybe<Array<TranslationAttributes>>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  titleTranslations?: InputMaybe<Array<TranslationAttributes>>
}

export type Translation = {
  __typename?: 'Translation'
  locale: Scalars['String']['output']
  value?: Maybe<Scalars['String']['output']>
}

export type TranslationAttributes = {
  locale: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** Autogenerated input type of UnarchiveLead */
export type UnarchiveLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UnarchiveLead. */
export type UnarchiveLeadPayload = {
  __typename?: 'UnarchiveLeadPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  lead: ManageLead
}

/** A per-answer validation error from processUniversalReview. */
export type UniversalAnswerError = {
  __typename?: 'UniversalAnswerError'
  errors: Array<Scalars['String']['output']>
  questionSlug: Scalars['String']['output']
  value?: Maybe<Scalars['String']['output']>
}

/** A single record reference held by an options_source-backed answer. */
export type UniversalAnswerRecordReference = {
  __typename?: 'UniversalAnswerRecordReference'
  label?: Maybe<Scalars['String']['output']>
  recordId: Scalars['ID']['output']
  recordType: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
}

/** A universal review across product, agency, and future subject types. */
export type UniversalReview = {
  __typename?: 'UniversalReview'
  anonymous: Scalars['Boolean']['output']
  answers?: Maybe<Array<ReviewAnswer>>
  aspectScores: Array<AspectScore>
  companyField?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companyPosition?: Maybe<Scalars['String']['output']>
  companySize?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentStatus: UniversalReviewStates
  firstPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  kind: UniversalReviewKinds
  locale: UniversalReviewLocales
  manualReminderDisabled?: Maybe<Scalars['Boolean']['output']>
  negative?: Maybe<Scalars['String']['output']>
  npsScore?: Maybe<Scalars['Int']['output']>
  positive?: Maybe<Scalars['String']['output']>
  problems?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedReason?: Maybe<UniversalReviewRejectedReasons>
  reminders?: Maybe<Array<UniversalReviewReminder>>
  reviewReply?: Maybe<ReviewReply>
  reviewerName?: Maybe<Scalars['String']['output']>
  statement?: Maybe<Scalars['String']['output']>
  subject: ReviewSubject
  title?: Maybe<Scalars['String']['output']>
}

/** A single (question_slug, value) pair submitted to processUniversalReview. */
export type UniversalReviewAnswerAttributes = {
  questionSlug: Scalars['String']['input']
  upload?: InputMaybe<Scalars['Upload']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export enum UniversalReviewKinds {
  Text = 'text',
  Video = 'video',
}

export enum UniversalReviewLocales {
  De = 'de',
  En = 'en',
}

export enum UniversalReviewRejectedReasons {
  AiGenerated = 'ai_generated',
  FakePerson = 'fake_person',
  FakeToolUse = 'fake_tool_use',
  IncorrectCompany = 'incorrect_company',
  InsufficientChanges = 'insufficient_changes',
  Invalid = 'invalid',
  NegativeReview = 'negative_review',
  OfferExpired = 'offer_expired',
  PrivateUse = 'private_use',
  SelfReview = 'self_review',
  TooThin = 'too_thin',
}

export type UniversalReviewReminder = {
  __typename?: 'UniversalReviewReminder'
  id: Scalars['ID']['output']
  kind: UniversalReviewReminderKinds
  message?: Maybe<Scalars['String']['output']>
  scheduledFor: Scalars['ISO8601DateTime']['output']
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export enum UniversalReviewReminderKinds {
  AutomaticDraft = 'automatic_draft',
  Manual = 'manual',
  PostPublishUpdate = 'post_publish_update',
  StaleWarning = 'stale_warning',
}

export enum UniversalReviewStates {
  Depublished = 'depublished',
  Drafted = 'drafted',
  InRevision = 'in_revision',
  Proposed = 'proposed',
  Published = 'published',
  Rejected = 'rejected',
  Stale = 'stale',
}

export type UniversalReviewStatusFacet = {
  __typename?: 'UniversalReviewStatusFacet'
  docCount: Scalars['Int']['output']
  key: UniversalReviewStates
}

export type UniversalReviewsSearchFilters = {
  aspectMatch?: InputMaybe<ArrayMatchEnum>
  aspects?: InputMaybe<Array<AspectFilter>>
  locale?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  publishedFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  publishedTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  recommendationRatings?: InputMaybe<Array<Scalars['Int']['input']>>
  sortBy?: InputMaybe<UniversalReviewsSearchSortingEnum>
}

export enum UniversalReviewsSearchSortingEnum {
  Date = 'date',
  DateAsc = 'date_asc',
  Rating = 'rating',
  RatingAsc = 'rating_asc',
}

/** Resolved survey for a (subject, reviewer) plus any existing draft/published review. */
export type UniversalSurveyForSubjectPayload = {
  __typename?: 'UniversalSurveyForSubjectPayload'
  review?: Maybe<UniversalReview>
  survey: RenderedSurvey
}

/** Autogenerated input type of UnwatchSubject */
export type UnwatchSubjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Numeric id or slug of the subject. */
  subjectId: Scalars['ID']['input']
  subjectType: MutationsWatchItemBaseMutationSubjects
}

/** Autogenerated return type of UnwatchSubject. */
export type UnwatchSubjectPayload = {
  __typename?: 'UnwatchSubjectPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The removed item, null when the subject was not watched. */
  watchItem?: Maybe<WatchItem>
}

/** Autogenerated input type of UpdateAgency */
export type UpdateAgencyInput = {
  attributes: ManageAgencyAttributes
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateAgency. */
export type UpdateAgencyPayload = {
  __typename?: 'UpdateAgencyPayload'
  agency?: Maybe<Agency>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateBudget */
export type UpdateBudgetInput = {
  additionalValue: Scalars['Float']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated input type of UpdateCompanySlug */
export type UpdateCompanySlugInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  new?: InputMaybe<Scalars['String']['input']>
  old: Scalars['String']['input']
}

/** Autogenerated return type of UpdateCompanySlug. */
export type UpdateCompanySlugPayload = {
  __typename?: 'UpdateCompanySlugPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of Update */
export type UpdateInput = {
  attachableId?: InputMaybe<Scalars['GlobalId']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  screenshotAttributes: Array<AssetAttributes>
}

/** Autogenerated return type of Update. */
export type UpdatePayload = {
  __typename?: 'UpdatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** All record screenshots after mutation */
  screenshots?: Maybe<Array<Asset>>
}

/** Autogenerated input type of UpdateProductDescription */
export type UpdateProductDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  descriptionDe: Scalars['String']['input']
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateProductDescription. */
export type UpdateProductDescriptionPayload = {
  __typename?: 'UpdateProductDescriptionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors?: Maybe<Array<Scalars['String']['output']>>
}

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInput = {
  attributes: ProductAttributes
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateProduct. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  product?: Maybe<Product>
}

export type VendorAgencies = {
  __typename?: 'VendorAgencies'
  agenciesSlugs?: Maybe<Array<Scalars['String']['output']>>
  agencyCategoriesSlugs?: Maybe<Array<Scalars['String']['output']>>
  productsMainCategorySlugs?: Maybe<Array<Scalars['String']['output']>>
  productsSlugs?: Maybe<Array<Scalars['String']['output']>>
  vendorSlug: Scalars['String']['output']
}

export type VendorMapper = {
  __typename?: 'VendorMapper'
  id?: Maybe<Scalars['ID']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export type VendorProducts = {
  __typename?: 'VendorProducts'
  categorySlugs?: Maybe<Array<Scalars['String']['output']>>
  mainCategoryId?: Maybe<Scalars['Int']['output']>
  productBadgeSlugs?: Maybe<Array<Scalars['String']['output']>>
  productSlugs: Array<Scalars['String']['output']>
  trialPhaseUntil?: Maybe<Scalars['ISO8601DateTime']['output']>
  vendorSlug: Scalars['String']['output']
}

export type VendorProductsResult = {
  __typename?: 'VendorProductsResult'
  agencyCategoryMapper: Array<VendorMapper>
  agencyMapper: Array<VendorMapper>
  basicReportAgencies: Array<VendorAgencies>
  basicReportProducts: Array<VendorProducts>
  categoryMapper: Array<VendorMapper>
  extendedReportAgencies: Array<VendorAgencies>
  extendedReportProducts: Array<VendorProducts>
  productBadgeMapper: Array<VendorMapper>
  productMapper: Array<VendorMapper>
  /** @deprecated Use basicReportProducts and extendedReportProducts instead */
  products: Array<VendorProducts>
}

export type VersusProduct = {
  __typename?: 'VersusProduct'
  /** @deprecated Use productSlug instead */
  productId: Scalars['String']['output']
  productSlug: Scalars['ID']['output']
  seoData?: Maybe<SeoData>
  updatedAt: Scalars['ISO8601DateTime']['output']
  /** @deprecated Use versusSlug instead */
  versusId: Scalars['String']['output']
  versusSlug: Scalars['ID']['output']
}

export type VersusProductSitemapEntry = {
  __typename?: 'VersusProductSitemapEntry'
  metaNoindex: Scalars['Boolean']['output']
  productSlug: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  versusSlug: Scalars['ID']['output']
}

export type VersusProductsResult = {
  __typename?: 'VersusProductsResult'
  pagination: Pagination
  versusProducts: Array<VersusProduct>
}

export type Vote = {
  __typename?: 'Vote'
  createdAt: Scalars['ISO8601DateTime']['output']
  downvoteReason?: Maybe<Scalars['String']['output']>
  errors?: Maybe<Array<FieldError>>
  id: Scalars['ID']['output']
  vote: ProductReviewSummaryVoteVoteEnum
}

export type WatchItem = {
  __typename?: 'WatchItem'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  sourceSurface: WatchItemSourceSurfaces
  subject: ReviewSubject
}

export enum WatchItemSourceSurfaces {
  AssistantResults = 'assistant_results',
  CategoryList = 'category_list',
  Pdp = 'pdp',
  Profile = 'profile',
}

/** Autogenerated input type of WatchSubject */
export type WatchSubjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  sourceSurface: WatchItemSourceSurfaces
  /** Numeric id or slug of the subject. */
  subjectId: Scalars['ID']['input']
  subjectType: MutationsWatchItemBaseMutationSubjects
}

/** Autogenerated return type of WatchSubject. */
export type WatchSubjectPayload = {
  __typename?: 'WatchSubjectPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  watchItem: WatchItem
}

export type AgencyBasicFieldsFragment = {
  __typename: 'Agency'
  id: string
  globalId: string
  title: string
  slug: string
  shortDescription?: string | null
  remote: boolean
  locations: Array<{ __typename?: 'Location'; id: string; city?: string | null; citySlug?: string | null }>
  traits: Array<{ __typename?: 'AgencyTrait' } & AgencyTraitFieldsFragment>
  logo?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  assignedFeatures: Array<{
    __typename?: 'AgencyAssignedFeature'
    id?: string | null
    position: number
    feature: {
      __typename?: 'AgencyFeature'
      id: string
      name: string
      category?: { __typename?: 'Category'; id: string; title: string } | null
    }
  }>
  assignedIndustries: Array<{
    __typename?: 'AgencyAssignedIndustry'
    id?: string | null
    position: number
    industry: { __typename?: 'Industry'; id: string; name: string }
  }>
}

export type AgencyConfigFieldsFragment = {
  __typename?: 'AgencyConfig'
  badgesAdminCalculated: DealAgencyPlanBadgesEnum
  certificatesUspsAdminCalculated: DealAgencyPlanCertificatesUspsEnum
  ctaPrimaryAdminCalculated: DealAgencyPlanCtaPrimaryEnum
  ctaPrimaryCached: AgencyConfigCtaPrimaryCachedEnum
  ctaSecondaryAdminCalculated: DealAgencyPlanCtaSecondaryEnum
  ctaSecondaryCached: AgencyConfigCtaSecondaryCachedEnum
  descriptionLongAdminCalculated: DealAgencyPlanDescriptionLongEnum
  documentsAdminCalculated: DealAgencyPlanDocumentsEnum
  heroImageAdminCalculated: DealAgencyPlanHeroImageEnum
  heroImageCached: AgencyConfigHeroImageCachedEnum
  pageVisitReportsCached: AgencyConfigPageVisitReportsCachedEnum
  portfolioAdminCalculated: DealAgencyPlanPortfolioEnum
  socialLinksAdminCalculated: DealAgencyPlanSocialLinksEnum
  widgetsAdminCalculated: DealAgencyPlanWidgetsEnum
}

export type AgencyDetailsFieldsFragment = {
  __typename?: 'Agency'
  twitter?: string | null
  linkedin?: string | null
  contactFormRecipients?: Array<string> | null
  assignedBadges: Array<{ __typename?: 'AssignedBadge' } & AssignedBadgeFieldsFragment>
  expiredAssignedBadges: Array<{ __typename?: 'AssignedBadge' } & AssignedBadgeFieldsFragment>
  toolPartners: Array<{
    __typename?: 'ToolPartner'
    id: string
    adpPosition: number
    product: { __typename?: 'Product' } & ProductBasicDataFragment
  }>
  hero?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  heroVideoThumbnail?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
  categories: Array<{ __typename?: 'Category'; id: string; slug: string; title: string; hidden: boolean; published: boolean }>
  descriptionTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  shortDescriptionTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  urlTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  linkTextTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  ctaSecondary?: { __typename?: 'Link'; label?: string | null; url: string } | null
  ctaSecondaryLabelTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  ctaSecondaryUrlTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  documents: Array<
    {
      __typename?: 'Asset'
      errors?: Array<{ __typename?: 'FieldError'; field: string; message: string; value?: string | null }> | null
    } & DocumentFieldsFragment
  >
  screenshots: Array<
    {
      __typename?: 'Asset'
      errors?: Array<{ __typename?: 'FieldError'; field: string; message: string; value?: string | null }> | null
    } & ScreenshotFieldsFragment
  >
} & AgencyBasicFieldsFragment

export type AgencyTraitFieldsFragment = {
  __typename?: 'AgencyTrait'
  id: string
  kind: AgencyTraitKindEnum
  description?: string | null
  title?: string | null
  position: number
  descriptionTranslations?: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }> | null
  titleTranslations?: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }> | null
}

export type AssetFieldsFragment = { __typename?: 'Asset'; name: string; size: number; url: string; contentType: string }

export type AssignedBadgeFieldsFragment = {
  __typename?: 'AssignedBadge'
  id: string
  timeframe?: string | null
  badgeType: string
  badgeName: string
  url?: string | null
  category?: { __typename?: 'Category'; displayOrTitle: string } | null
}

export type CampaignFieldsFragment = {
  __typename?: 'Campaign'
  amount?: number | null
  amountPublic?: boolean | null
  available?: boolean | null
  budgetLimit?: number | null
  createdAt?: string | null
  description?: string | null
  enabled?: boolean | null
  hashValue?: string | null
  id?: string | null
  incentivizationType?: IncentivizationCampaignIncentivizationTypeEnum | null
  incentivizationsLimit?: number | null
  kind?: string | null
  limitType?: IncentivizationCampaignLimitTypeEnum | null
  lostIncentivizationsCount?: number | null
  requestedIncentivizationsCount?: number | null
  status?: IncentivizationCampaignStatusEnum | null
  title?: string | null
  totalIncentivizationsCount?: number | null
  updatedAt?: string | null
  validFrom?: any | null
  validTo?: any | null
  wonIncentivizationsCount?: number | null
  descriptionTranslations: Array<{ __typename?: 'Translation' } & TranslationFieldsFragment>
  personalizations?: Array<{ __typename?: 'Personalization' } & CampaignPersonalisationFieldsFragment> | null
}

export type CampaignPersonalisationFieldsFragment = {
  __typename?: 'Personalization'
  createdAt?: string | null
  hashValue?: string | null
  id?: string | null
  inviteMessage: string
  locale: IncentivizationCampaignPersonalizationLocaleEnum
  lostIncentivizationsCount: number
  requestedIncentivizationsCount: number
  totalIncentivizationsCount: number
  updatedAt?: string | null
  wonIncentivizationsCount: number
}

export type DocumentFieldsFragment = {
  __typename?: 'Asset'
  id?: string | null
  name: string
  filename: string
  size: number
  url: string
  previewUrl?: string | null
  previewFilename?: string | null
  contentType: string
  position?: number | null
  nameTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
}

export type FieldErrorFieldsFragment = { __typename?: 'FieldError'; field: string; message: string; value?: string | null }

export type ProductBasicDataFragment = {
  __typename?: 'Product'
  id: string
  globalId: string
  slug: string
  title: string
  isSuite: boolean
  publishedAt?: string | null
  averageRecommendationRating?: number | null
  reviewCount: number
  assignedBadges: Array<{ __typename?: 'AssignedBadge' } & AssignedBadgeFieldsFragment>
  expiredAssignedBadges: Array<{ __typename?: 'AssignedBadge' } & AssignedBadgeFieldsFragment>
  logo?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
}

export type ProductConfigFieldsFragment = {
  __typename?: 'ProductConfig'
  badgesAdminCalculated: DealProductPlanBadgesEnum
  ctaCustomQuoteAdminCalculated: DealProductPlanCtaCustomQuoteEnum
  ctaCustomQuoteCached: ProductConfigCtaCustomQuoteCachedEnum
  ctaCustomQuoteVendor: ProductConfigCtaCustomQuoteVendorEnum
  ctaCustomQuoteVendorPossibleOptions: Array<string>
  ctaPrimaryAdminCalculated: DealProductPlanCtaPrimaryEnum
  ctaPrimaryCached: ProductConfigCtaPrimaryCachedEnum
  ctaPrimaryVendor: ProductConfigCtaPrimaryVendorEnum
  ctaPrimaryVendorPossibleOptions: Array<string>
  ctaSecondaryAdminCalculated: DealProductPlanCtaSecondaryEnum
  ctaSecondaryCached: ProductConfigCtaSecondaryCachedEnum
  ctaSecondaryVendor: ProductConfigCtaSecondaryVendorEnum
  ctaSecondaryVendorPossibleOptions: Array<string>
  downloadsFileUploadAdminCalculated: DealProductPlanDownloadsFileUploadEnum
  heroImageAdminCalculated: DealProductPlanHeroImageEnum
  heroImageCached: ProductConfigHeroImageCachedEnum
  heroImageVendor: ProductConfigHeroImageVendorEnum
  heroImageVendorPossibleOptions: Array<string>
  pageVisitReportsAdminCalculated: DealProductPlanPageVisitReportsEnum
  pageVisitReportsCached: ProductConfigPageVisitReportsCachedEnum
  pricingDisclaimerLinkCached: ProductConfigPricingDisclaimerLinkCachedEnum
  profileClaimedAdminCalculated: DealProductPlanProfileClaimedEnum
  profileClaimedCached: ProductConfigProfileClaimedCachedEnum
  profileClaimedVendor: ProductConfigProfileClaimedVendorEnum
  profileClaimedVendorPossibleOptions: Array<string>
  reviewRemindersAllowedCached: ProductConfigReviewRemindersAllowedCachedEnum
  reviewRepliesAllowedAdminCalculated: DealProductPlanReviewRepliesAllowedEnum
  reviewRepliesAllowedCached: ProductConfigReviewRepliesAllowedCachedEnum
  reviewRepliesAllowedVendor: ProductConfigReviewRepliesAllowedVendorEnum
  reviewRepliesAllowedVendorPossibleOptions: Array<string>
  socialLinksAdminCalculated: DealProductPlanSocialLinksEnum
  socialLinksCached: ProductConfigSocialLinksCachedEnum
  socialLinksVendor: ProductConfigSocialLinksVendorEnum
  widgetsAdminCalculated: DealProductPlanWidgetsEnum
}

export type ProductPricingPlanFragment = {
  __typename?: 'PricingPlan'
  billingPeriod?: string | null
  description?: string | null
  name?: string | null
  id?: string | null
  position?: number | null
  priceCents?: number | null
  priceCurrency?: string | null
  priceCurrencySymbol?: string | null
  priceTextValue?: string | null
  pricingSubscriptionModeId?: string | null
  pricingTextOptionId?: string | null
  promoted: boolean
  promotedLabel?: PromotedLabelEnum | null
  startingPrice: boolean
  titleIcon?: TitleIconEnum | null
  descriptionTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  nameTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
  perksTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
}

export type ScreenshotFieldsFragment = {
  __typename?: 'Asset'
  id?: string | null
  name: string
  size: number
  url: string
  contentType: string
}

export type TranslationFieldsFragment = { __typename?: 'Translation'; locale: string; value?: string | null }

export type AddReviewsLeadNoteMutationVariables = Exact<{
  leadId: Scalars['ID']['input']
  body: Scalars['String']['input']
}>

export type AddReviewsLeadNoteMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    addLeadNote?: {
      __typename?: 'AddLeadNotePayload'
      note: { __typename?: 'LeadNote'; id: string; authorName?: string | null; body: string; createdAt: string }
    } | null
  }
}

export type ArchiveReviewsLeadMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ArchiveReviewsLeadMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    archiveLead?: { __typename?: 'ArchiveLeadPayload'; lead: { __typename?: 'ManageLead'; id: string; archivedAt?: string | null } } | null
  }
}

export type CreateReviewsCampaignMutationVariables = Exact<{
  productId: Scalars['ID']['input']
  attributes: CampaignAttributes
}>

export type CreateReviewsCampaignMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    createCampaign: {
      __typename?: 'Campaign'
      errors?: Array<{ __typename?: 'FieldError' } & FieldErrorFieldsFragment> | null
      personalizations?: Array<
        {
          __typename?: 'Personalization'
          errors?: Array<{ __typename?: 'FieldError' } & FieldErrorFieldsFragment> | null
        } & CampaignPersonalisationFieldsFragment
      > | null
    } & CampaignFieldsFragment
  }
}

export type CreateReviewsCampaignPersonalizationMutationVariables = Exact<{
  campaign: Scalars['ID']['input']
  attributes: PersonalizationAttributes
}>

export type CreateReviewsCampaignPersonalizationMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    createCampaignPersonalization: {
      __typename?: 'Personalization'
      errors?: Array<{ __typename?: 'FieldError' } & FieldErrorFieldsFragment> | null
    } & CampaignPersonalisationFieldsFragment
  }
}

export type CreateReviewsEntityDocumentMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  documentAttributes: AssetAttributes
}>

export type CreateReviewsEntityDocumentMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; createDocument: Array<{ __typename?: 'Asset'; id?: string | null }> }
}

export type CreateReviewsEntityScreenshotMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  screenshotAttributes: AssetAttributes
}>

export type CreateReviewsEntityScreenshotMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; createScreenshot?: { __typename?: 'CreatePayload'; clientMutationId?: string | null } | null }
}

export type CreateSurveyResponseReminderMutationVariables = Exact<{
  input: CreateSurveyResponseReminderInput
}>

export type CreateSurveyResponseReminderMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    createSurveyResponseReminder?: { __typename?: 'ManageSurveyResponseReminder'; id: string } | null
  }
}

export type CreateSurveyResponseRemindersMutationVariables = Exact<{
  input: CreateSurveyResponseRemindersInput
}>

export type CreateSurveyResponseRemindersMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    createSurveyResponseReminders?: {
      __typename?: 'ManageCreateSurveyResponseRemindersResult'
      failedCount: number
      successCount: number
    } | null
  }
}

export type CreateUniversalReviewReminderMutationVariables = Exact<{
  input: CreateUniversalReviewReminderInput
}>

export type CreateUniversalReviewReminderMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    createUniversalReviewReminder?: {
      __typename?: 'UniversalReviewReminder'
      id: string
      kind: UniversalReviewReminderKinds
      message?: string | null
      sentAt?: string | null
      userId?: number | null
    } | null
  }
}

export type DeleteCampaignPersonalizationMutationVariables = Exact<{
  campaignPersonalization: Scalars['ID']['input']
}>

export type DeleteCampaignPersonalizationMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; deleteCampaignPersonalization: { __typename?: 'Personalization'; id?: string | null } }
}

export type DeleteReviewReplyMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteReviewReplyMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; deleteReviewReply?: { __typename?: 'ReviewReply'; id?: string | null } | null }
}

export type DeleteReviewsEntityDocumentsMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type DeleteReviewsEntityDocumentsMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; deleteDocuments: Array<{ __typename?: 'Asset'; id?: string | null }> }
}

export type DeleteReviewsEntityScreenshotsMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type DeleteReviewsEntityScreenshotsMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; deleteScreenshots?: { __typename?: 'DeletePayload'; clientMutationId?: string | null } | null }
}

export type SetReviewsLeadStatusMutationVariables = Exact<{
  id: Scalars['ID']['input']
  status: LeadStatusEnum
}>

export type SetReviewsLeadStatusMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    setLeadStatus?: { __typename?: 'SetLeadStatusPayload'; lead: { __typename?: 'ManageLead'; id: string } } | null
  }
}

export type UnarchiveReviewsLeadMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UnarchiveReviewsLeadMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    unarchiveLead?: {
      __typename?: 'UnarchiveLeadPayload'
      lead: { __typename?: 'ManageLead'; id: string; archivedAt?: string | null }
    } | null
  }
}

export type UpdateReviewsAgencyMutationVariables = Exact<{
  id: Scalars['ID']['input']
  attributes: ManageAgencyAttributes
}>

export type UpdateReviewsAgencyMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    updateAgency?: {
      __typename?: 'UpdateAgencyPayload'
      agency?:
        | ({
            __typename?: 'Agency'
            errors?: Array<{ __typename?: 'FieldError'; field: string; message: string; value?: string | null }> | null
          } & AgencyDetailsFieldsFragment)
        | null
    } | null
  }
}

export type UpdateReviewsCampaignMutationVariables = Exact<{
  campaign: Scalars['ID']['input']
  attributes: CampaignAttributes
}>

export type UpdateReviewsCampaignMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    updateCampaign: {
      __typename?: 'Campaign'
      errors?: Array<{ __typename?: 'FieldError' } & FieldErrorFieldsFragment> | null
    } & CampaignFieldsFragment
  }
}

export type UpdateReviewsCampaignPersonalizationMutationVariables = Exact<{
  campaignPersonalization: Scalars['ID']['input']
  attributes: PersonalizationAttributes
}>

export type UpdateReviewsCampaignPersonalizationMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    updateCampaignPersonalization: {
      __typename?: 'Personalization'
      id?: string | null
      inviteMessage: string
      locale: IncentivizationCampaignPersonalizationLocaleEnum
      hashValue?: string | null
      errors?: Array<{ __typename?: 'FieldError' } & FieldErrorFieldsFragment> | null
    }
  }
}

export type UpdateReviewsEntityDocumentsMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  documentAttributes: Array<AssetAttributes> | AssetAttributes
}>

export type UpdateReviewsEntityDocumentsMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; updateDocuments: Array<{ __typename?: 'Asset'; id?: string | null }> }
}

export type UpdateReviewsEntityScreenshotsMutationVariables = Exact<{
  attachableId: Scalars['GlobalId']['input']
  screenshotAttributes: Array<AssetAttributes> | AssetAttributes
}>

export type UpdateReviewsEntityScreenshotsMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; updateScreenshots?: { __typename?: 'UpdatePayload'; clientMutationId?: string | null } | null }
}

export type UpdateReviewsProductMutationVariables = Exact<{
  id: Scalars['ID']['input']
  attributes: ProductAttributes
}>

export type UpdateReviewsProductMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    updateProduct?: { __typename?: 'UpdateProductPayload'; clientMutationId?: string | null } | null
  }
}

export type UpdateReviewsProductWithPricingPlansMutationVariables = Exact<{
  id: Scalars['ID']['input']
  attributes: ProductAttributes
  pricing: ChangePricingPlansInput
}>

export type UpdateReviewsProductWithPricingPlansMutation = {
  __typename?: 'Mutation'
  manage: {
    __typename?: 'ManageMutation'
    updateProduct?: { __typename?: 'UpdateProductPayload'; clientMutationId?: string | null } | null
    changePricingPlans?: Array<{ __typename?: 'PricingPlan'; name?: string | null }> | null
  }
}

export type UpsertReviewReplyMutationVariables = Exact<{
  notifyReviewer?: InputMaybe<Scalars['Boolean']['input']>
  personalized?: InputMaybe<Scalars['Boolean']['input']>
  reply: Scalars['String']['input']
  reviewId?: InputMaybe<Scalars['ID']['input']>
  universalReviewId?: InputMaybe<Scalars['ID']['input']>
}>

export type UpsertReviewReplyMutation = {
  __typename?: 'Mutation'
  manage: { __typename?: 'ManageMutation'; upsertReviewReply?: { __typename?: 'ReviewReply'; id?: string | null } | null }
}

export type BuyerInsightsQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  period?: InputMaybe<ManageInsightsPeriodPreset>
}>

export type BuyerInsightsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    insights: {
      __typename?: 'ManageInsightsBatchResult'
      results: Array<{
        __typename?: 'ManageInsightsItemResult'
        metric: string
        status: number
        error?: string | null
        response?:
          | { __typename: 'ManageInsightsAttributeIndexCompositeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeIndexResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeSentimentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBadgeProgressResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBenchmarkTiersResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByMonthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByWeekResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCampaignPerformanceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryDemandResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryFunnelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationEnginesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationSourcesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsClickoutRateResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsClickoutRateRow'
                period?: any | null
                pageviewsEstimated?: number | null
                clickouts?: number | null
              }>
            }
          | { __typename: 'ManageInsightsCompetitorDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCovisitationResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetectionTrendsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNewEntrantsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNpsBySegmentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPositionMentionsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingLandscapeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingPositionResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankTrackingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingByYearResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingHistoryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingMonthlyResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingSummaryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecurringVisitorShareResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewFreshnessResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewerMixResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSegmentedRatingsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentByEngineResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentKeywordsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfModelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceWindowResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesLifetimeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsVisitingCompaniesResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{ __typename?: 'ManageInsightsVisitingCompaniesRow'; period?: any | null; demaskedCompanies?: number | null }>
            }
          | { __typename: 'ManageInsightsVisitorReviewerGapResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVsCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | null
      }>
    }
  } | null
}

export type CompetitionInsightsQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  categorySlug: Scalars['String']['input']
  period?: InputMaybe<ManageInsightsPeriodPreset>
  window: ManageInsightsWindowKey
  shareOfVoiceStart: Scalars['ISO8601Date']['input']
  shareOfVoiceEnd: Scalars['ISO8601Date']['input']
  covisitationStart: Scalars['ISO8601Date']['input']
  covisitationEnd: Scalars['ISO8601Date']['input']
}>

export type CompetitionInsightsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    insights: {
      __typename?: 'ManageInsightsBatchResult'
      results: Array<{
        __typename?: 'ManageInsightsItemResult'
        metric: string
        status: number
        error?: string | null
        response?:
          | { __typename: 'ManageInsightsAttributeIndexCompositeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsAttributeIndexResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsAttributeIndexRow'
                attribute?: string | null
                positiveShare?: number | null
                categoryAvgPositiveShare?: number | null
                totalMentions?: number | null
                attrRank?: number | null
              }>
            }
          | { __typename: 'ManageInsightsAttributeSentimentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBadgeProgressResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsBenchmarkTiersResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsBenchmarkTiersRow'
                period?: any | null
                measureValue?: number | null
                tier1Avg?: number | null
                categoryMedian?: number | null
              }>
            }
          | { __typename: 'ManageInsightsByMonthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByWeekResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCampaignPerformanceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryDemandResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryFunnelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationEnginesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationSourcesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsClickoutRateResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCompetitorDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsCovisitationResponse'
              truncated: boolean
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsCovisitationRow'
                period?: any | null
                competitorSlug?: string | null
                covisitingSessions?: number | null
                comparingSessions?: number | null
              }>
            }
          | { __typename: 'ManageInsightsDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetectionTrendsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNewEntrantsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNpsBySegmentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPositionMentionsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsPricingLandscapeResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              entity?: { __typename?: 'ManageInsightsEntityRef'; id: string } | null
              rows: Array<{
                __typename?: 'ManageInsightsPricingLandscapeRow'
                priceDecile?: number | null
                avgEntryPriceMonthlyEur?: number | null
                minEntryPriceMonthlyEur?: number | null
                maxEntryPriceMonthlyEur?: number | null
                productsInCategoryCount?: number | null
                productsInDecile?: number | null
              }>
            }
          | {
              __typename: 'ManageInsightsPricingPositionResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsPricingPositionRow'
                entryPriceMonthlyEur?: number | null
                priceDecile?: number | null
                primaryCategorySlug?: string | null
              }>
            }
          | { __typename: 'ManageInsightsRankTrackingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingByYearResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingHistoryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingMonthlyResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingSummaryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecurringVisitorShareResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewFreshnessResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewerMixResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSegmentedRatingsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentByEngineResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentKeywordsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfModelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsShareOfVoiceCompetitorsResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsShareOfVoiceCompetitorRow'
                toolSlug?: string | null
                toolPageviews?: number | null
              }>
            }
          | {
              __typename: 'ManageInsightsShareOfVoiceResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsShareOfVoiceRow'
                period?: any | null
                categoryPageviews?: number | null
                toolsWithTraffic?: number | null
              }>
            }
          | {
              __typename: 'ManageInsightsShareOfVoiceWindowResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsShareOfVoiceWindowRow'
                toolPageviews?: number | null
                categoryPageviews?: number | null
                sovPageviews?: number | null
                previousSovPageviews?: number | null
                previousComplete?: boolean | null
              }>
            }
          | { __typename: 'ManageInsightsToolReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesLifetimeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitingCompaniesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitorReviewerGapResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVsCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | null
      }>
    }
  } | null
}

export type InsightsCategoryTopTenQueryVariables = Exact<{
  categorySlug: Scalars['ID']['input']
}>

export type InsightsCategoryTopTenQuery = {
  __typename?: 'Query'
  exploreProducts?: {
    __typename?: 'ExploreProductsResult'
    products: Array<{
      __typename?: 'Product'
      slug: string
      title: string
      reviewCount: number
      averageRecommendationRating?: number | null
      logo?: { __typename?: 'Asset'; url: string } | null
    }>
  } | null
}

export type InsightsProductsBySlugsQueryVariables = Exact<{
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type InsightsProductsBySlugsQuery = {
  __typename?: 'Query'
  listProducts: Array<{
    __typename?: 'Product'
    slug: string
    title: string
    reviewCount: number
    averageRecommendationRating?: number | null
    logo?: { __typename?: 'Asset'; url: string } | null
  }>
}

export type MarketInsightsQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  entityId: Scalars['String']['input']
  period?: InputMaybe<ManageInsightsPeriodPreset>
  startDate: Scalars['ISO8601Date']['input']
  endDate: Scalars['ISO8601Date']['input']
}>

export type MarketInsightsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    insights: {
      __typename?: 'ManageInsightsBatchResult'
      results: Array<{
        __typename?: 'ManageInsightsItemResult'
        metric: string
        status: number
        error?: string | null
        response?:
          | { __typename: 'ManageInsightsAttributeIndexCompositeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeIndexResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeSentimentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBadgeProgressResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBenchmarkTiersResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByMonthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByWeekResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCampaignPerformanceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsCategoryDemandResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsCategoryDemandRow'
                period?: any | null
                sessions?: number | null
                sessionsDeltaPrev?: number | null
                pageviewsEstimated?: number | null
                pageviewsEstimatedDeltaPrev?: number | null
                toolsWithTraffic?: number | null
                toolsWithTrafficDeltaPrev?: number | null
              }>
            }
          | { __typename: 'ManageInsightsCategoryFunnelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationEnginesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationSourcesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsClickoutRateResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCompetitorDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCovisitationResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetectionTrendsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsNewEntrantsResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsNewEntrantsRow'
                toolSlug?: string | null
                entryVia?: string | null
                entryMonth?: any | null
                enteredViaReview?: boolean | null
                enteredViaTraffic?: boolean | null
              }>
            }
          | { __typename: 'ManageInsightsNpsBySegmentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPositionMentionsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingLandscapeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingPositionResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsRankTrackingResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              window?: { __typename?: 'ManageInsightsPeriod'; start?: any | null } | null
              rows: Array<{ __typename?: 'ManageInsightsRankTrackingRow'; period?: any | null; rankInCategory?: number | null }>
            }
          | { __typename: 'ManageInsightsRankingByYearResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingHistoryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingMonthlyResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingSummaryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecurringVisitorShareResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewFreshnessResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsReviewGrowthResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsReviewGrowthRow'
                period?: any | null
                newReviews?: number | null
                newReviewsDeltaPrev?: number | null
                cumulativeReviews?: number | null
              }>
            }
          | { __typename: 'ManageInsightsReviewerMixResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSegmentedRatingsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentByEngineResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentKeywordsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfModelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceWindowResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesLifetimeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitingCompaniesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitorReviewerGapResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVsCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | null
      }>
    }
  } | null
}

export type ReviewsAgenciesQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsAgenciesQuery = {
  __typename?: 'Query'
  manage?: { __typename?: 'ManageQuery'; agencies?: Array<{ __typename?: 'Agency' } & AgencyBasicFieldsFragment> | null } | null
}

export type ReviewsAgencyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsAgencyByIdQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    agency: { __typename?: 'Agency'; config: { __typename?: 'AgencyConfig' } & AgencyConfigFieldsFragment } & AgencyDetailsFieldsFragment
  } | null
}

export type ReviewsAgencyFeaturesQueryVariables = Exact<{
  categories: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ReviewsAgencyFeaturesQuery = {
  __typename?: 'Query'
  agencyFeatures?: Array<{
    __typename?: 'AgencyFeature'
    id: string
    name: string
    category?: { __typename?: 'Category'; id: string; title: string } | null
  }> | null
}

export type ReviewsAgencyOptionsQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsAgencyOptionsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    options: {
      __typename?: 'ManageOptions'
      cities: Array<{ __typename?: 'City'; name?: string | null; slug?: string | null }>
      industries: Array<{ __typename?: 'Industry'; id: string; name: string }>
    }
  } | null
}

export type ReviewsAgencyToolPartnerOptionsQueryVariables = Exact<{
  page?: Scalars['Int']['input']
  perPage?: Scalars['Int']['input']
  sortBy?: ExploreProductsSortingEnum
  searchTerm?: InputMaybe<Scalars['String']['input']>
  exclude?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ReviewsAgencyToolPartnerOptionsQuery = {
  __typename?: 'Query'
  exploreProducts?: {
    __typename?: 'ExploreProductsResult'
    pagination: { __typename?: 'Pagination'; currentPage: number; hasNextPage: boolean }
    products: Array<{ __typename?: 'Product' } & ProductBasicDataFragment>
  } | null
}

export type ReviewsAgencyUniversalReviewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsAgencyUniversalReviewQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    universalReview: {
      __typename?: 'UniversalReview'
      id: string
      currentStatus: UniversalReviewStates
      anonymous: boolean
      reviewerName?: string | null
      companyField?: string | null
      companyName?: string | null
      companyPosition?: string | null
      companySize?: string | null
      title?: string | null
      statement?: string | null
      npsScore?: number | null
      publishedAt?: string | null
      firstPublishedAt?: string | null
      createdAt: string
      manualReminderDisabled?: boolean | null
      reminders?: Array<{
        __typename?: 'UniversalReviewReminder'
        id: string
        kind: UniversalReviewReminderKinds
        message?: string | null
        sentAt?: string | null
        userId?: number | null
      }> | null
      reviewReply?: {
        __typename?: 'ReviewReply'
        id?: string | null
        personalized?: boolean | null
        reply: string
        senderName?: string | null
      } | null
    }
  } | null
}

export type ReviewsAgencyUniversalReviewsQueryVariables = Exact<{
  subjectId: Scalars['GlobalId']['input']
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<ManageUniversalReviewsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  filters?: InputMaybe<ManageUniversalReviewsSearchFilters>
}>

export type ReviewsAgencyUniversalReviewsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    universalReviews: {
      __typename?: 'ManageExploreUniversalReviews'
      reviews: Array<{
        __typename?: 'UniversalReview'
        id: string
        currentStatus: UniversalReviewStates
        createdAt: string
        publishedAt?: string | null
        firstPublishedAt?: string | null
        anonymous: boolean
        reviewerName?: string | null
        companyName?: string | null
        npsScore?: number | null
        reminders?: Array<{ __typename?: 'UniversalReviewReminder'; id: string }> | null
        reviewReply?: { __typename?: 'ReviewReply'; id?: string | null } | null
      }>
      pagination: {
        __typename?: 'Pagination'
        currentPage: number
        perPage: number
        totalCount: number
        hasNextPage: boolean
        totalPages: number
      }
    }
  } | null
}

export type ReviewsAgencyUniversalReviewsExportCsvQueryVariables = Exact<{
  subjectId: Scalars['GlobalId']['input']
  sortBy?: InputMaybe<ManageUniversalReviewsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  filters?: InputMaybe<ManageUniversalReviewsSearchFilters>
}>

export type ReviewsAgencyUniversalReviewsExportCsvQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    universalReviewsExportCsv: { __typename?: 'ManageUniversalReviewsExportCsv'; errors?: Array<string> | null; fileUrl?: string | null }
  } | null
}

export type ReviewsCurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsCurrentUserQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    currentUser: {
      __typename?: 'ManageUser'
      hasAccessToOmrViewer: boolean
      accountType: AccountTypeEnum
      company?: { __typename?: 'AnalyticsIdentityCompany'; id: string; name?: string | null; slug: string; planTier?: string | null } | null
    }
  } | null
}

export type ReviewsIncentivizationCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type ReviewsIncentivizationCampaignQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    incentivizationCampaign: {
      __typename?: 'Campaign'
      id?: string | null
      enabled?: boolean | null
      amount?: number | null
      available?: boolean | null
      createdAt?: string | null
      title?: string | null
      validFrom?: any | null
      validTo?: any | null
      incentivizationsLimit?: number | null
      incentivizationType?: IncentivizationCampaignIncentivizationTypeEnum | null
      wonIncentivizationsCount?: number | null
      associatedReviewsCount?: number | null
      status?: IncentivizationCampaignStatusEnum | null
      limitType?: IncentivizationCampaignLimitTypeEnum | null
      hashValue?: string | null
      personalizations?: Array<{
        __typename?: 'Personalization'
        id?: string | null
        inviteMessage: string
        locale: IncentivizationCampaignPersonalizationLocaleEnum
        hashValue?: string | null
      }> | null
    }
  } | null
}

export type ReviewsIncentivizationCampaignsQueryVariables = Exact<{
  productId: Scalars['ID']['input']
  statuses?: InputMaybe<Array<IncentivizationCampaignStatusEnum> | IncentivizationCampaignStatusEnum>
}>

export type ReviewsIncentivizationCampaignsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    incentivizationCampaigns: Array<{
      __typename?: 'Campaign'
      id?: string | null
      enabled?: boolean | null
      amount?: number | null
      createdAt?: string | null
      title?: string | null
      validFrom?: any | null
      validTo?: any | null
      status?: IncentivizationCampaignStatusEnum | null
      incentivizationsLimit?: number | null
      wonIncentivizationsCount?: number | null
      totalIncentivizationsCount?: number | null
      associatedReviewsCount?: number | null
      hashValue?: string | null
      personalizations?: Array<{
        __typename?: 'Personalization'
        id?: string | null
        inviteMessage: string
        locale: IncentivizationCampaignPersonalizationLocaleEnum
        hashValue?: string | null
      }> | null
    }>
  } | null
}

export type ReviewsInsightsGrowthQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  mainCategorySlug: Scalars['String']['input']
  growthStart: Scalars['ISO8601Date']['input']
  growthEnd: Scalars['ISO8601Date']['input']
  windowStart: Scalars['ISO8601Date']['input']
  historyStart: Scalars['ISO8601Date']['input']
  historyEnd: Scalars['ISO8601Date']['input']
  segmentsBefore: Scalars['ISO8601Date']['input']
  segmentsEnd: Scalars['ISO8601Date']['input']
  monthlyStart: Scalars['ISO8601Date']['input']
  monthlyEnd: Scalars['ISO8601Date']['input']
}>

export type ReviewsInsightsGrowthQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    insights: {
      __typename?: 'ManageInsightsBatchResult'
      results: Array<{
        __typename?: 'ManageInsightsItemResult'
        metric: string
        status: number
        error?: string | null
        response?:
          | { __typename: 'ManageInsightsAttributeIndexCompositeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeIndexResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsAttributeSentimentResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsAttributeSentimentRow'
                period?: any | null
                attribute?: string | null
                positiveMentions?: number | null
                negativeMentions?: number | null
                totalMentions?: number | null
                reviewsWithPositiveMention?: number | null
                reviewsWithNegativeMention?: number | null
                reviewCount?: number | null
              }>
            }
          | { __typename: 'ManageInsightsBadgeProgressResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBenchmarkTiersResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByMonthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByWeekResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCampaignPerformanceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryDemandResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryFunnelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationEnginesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationSourcesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsClickoutRateResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCompetitorDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCovisitationResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetectionTrendsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNewEntrantsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsNpsBySegmentResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsNpsBySegmentRow'
                segmentType?: string | null
                segmentValue?: string | null
                reviewCount?: number | null
                promoters?: number | null
                detractors?: number | null
              }>
            }
          | { __typename: 'ManageInsightsPositionMentionsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingLandscapeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingPositionResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankTrackingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingByYearResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsRatingHistoryResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsRatingHistoryRow'
                period?: any | null
                averageRecommendationRating?: number | null
                reviewCount?: number | null
                ratingDeltaPrev?: number | null
              }>
            }
          | {
              __typename: 'ManageInsightsRatingMonthlyResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsRatingMonthlyRow'
                period?: any | null
                reviewsBad?: number | null
                reviewsWorse?: number | null
                reviewsGood?: number | null
                reviewsBetter?: number | null
                reviewsBest?: number | null
                avgEaseOfUse?: number | null
                easeOfUseCount?: number | null
                avgEaseOfSetup?: number | null
                easeOfSetupCount?: number | null
                avgCustomerSupportScore?: number | null
                customerSupportScoreCount?: number | null
                avgRequirementsScore?: number | null
                requirementsScoreCount?: number | null
                categoryAvgEaseOfUse?: number | null
                categoryEaseOfUseCount?: number | null
                categoryAvgEaseOfSetup?: number | null
                categoryEaseOfSetupCount?: number | null
                categoryAvgCustomerSupportScore?: number | null
                categoryCustomerSupportScoreCount?: number | null
                categoryAvgRequirementsScore?: number | null
                categoryRequirementsScoreCount?: number | null
              }>
            }
          | { __typename: 'ManageInsightsRatingSummaryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecurringVisitorShareResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsReviewFreshnessResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsReviewFreshnessRow'
                period?: any | null
                categorySlug?: string | null
                newReviewCountByPurpose?: number | null
              }>
            }
          | { __typename: 'ManageInsightsReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsReviewerMixResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsReviewerMixRow'
                segmentType?: string | null
                segmentValue?: string | null
                reviewCount?: number | null
                toolDimReviews?: number | null
                categoryReviewCount?: number | null
                categoryDimReviews?: number | null
              }>
            }
          | { __typename: 'ManageInsightsSegmentedRatingsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentByEngineResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentKeywordsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfModelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceWindowResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsToolReviewGrowthResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{ __typename?: 'ManageInsightsToolReviewGrowthRow'; period?: any | null; newReviews?: number | null }>
            }
          | {
              __typename: 'ManageInsightsToolSwitchesLifetimeResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsToolSwitchesLifetimeRow'
                source?: string | null
                switchedFromType?: string | null
                switchedFromToolTitle?: string | null
                reviewers?: number | null
                answeredCount?: number | null
                switchedCount?: number | null
                sourcedCount?: number | null
              }>
            }
          | {
              __typename: 'ManageInsightsToolSwitchesResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsToolSwitchesRow'
                period?: any | null
                source?: string | null
                switchedFromType?: string | null
                switchedFromToolTitle?: string | null
                reviewers?: number | null
                answeredCount?: number | null
                switchedCount?: number | null
                sourcedCount?: number | null
              }>
            }
          | { __typename: 'ManageInsightsVisitingCompaniesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitorReviewerGapResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVsCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | null
      }>
    }
  } | null
}

export type ReviewsInsightsLatestQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  mainCategorySlug: Scalars['String']['input']
}>

export type ReviewsInsightsLatestQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    insights: {
      __typename?: 'ManageInsightsBatchResult'
      results: Array<{
        __typename?: 'ManageInsightsItemResult'
        metric: string
        status: number
        error?: string | null
        response?:
          | { __typename: 'ManageInsightsAttributeIndexCompositeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeIndexResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsAttributeSentimentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsBadgeProgressResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsBenchmarkTiersResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsBenchmarkTiersRow'
                period?: any | null
                tier1Avg?: number | null
                tier2Avg?: number | null
                categoryAvg?: number | null
                categoryMedian?: number | null
                rankedToolsInCategory?: number | null
              }>
            }
          | { __typename: 'ManageInsightsByMonthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsByWeekResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsCampaignPerformanceResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsCampaignPerformanceRow'
                campaignId?: number | null
                campaignTitle?: string | null
                campaignStatus?: string | null
                campaignValidFrom?: any | null
                campaignValidTo?: any | null
                startedCount?: number | null
                submittedCount?: number | null
                publishedCount?: number | null
                submitRate?: number | null
              }>
            }
          | { __typename: 'ManageInsightsCategoryDemandResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCategoryFunnelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationEnginesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCitationSourcesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsClickoutRateResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCompetitorDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsCovisitationResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetailResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsDetectionTrendsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNewEntrantsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsNpsBySegmentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPositionMentionsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingLandscapeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsPricingPositionResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankTrackingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingByYearResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRankingResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingHistoryResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRatingMonthlyResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsRatingSummaryResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsRatingSummaryRow'
                reviewCount?: number | null
                replyRate?: number | null
                averageRecommendationRating?: number | null
                reviewsBad?: number | null
                reviewsWorse?: number | null
                reviewsGood?: number | null
                reviewsBetter?: number | null
                reviewsBest?: number | null
                avgEaseOfUse?: number | null
                avgEaseOfSetup?: number | null
                avgCustomerSupportScore?: number | null
                avgRequirementsScore?: number | null
                categoryAvgEaseOfUse?: number | null
                categoryAvgEaseOfSetup?: number | null
                categoryAvgCustomerSupportScore?: number | null
                categoryAvgRequirementsScore?: number | null
                isSuite?: boolean | null
              }>
            }
          | { __typename: 'ManageInsightsRecentResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsRecurringVisitorShareResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | {
              __typename: 'ManageInsightsReviewFreshnessResponse'
              emptyReason?: ManageInsightsEmptyReason | null
              rows: Array<{
                __typename?: 'ManageInsightsReviewFreshnessRow'
                period?: any | null
                categorySlug?: string | null
                reviewCountByPurpose?: number | null
                outdatedReviewShare?: number | null
              }>
            }
          | { __typename: 'ManageInsightsReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsReviewerMixResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSegmentedRatingsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentByEngineResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsSentimentKeywordsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfModelResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsShareOfVoiceWindowResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolReviewGrowthResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesLifetimeResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsToolSwitchesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitingCompaniesResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVisitorReviewerGapResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | { __typename: 'ManageInsightsVsCompetitorsResponse'; emptyReason?: ManageInsightsEmptyReason | null }
          | null
      }>
    }
  } | null
}

export type ReviewsInsightsSurveyResponseFacetsQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
}>

export type ReviewsInsightsSurveyResponseFacetsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    all?: {
      __typename?: 'ManageExploreSurveyResponses'
      stateFacet: Array<{ __typename?: 'SurveyResponsesStateFacet'; key: SurveyResponsesStateEnum; docCount: number }>
    } | null
  } | null
}

export type ReviewsLeadQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsLeadQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    lead: {
      __typename?: 'ManageLead'
      id: string
      senderName: string
      senderEmail: string
      senderCompany?: string | null
      senderPhone?: string | null
      senderCompanyPosition?: string | null
      latestRequestAt: string
      archivedAt?: string | null
      status: LeadStatusEnum
      statusChangedAt?: string | null
      contactRequests: Array<{
        __typename?: 'ContactRequest'
        id?: string | null
        contactRequestType?: ContactRequestContactRequestTypeEnum | null
        message?: string | null
        createdAt?: string | null
        locked: boolean
      }>
      notes: Array<{ __typename?: 'LeadNote'; id: string; authorName?: string | null; body: string; createdAt: string }>
      history: Array<{
        __typename?: 'ManageLeadHistoryEntry'
        id: string
        kind: LeadHistoryKindEnum
        actorName?: string | null
        body?: string | null
        createdAt: string
        fromStatus?: LeadStatusEnum | null
        toStatus?: LeadStatusEnum | null
      }>
    }
  } | null
}

export type ReviewsLeadsQueryVariables = Exact<{
  contactableId?: InputMaybe<Scalars['GlobalId']['input']>
  filters?: InputMaybe<ManageLeadsSearchFilters>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<LeadsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
}>

export type ReviewsLeadsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    leads?: {
      __typename?: 'ManageExploreLeads'
      results: Array<{
        __typename?: 'ContactRequest'
        id?: string | null
        contactRequestType?: ContactRequestContactRequestTypeEnum | null
        senderName: string
        senderEmail: string
        senderCompany?: string | null
        createdAt?: string | null
        locked: boolean
        leadStatus?: LeadStatusEnum | null
      }>
      pagination: {
        __typename?: 'Pagination'
        currentPage: number
        perPage: number
        totalCount: number
        totalPages: number
        hasNextPage: boolean
        hasPrevPage: boolean
      }
      contactRequestTypeFacet: Array<{ __typename?: 'LeadsContactRequestTypeFacet'; key: LeadsContactRequestTypeEnum; docCount: number }>
    } | null
  } | null
}

export type ReviewsLeadsExportCsvQueryVariables = Exact<{
  contactableId: Scalars['GlobalId']['input']
  fields: Array<ManageLeadsFieldsEntry> | ManageLeadsFieldsEntry
  filters?: InputMaybe<ManageLeadsSearchFilters>
  sortBy?: InputMaybe<LeadsSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
}>

export type ReviewsLeadsExportCsvQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    leadsExportCsv: { __typename?: 'ManageLeadsExportCsv'; fileUrl?: string | null; errors?: Array<string> | null }
  } | null
}

export type ReviewsProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsProductByIdQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    product: {
      __typename?: 'Product'
      companySlug?: string | null
      hasPaidPlan?: boolean | null
      twitter?: string | null
      linkedin?: string | null
      showDisclaimer?: boolean | null
      disclaimerText?: string | null
      disclaimerUrl?: string | null
      freePlanAvailable?: boolean | null
      freeDemo: boolean
      freeTrial: boolean
      trialUnit?: ProductTrialUnitEnum | null
      trialPeriod?: number | null
      noPricingPlans?: boolean | null
      noPricingPlansHint?: string | null
      cloud?: ProductCloudEnum | null
      anytimeSupport?: ProductAnytimeSupportEnum | null
      onPremise?: ProductOnPremiseEnum | null
      germanSupport?: ProductGermanSupportEnum | null
      germanLocation?: ProductGermanLocationEnum | null
      euLocation?: ProductEuLocationEnum | null
      euStandardContract?: ProductEuStandardContractEnum | null
      euCompanyAffiliated?: ProductEuCompanyAffiliatedEnum | null
      contactFormRecipients?: Array<string> | null
      pageVisitReportEmails?: Array<string> | null
      vendorEmailAddresses?: Array<string> | null
      hero?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
      heroVideoThumbnail?: ({ __typename?: 'Asset' } & AssetFieldsFragment) | null
      documents: Array<{ __typename?: 'Asset' } & DocumentFieldsFragment>
      config: { __typename?: 'ProductConfig' } & ProductConfigFieldsFragment
      screenshots: Array<{ __typename?: 'Asset' } & ScreenshotFieldsFragment>
      mainCategory: { __typename?: 'Category'; id: string; slug: string; title: string }
      categories: Array<{ __typename?: 'Category'; id: string; slug: string; title: string; hidden: boolean; published: boolean }>
      descriptionTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      shortDescriptionTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      urlTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      linkTextTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      disclaimerTextTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      disclaimerUrlTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      noPricingPlansHintTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      pricingPlans: Array<{ __typename?: 'PricingPlan' } & ProductPricingPlanFragment>
      ctaSecondaryLabelTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      ctaSecondaryUrlTranslations: Array<{ __typename?: 'Translation'; locale: string; value?: string | null }>
      ctaSecondary?: { __typename?: 'Link'; url: string; label?: string | null } | null
      currentBudget?: {
        __typename?: 'Budget'
        value: number
        usedValue?: number | null
        endDate: any
        additionalValue?: number | null
        remainingValue?: number | null
      } | null
    } & ProductBasicDataFragment
  } | null
}

export type ReviewsProductOptionsQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsProductOptionsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    options: {
      __typename?: 'ManageOptions'
      pricingTextOptions: Array<{
        __typename?: 'PricingTextOption'
        id: string
        name: string
        free: boolean
        nameTranslations: Array<{ __typename?: 'Translation' } & TranslationFieldsFragment>
      }>
      pricingSubscriptionModes: Array<{
        __typename?: 'PricingSubscriptionMode'
        id: string
        name: string
        inDays?: number | null
        nameTranslations: Array<{ __typename?: 'Translation' } & TranslationFieldsFragment>
      }>
      currencies: Array<{ __typename?: 'Currency'; name: string; code: string; symbol: string }>
    }
  } | null
}

export type ReviewsProductSurveyResponseDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsProductSurveyResponseDetailsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponse: {
      __typename?: 'ManageSurveyResponse'
      aasmState: string
      anonymous: boolean
      createdAt: string
      firstPublishedAt?: string | null
      id: string
      publishedAt?: string | null
      rejectedAt?: string | null
      rejectedReason?: SurveyResponseRejectedReasons | null
      reminderDisabled: boolean
      reviewerCompany?: string | null
      reviewerCompanySize?: string | null
      reviewerIndustry?: string | null
      reviewerFirstName?: string | null
      reviewerPosition?: string | null
      updatedAt: string
      incentive?: { __typename?: 'Incentive'; slug: string } | null
      purposes: Array<{ __typename?: 'Category'; title: string }>
      reminders: Array<{
        __typename?: 'ManageSurveyResponseReminder'
        id: string
        sentAt?: string | null
        createdAt: string
        message?: string | null
        status: SurveyResponseReminderStatuses
        userId?: number | null
        automatic: boolean
      }>
      review?: {
        __typename?: 'Review'
        id: string
        positive?: string | null
        negative?: string | null
        problems?: string | null
        anonymous: boolean
        companySize?: string | null
        companyName?: string | null
        companyField?: string | null
        companyPosition: string
        title: string
        recommendationScore: number
        reviewerFirstName?: string | null
        reviewerLastName?: string | null
        incentive: boolean
        publishedAt?: string | null
        reviewReply?: {
          __typename?: 'ReviewReply'
          id?: string | null
          personalized?: boolean | null
          reply: string
          senderName?: string | null
        } | null
        purposes: Array<{ __typename?: 'Category'; title: string }>
        product: { __typename?: 'Product'; title: string }
        video?: { __typename?: 'Asset'; contentType: string; name: string; url: string } | null
      } | null
    }
  } | null
}

export type ReviewsProductSurveyResponsesExportCsvQueryVariables = Exact<{
  slug: Scalars['String']['input']
  filters: ManageSurveyResponsesSearchFilters
  view?: InputMaybe<SurveyResponsesViewEnum>
}>

export type ReviewsProductSurveyResponsesExportCsvQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponsesExportCsv: { __typename?: 'ManageSurveyResponsesExportCsv'; errors?: Array<string> | null; fileUrl?: string | null }
  } | null
}

export type ReviewsProductSurveyResponseStatusQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsProductSurveyResponseStatusQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponse: {
      __typename?: 'ManageSurveyResponse'
      aasmState: string
      id: string
      reviewerFirstName?: string | null
      rejectedReason?: SurveyResponseRejectedReasons | null
    }
  } | null
}

export type ReviewsProductSurveyResponsesQueryVariables = Exact<{
  slug: Scalars['ID']['input']
  page: Scalars['Int']['input']
  perPage: Scalars['Int']['input']
  sortBy?: InputMaybe<SurveyResponsesSortByEnum>
  sortDirection?: InputMaybe<SortDirectionEnum>
  filters: ManageSurveyResponsesSearchFilters
  view?: InputMaybe<SurveyResponsesViewEnum>
}>

export type ReviewsProductSurveyResponsesQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponses?: {
      __typename?: 'ManageExploreSurveyResponses'
      results: Array<{
        __typename?: 'ManageSurveyResponse'
        id: string
        aasmState: string
        reviewerFirstName?: string | null
        reviewerCompany?: string | null
        reviewerPosition?: string | null
        rejectedReason?: SurveyResponseRejectedReasons | null
        reminderDisabled: boolean
        updatedAt: string
        purposes: Array<{ __typename?: 'Category'; title: string }>
        reminders: Array<{ __typename?: 'ManageSurveyResponseReminder'; id: string; sentAt?: string | null }>
        review?: {
          __typename?: 'Review'
          recommendationScore: number
          companyName?: string | null
          companyPosition: string
          reviewReply?: { __typename?: 'ReviewReply'; id?: string | null } | null
          campaign?: { __typename?: 'Campaign'; title?: string | null } | null
        } | null
        requestedCampaign?: { __typename?: 'Campaign'; title?: string | null } | null
      }>
      purposesFacet: Array<{ __typename?: 'KeywordFacet'; docCount: number; key: string; name?: string | null }>
      viewFacet: Array<{ __typename?: 'SurveyResponsesViewFacet'; key: SurveyResponsesViewEnum; docCount: number }>
      pagination: {
        __typename?: 'Pagination'
        perPage: number
        currentPage: number
        totalCount: number
        hasNextPage: boolean
        totalPages: number
      }
    } | null
  } | null
}

export type ReviewsProductSurveyResponsesCountQueryVariables = Exact<{
  slug: Scalars['ID']['input']
}>

export type ReviewsProductSurveyResponsesCountQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponses?: { __typename?: 'ManageExploreSurveyResponses'; pagination: { __typename?: 'Pagination'; totalCount: number } } | null
  } | null
}

export type ReviewsProductSurveyResponsesViewFacetQueryVariables = Exact<{
  slug: Scalars['ID']['input']
}>

export type ReviewsProductSurveyResponsesViewFacetQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    surveyResponses?: {
      __typename?: 'ManageExploreSurveyResponses'
      viewFacet: Array<{ __typename?: 'SurveyResponsesViewFacet'; key: SurveyResponsesViewEnum; docCount: number }>
    } | null
  } | null
}

export type ReviewsProductsQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsProductsQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    products?: Array<
      {
        __typename?: 'Product'
        hasPaidPlan?: boolean | null
        rankscaleUrl?: string | null
        config: {
          __typename?: 'ProductConfig'
          profileClaimedCached: ProductConfigProfileClaimedCachedEnum
          aiVisibilityDashboardCached: ProductConfigAiVisibilityDashboardCachedEnum
        }
      } & ProductBasicDataFragment
    > | null
  } | null
}

export type ReviewReviewsQueryVariables = Exact<{
  product: Scalars['ID']['input']
  filters?: InputMaybe<ReviewsSearchFilters>
}>

export type ReviewReviewsQuery = {
  __typename?: 'Query'
  reviews?: {
    __typename?: 'PaginatedReviews'
    statistics: { __typename?: 'ReviewStatistics'; recommendationScoreBetter: number; recommendationScoreBest: number }
  } | null
}

export type ReviewsTopProductsRankingQueryVariables = Exact<{
  productSlug: Scalars['ID']['input']
  orderBy?: InputMaybe<ManageTopProductsRankingOrderBy>
  orderDir?: InputMaybe<SortDirectionEnum>
  page: Scalars['Int']['input']
  perPage: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type ReviewsTopProductsRankingQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    topProductsRanking: {
      __typename?: 'ManageTopProductsRanking'
      year?: number | null
      results: Array<{
        __typename?: 'ManageTopProductsRankingRow'
        tool: string
        toolTitle?: string | null
        rank?: number | null
        position?: number | null
        rating?: number | null
        reviewCount?: number | null
      }>
      pinned?: {
        __typename?: 'ManageTopProductsRankingRow'
        tool: string
        toolTitle?: string | null
        rank?: number | null
        position?: number | null
        rating?: number | null
        reviewCount?: number | null
      } | null
      pagination: {
        __typename?: 'Pagination'
        currentPage: number
        perPage: number
        totalCount: number
        totalPages: number
        hasNextPage: boolean
      }
    }
  } | null
}

export type ReviewsTopRatedBadgeProgressQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReviewsTopRatedBadgeProgressQuery = {
  __typename?: 'Query'
  manage?: {
    __typename?: 'ManageQuery'
    topRatedBadgeProgress: {
      __typename?: 'ManageTopRatedBadgeProgress'
      reviewCount: number
      averageScore?: number | null
      eligible: boolean
      minimumReviewCount: number
      minimumAverageScore: number
    }
  } | null
}

export const AgencyConfigFieldsFragmentDoc = gql`
  fragment AgencyConfigFields on AgencyConfig {
    badgesAdminCalculated
    certificatesUspsAdminCalculated
    ctaPrimaryAdminCalculated
    ctaPrimaryCached
    ctaSecondaryAdminCalculated
    ctaSecondaryCached
    descriptionLongAdminCalculated
    documentsAdminCalculated
    heroImageAdminCalculated
    heroImageCached
    pageVisitReportsCached
    portfolioAdminCalculated
    socialLinksAdminCalculated
    widgetsAdminCalculated
  }
`
export const AgencyTraitFieldsFragmentDoc = gql`
  fragment agencyTraitFields on AgencyTrait {
    id
    kind
    description
    descriptionTranslations {
      locale
      value
    }
    title
    position
    titleTranslations {
      locale
      value
    }
  }
`
export const AssetFieldsFragmentDoc = gql`
  fragment assetFields on Asset {
    name
    size
    url
    contentType
  }
`
export const AgencyBasicFieldsFragmentDoc = gql`
  fragment agencyBasicFields on Agency {
    __typename
    id
    globalId
    title
    slug
    shortDescription
    locations {
      id
      city
      citySlug
    }
    remote
    traits {
      ...agencyTraitFields
    }
    logo {
      ...assetFields
    }
    assignedFeatures {
      id
      position
      feature {
        id
        name
        category {
          id
          title
        }
      }
    }
    assignedIndustries {
      id
      position
      industry {
        id
        name
      }
    }
  }
  ${AgencyTraitFieldsFragmentDoc}
  ${AssetFieldsFragmentDoc}
`
export const AssignedBadgeFieldsFragmentDoc = gql`
  fragment assignedBadgeFields on AssignedBadge {
    id
    timeframe
    badgeType
    badgeName
    url
    category {
      displayOrTitle
    }
  }
`
export const ProductBasicDataFragmentDoc = gql`
  fragment productBasicData on Product {
    id
    globalId
    slug
    title
    isSuite
    publishedAt
    averageRecommendationRating
    reviewCount
    assignedBadges {
      ...assignedBadgeFields
    }
    expiredAssignedBadges {
      ...assignedBadgeFields
    }
    logo {
      ...assetFields
    }
  }
  ${AssignedBadgeFieldsFragmentDoc}
  ${AssetFieldsFragmentDoc}
`
export const DocumentFieldsFragmentDoc = gql`
  fragment documentFields on Asset {
    id
    name
    filename
    nameTranslations {
      locale
      value
    }
    size
    url
    previewUrl(width: 300, height: 400)
    previewFilename
    contentType
    position
  }
`
export const ScreenshotFieldsFragmentDoc = gql`
  fragment screenshotFields on Asset {
    id
    name
    size
    url
    contentType
  }
`
export const AgencyDetailsFieldsFragmentDoc = gql`
  fragment agencyDetailsFields on Agency {
    ...agencyBasicFields
    assignedBadges {
      ...assignedBadgeFields
    }
    expiredAssignedBadges {
      ...assignedBadgeFields
    }
    toolPartners {
      id
      adpPosition
      product {
        ...productBasicData
      }
    }
    hero {
      ...assetFields
    }
    heroVideoThumbnail {
      ...assetFields
    }
    categories {
      id
      slug
      title
      hidden
      published
    }
    descriptionTranslations {
      locale
      value
    }
    shortDescriptionTranslations {
      locale
      value
    }
    twitter
    linkedin
    urlTranslations {
      locale
      value
    }
    linkTextTranslations {
      locale
      value
    }
    ctaSecondary {
      label
      url
    }
    ctaSecondaryLabelTranslations {
      locale
      value
    }
    ctaSecondaryUrlTranslations {
      locale
      value
    }
    documents {
      ...documentFields
      errors {
        field
        message
        value
      }
    }
    screenshots {
      ...screenshotFields
      errors {
        field
        message
        value
      }
    }
    contactFormRecipients
  }
  ${AgencyBasicFieldsFragmentDoc}
  ${AssignedBadgeFieldsFragmentDoc}
  ${ProductBasicDataFragmentDoc}
  ${AssetFieldsFragmentDoc}
  ${DocumentFieldsFragmentDoc}
  ${ScreenshotFieldsFragmentDoc}
`
export const TranslationFieldsFragmentDoc = gql`
  fragment translationFields on Translation {
    locale
    value
  }
`
export const CampaignPersonalisationFieldsFragmentDoc = gql`
  fragment campaignPersonalisationFields on Personalization {
    createdAt
    hashValue
    id
    inviteMessage
    locale
    lostIncentivizationsCount
    requestedIncentivizationsCount
    totalIncentivizationsCount
    updatedAt
    wonIncentivizationsCount
  }
`
export const CampaignFieldsFragmentDoc = gql`
  fragment campaignFields on Campaign {
    amount
    amountPublic
    available
    budgetLimit
    createdAt
    description
    descriptionTranslations {
      ...translationFields
    }
    enabled
    hashValue
    id
    incentivizationType
    incentivizationsLimit
    kind
    limitType
    lostIncentivizationsCount
    personalizations {
      ...campaignPersonalisationFields
    }
    requestedIncentivizationsCount
    status
    title
    totalIncentivizationsCount
    updatedAt
    validFrom
    validTo
    wonIncentivizationsCount
  }
  ${TranslationFieldsFragmentDoc}
  ${CampaignPersonalisationFieldsFragmentDoc}
`
export const FieldErrorFieldsFragmentDoc = gql`
  fragment fieldErrorFields on FieldError {
    field
    message
    value
  }
`
export const ProductConfigFieldsFragmentDoc = gql`
  fragment ProductConfigFields on ProductConfig {
    badgesAdminCalculated
    ctaCustomQuoteAdminCalculated
    ctaCustomQuoteCached
    ctaCustomQuoteVendor
    ctaCustomQuoteVendorPossibleOptions
    ctaPrimaryAdminCalculated
    ctaPrimaryCached
    ctaPrimaryVendor
    ctaPrimaryVendorPossibleOptions
    ctaSecondaryAdminCalculated
    ctaSecondaryCached
    ctaSecondaryVendor
    ctaSecondaryVendorPossibleOptions
    downloadsFileUploadAdminCalculated
    heroImageAdminCalculated
    heroImageCached
    heroImageVendor
    heroImageVendorPossibleOptions
    pageVisitReportsAdminCalculated
    pageVisitReportsCached
    pricingDisclaimerLinkCached
    profileClaimedAdminCalculated
    profileClaimedCached
    profileClaimedVendor
    profileClaimedVendorPossibleOptions
    reviewRemindersAllowedCached
    reviewRepliesAllowedAdminCalculated
    reviewRepliesAllowedCached
    reviewRepliesAllowedVendor
    reviewRepliesAllowedVendorPossibleOptions
    socialLinksAdminCalculated
    socialLinksCached
    socialLinksVendor
    widgetsAdminCalculated
  }
`
export const ProductPricingPlanFragmentDoc = gql`
  fragment ProductPricingPlan on PricingPlan {
    billingPeriod
    description
    name
    descriptionTranslations {
      locale
      value
    }
    nameTranslations {
      locale
      value
    }
    id
    position
    perksTranslations {
      locale
      value
    }
    priceCents
    priceCurrency
    priceCurrencySymbol
    priceTextValue
    pricingSubscriptionModeId
    pricingTextOptionId
    promoted
    promotedLabel
    startingPrice
    titleIcon
  }
`
export const AddReviewsLeadNoteDocument = gql`
  mutation addReviewsLeadNote($leadId: ID!, $body: String!) {
    manage {
      addLeadNote(input: { leadId: $leadId, body: $body }) {
        note {
          id
          authorName
          body
          createdAt
        }
      }
    }
  }
`

/**
 * __useAddReviewsLeadNoteMutation__
 *
 * To run a mutation, you first call `useAddReviewsLeadNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddReviewsLeadNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddReviewsLeadNoteMutation({
 *   variables: {
 *     leadId: // value for 'leadId'
 *     body: // value for 'body'
 *   },
 * });
 */
export function useAddReviewsLeadNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddReviewsLeadNoteMutation, AddReviewsLeadNoteMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddReviewsLeadNoteMutation, AddReviewsLeadNoteMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<AddReviewsLeadNoteMutation, AddReviewsLeadNoteMutationVariables>(
    AddReviewsLeadNoteDocument,
    options,
  )
}
export type AddReviewsLeadNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddReviewsLeadNoteMutation,
  AddReviewsLeadNoteMutationVariables
>
export const ArchiveReviewsLeadDocument = gql`
  mutation archiveReviewsLead($id: ID!) {
    manage {
      archiveLead(input: { id: $id }) {
        lead {
          id
          archivedAt
        }
      }
    }
  }
`

/**
 * __useArchiveReviewsLeadMutation__
 *
 * To run a mutation, you first call `useArchiveReviewsLeadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveReviewsLeadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveReviewsLeadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useArchiveReviewsLeadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ArchiveReviewsLeadMutation, ArchiveReviewsLeadMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveReviewsLeadMutation, ArchiveReviewsLeadMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<ArchiveReviewsLeadMutation, ArchiveReviewsLeadMutationVariables>(
    ArchiveReviewsLeadDocument,
    options,
  )
}
export type ArchiveReviewsLeadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ArchiveReviewsLeadMutation,
  ArchiveReviewsLeadMutationVariables
>
export const CreateReviewsCampaignDocument = gql`
  mutation createReviewsCampaign($productId: ID!, $attributes: CampaignAttributes!) {
    manage {
      createCampaign(input: { productId: $productId, attributes: $attributes }) {
        ...campaignFields
        errors {
          ...fieldErrorFields
        }
        personalizations {
          ...campaignPersonalisationFields
          errors {
            ...fieldErrorFields
          }
        }
      }
    }
  }
  ${CampaignFieldsFragmentDoc}
  ${FieldErrorFieldsFragmentDoc}
  ${CampaignPersonalisationFieldsFragmentDoc}
`

/**
 * __useCreateReviewsCampaignMutation__
 *
 * To run a mutation, you first call `useCreateReviewsCampaignMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewsCampaignMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReviewsCampaignMutation({
 *   variables: {
 *     productId: // value for 'productId'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateReviewsCampaignMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateReviewsCampaignMutation, CreateReviewsCampaignMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateReviewsCampaignMutation, CreateReviewsCampaignMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CreateReviewsCampaignMutation, CreateReviewsCampaignMutationVariables>(
    CreateReviewsCampaignDocument,
    options,
  )
}
export type CreateReviewsCampaignMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateReviewsCampaignMutation,
  CreateReviewsCampaignMutationVariables
>
export const CreateReviewsCampaignPersonalizationDocument = gql`
  mutation createReviewsCampaignPersonalization($campaign: ID!, $attributes: PersonalizationAttributes!) {
    manage {
      createCampaignPersonalization(input: { campaign: $campaign, attributes: $attributes }) {
        ...campaignPersonalisationFields
        errors {
          ...fieldErrorFields
        }
      }
    }
  }
  ${CampaignPersonalisationFieldsFragmentDoc}
  ${FieldErrorFieldsFragmentDoc}
`

/**
 * __useCreateReviewsCampaignPersonalizationMutation__
 *
 * To run a mutation, you first call `useCreateReviewsCampaignPersonalizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewsCampaignPersonalizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReviewsCampaignPersonalizationMutation({
 *   variables: {
 *     campaign: // value for 'campaign'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateReviewsCampaignPersonalizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateReviewsCampaignPersonalizationMutation,
        CreateReviewsCampaignPersonalizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateReviewsCampaignPersonalizationMutation,
          CreateReviewsCampaignPersonalizationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateReviewsCampaignPersonalizationMutation,
    CreateReviewsCampaignPersonalizationMutationVariables
  >(CreateReviewsCampaignPersonalizationDocument, options)
}
export type CreateReviewsCampaignPersonalizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateReviewsCampaignPersonalizationMutation,
  CreateReviewsCampaignPersonalizationMutationVariables
>
export const CreateReviewsEntityDocumentDocument = gql`
  mutation createReviewsEntityDocument($attachableId: GlobalId!, $documentAttributes: AssetAttributes!) {
    manage {
      createDocument(input: { attachableId: $attachableId, documentAttributes: $documentAttributes }) {
        id
      }
    }
  }
`

/**
 * __useCreateReviewsEntityDocumentMutation__
 *
 * To run a mutation, you first call `useCreateReviewsEntityDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewsEntityDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReviewsEntityDocumentMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     documentAttributes: // value for 'documentAttributes'
 *   },
 * });
 */
export function useCreateReviewsEntityDocumentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateReviewsEntityDocumentMutation, CreateReviewsEntityDocumentMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateReviewsEntityDocumentMutation, CreateReviewsEntityDocumentMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateReviewsEntityDocumentMutation, CreateReviewsEntityDocumentMutationVariables>(
    CreateReviewsEntityDocumentDocument,
    options,
  )
}
export type CreateReviewsEntityDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateReviewsEntityDocumentMutation,
  CreateReviewsEntityDocumentMutationVariables
>
export const CreateReviewsEntityScreenshotDocument = gql`
  mutation createReviewsEntityScreenshot($attachableId: GlobalId!, $screenshotAttributes: AssetAttributes!) {
    manage {
      createScreenshot(input: { attachableId: $attachableId, screenshotAttributes: $screenshotAttributes }) {
        clientMutationId
      }
    }
  }
`

/**
 * __useCreateReviewsEntityScreenshotMutation__
 *
 * To run a mutation, you first call `useCreateReviewsEntityScreenshotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewsEntityScreenshotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReviewsEntityScreenshotMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     screenshotAttributes: // value for 'screenshotAttributes'
 *   },
 * });
 */
export function useCreateReviewsEntityScreenshotMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateReviewsEntityScreenshotMutation, CreateReviewsEntityScreenshotMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateReviewsEntityScreenshotMutation, CreateReviewsEntityScreenshotMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateReviewsEntityScreenshotMutation, CreateReviewsEntityScreenshotMutationVariables>(
    CreateReviewsEntityScreenshotDocument,
    options,
  )
}
export type CreateReviewsEntityScreenshotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateReviewsEntityScreenshotMutation,
  CreateReviewsEntityScreenshotMutationVariables
>
export const CreateSurveyResponseReminderDocument = gql`
  mutation createSurveyResponseReminder($input: CreateSurveyResponseReminderInput!) {
    manage {
      createSurveyResponseReminder(input: $input) {
        id
      }
    }
  }
`

/**
 * __useCreateSurveyResponseReminderMutation__
 *
 * To run a mutation, you first call `useCreateSurveyResponseReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyResponseReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSurveyResponseReminderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyResponseReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateSurveyResponseReminderMutation, CreateSurveyResponseReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateSurveyResponseReminderMutation, CreateSurveyResponseReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateSurveyResponseReminderMutation, CreateSurveyResponseReminderMutationVariables>(
    CreateSurveyResponseReminderDocument,
    options,
  )
}
export type CreateSurveyResponseReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSurveyResponseReminderMutation,
  CreateSurveyResponseReminderMutationVariables
>
export const CreateSurveyResponseRemindersDocument = gql`
  mutation createSurveyResponseReminders($input: CreateSurveyResponseRemindersInput!) {
    manage {
      createSurveyResponseReminders(input: $input) {
        failedCount
        successCount
      }
    }
  }
`

/**
 * __useCreateSurveyResponseRemindersMutation__
 *
 * To run a mutation, you first call `useCreateSurveyResponseRemindersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyResponseRemindersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSurveyResponseRemindersMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyResponseRemindersMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateSurveyResponseRemindersMutation, CreateSurveyResponseRemindersMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateSurveyResponseRemindersMutation, CreateSurveyResponseRemindersMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateSurveyResponseRemindersMutation, CreateSurveyResponseRemindersMutationVariables>(
    CreateSurveyResponseRemindersDocument,
    options,
  )
}
export type CreateSurveyResponseRemindersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSurveyResponseRemindersMutation,
  CreateSurveyResponseRemindersMutationVariables
>
export const CreateUniversalReviewReminderDocument = gql`
  mutation createUniversalReviewReminder($input: CreateUniversalReviewReminderInput!) {
    manage {
      createUniversalReviewReminder(input: $input) {
        id
        kind
        message
        sentAt
        userId
      }
    }
  }
`

/**
 * __useCreateUniversalReviewReminderMutation__
 *
 * To run a mutation, you first call `useCreateUniversalReviewReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUniversalReviewReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUniversalReviewReminderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUniversalReviewReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUniversalReviewReminderMutation, CreateUniversalReviewReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateUniversalReviewReminderMutation, CreateUniversalReviewReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateUniversalReviewReminderMutation, CreateUniversalReviewReminderMutationVariables>(
    CreateUniversalReviewReminderDocument,
    options,
  )
}
export type CreateUniversalReviewReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUniversalReviewReminderMutation,
  CreateUniversalReviewReminderMutationVariables
>
export const DeleteCampaignPersonalizationDocument = gql`
  mutation deleteCampaignPersonalization($campaignPersonalization: ID!) {
    manage {
      deleteCampaignPersonalization(input: { campaignPersonalization: $campaignPersonalization }) {
        id
      }
    }
  }
`

/**
 * __useDeleteCampaignPersonalizationMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignPersonalizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignPersonalizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCampaignPersonalizationMutation({
 *   variables: {
 *     campaignPersonalization: // value for 'campaignPersonalization'
 *   },
 * });
 */
export function useDeleteCampaignPersonalizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCampaignPersonalizationMutation, DeleteCampaignPersonalizationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCampaignPersonalizationMutation, DeleteCampaignPersonalizationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCampaignPersonalizationMutation, DeleteCampaignPersonalizationMutationVariables>(
    DeleteCampaignPersonalizationDocument,
    options,
  )
}
export type DeleteCampaignPersonalizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCampaignPersonalizationMutation,
  DeleteCampaignPersonalizationMutationVariables
>
export const DeleteReviewReplyDocument = gql`
  mutation deleteReviewReply($id: ID!) {
    manage {
      deleteReviewReply(input: { id: $id }) {
        id
      }
    }
  }
`

/**
 * __useDeleteReviewReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReviewReplyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewReplyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReviewReplyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewReplyMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteReviewReplyMutation, DeleteReviewReplyMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteReviewReplyMutation, DeleteReviewReplyMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteReviewReplyMutation, DeleteReviewReplyMutationVariables>(DeleteReviewReplyDocument, options)
}
export type DeleteReviewReplyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteReviewReplyMutation,
  DeleteReviewReplyMutationVariables
>
export const DeleteReviewsEntityDocumentsDocument = gql`
  mutation deleteReviewsEntityDocuments($attachableId: GlobalId!, $ids: [ID!]!) {
    manage {
      deleteDocuments(input: { attachableId: $attachableId, ids: $ids }) {
        id
      }
    }
  }
`

/**
 * __useDeleteReviewsEntityDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteReviewsEntityDocumentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewsEntityDocumentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReviewsEntityDocumentsMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteReviewsEntityDocumentsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteReviewsEntityDocumentsMutation, DeleteReviewsEntityDocumentsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteReviewsEntityDocumentsMutation, DeleteReviewsEntityDocumentsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteReviewsEntityDocumentsMutation, DeleteReviewsEntityDocumentsMutationVariables>(
    DeleteReviewsEntityDocumentsDocument,
    options,
  )
}
export type DeleteReviewsEntityDocumentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteReviewsEntityDocumentsMutation,
  DeleteReviewsEntityDocumentsMutationVariables
>
export const DeleteReviewsEntityScreenshotsDocument = gql`
  mutation deleteReviewsEntityScreenshots($attachableId: GlobalId!, $ids: [ID!]!) {
    manage {
      deleteScreenshots(input: { attachableId: $attachableId, ids: $ids }) {
        clientMutationId
      }
    }
  }
`

/**
 * __useDeleteReviewsEntityScreenshotsMutation__
 *
 * To run a mutation, you first call `useDeleteReviewsEntityScreenshotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewsEntityScreenshotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReviewsEntityScreenshotsMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteReviewsEntityScreenshotsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteReviewsEntityScreenshotsMutation, DeleteReviewsEntityScreenshotsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteReviewsEntityScreenshotsMutation, DeleteReviewsEntityScreenshotsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteReviewsEntityScreenshotsMutation, DeleteReviewsEntityScreenshotsMutationVariables>(
    DeleteReviewsEntityScreenshotsDocument,
    options,
  )
}
export type DeleteReviewsEntityScreenshotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteReviewsEntityScreenshotsMutation,
  DeleteReviewsEntityScreenshotsMutationVariables
>
export const SetReviewsLeadStatusDocument = gql`
  mutation setReviewsLeadStatus($id: ID!, $status: LeadStatusEnum!) {
    manage {
      setLeadStatus(input: { id: $id, status: $status }) {
        lead {
          id
        }
      }
    }
  }
`

/**
 * __useSetReviewsLeadStatusMutation__
 *
 * To run a mutation, you first call `useSetReviewsLeadStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetReviewsLeadStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetReviewsLeadStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useSetReviewsLeadStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetReviewsLeadStatusMutation, SetReviewsLeadStatusMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetReviewsLeadStatusMutation, SetReviewsLeadStatusMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<SetReviewsLeadStatusMutation, SetReviewsLeadStatusMutationVariables>(
    SetReviewsLeadStatusDocument,
    options,
  )
}
export type SetReviewsLeadStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetReviewsLeadStatusMutation,
  SetReviewsLeadStatusMutationVariables
>
export const UnarchiveReviewsLeadDocument = gql`
  mutation unarchiveReviewsLead($id: ID!) {
    manage {
      unarchiveLead(input: { id: $id }) {
        lead {
          id
          archivedAt
        }
      }
    }
  }
`

/**
 * __useUnarchiveReviewsLeadMutation__
 *
 * To run a mutation, you first call `useUnarchiveReviewsLeadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveReviewsLeadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnarchiveReviewsLeadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveReviewsLeadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UnarchiveReviewsLeadMutation, UnarchiveReviewsLeadMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnarchiveReviewsLeadMutation, UnarchiveReviewsLeadMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UnarchiveReviewsLeadMutation, UnarchiveReviewsLeadMutationVariables>(
    UnarchiveReviewsLeadDocument,
    options,
  )
}
export type UnarchiveReviewsLeadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UnarchiveReviewsLeadMutation,
  UnarchiveReviewsLeadMutationVariables
>
export const UpdateReviewsAgencyDocument = gql`
  mutation updateReviewsAgency($id: ID!, $attributes: ManageAgencyAttributes!) {
    manage {
      updateAgency(input: { id: $id, attributes: $attributes }) {
        agency {
          ...agencyDetailsFields
          errors {
            field
            message
            value
          }
        }
      }
    }
  }
  ${AgencyDetailsFieldsFragmentDoc}
`

/**
 * __useUpdateReviewsAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsAgencyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsAgencyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsAgencyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateReviewsAgencyMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateReviewsAgencyMutation, UpdateReviewsAgencyMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReviewsAgencyMutation, UpdateReviewsAgencyMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpdateReviewsAgencyMutation, UpdateReviewsAgencyMutationVariables>(
    UpdateReviewsAgencyDocument,
    options,
  )
}
export type UpdateReviewsAgencyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsAgencyMutation,
  UpdateReviewsAgencyMutationVariables
>
export const UpdateReviewsCampaignDocument = gql`
  mutation updateReviewsCampaign($campaign: ID!, $attributes: CampaignAttributes!) {
    manage {
      updateCampaign(input: { campaign: $campaign, attributes: $attributes }) {
        ...campaignFields
        errors {
          ...fieldErrorFields
        }
      }
    }
  }
  ${CampaignFieldsFragmentDoc}
  ${FieldErrorFieldsFragmentDoc}
`

/**
 * __useUpdateReviewsCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsCampaignMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsCampaignMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsCampaignMutation({
 *   variables: {
 *     campaign: // value for 'campaign'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateReviewsCampaignMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateReviewsCampaignMutation, UpdateReviewsCampaignMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReviewsCampaignMutation, UpdateReviewsCampaignMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpdateReviewsCampaignMutation, UpdateReviewsCampaignMutationVariables>(
    UpdateReviewsCampaignDocument,
    options,
  )
}
export type UpdateReviewsCampaignMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsCampaignMutation,
  UpdateReviewsCampaignMutationVariables
>
export const UpdateReviewsCampaignPersonalizationDocument = gql`
  mutation updateReviewsCampaignPersonalization($campaignPersonalization: ID!, $attributes: PersonalizationAttributes!) {
    manage {
      updateCampaignPersonalization(input: { campaignPersonalization: $campaignPersonalization, attributes: $attributes }) {
        id
        inviteMessage
        locale
        hashValue
        errors {
          ...fieldErrorFields
        }
      }
    }
  }
  ${FieldErrorFieldsFragmentDoc}
`

/**
 * __useUpdateReviewsCampaignPersonalizationMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsCampaignPersonalizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsCampaignPersonalizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsCampaignPersonalizationMutation({
 *   variables: {
 *     campaignPersonalization: // value for 'campaignPersonalization'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateReviewsCampaignPersonalizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateReviewsCampaignPersonalizationMutation,
        UpdateReviewsCampaignPersonalizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateReviewsCampaignPersonalizationMutation,
          UpdateReviewsCampaignPersonalizationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateReviewsCampaignPersonalizationMutation,
    UpdateReviewsCampaignPersonalizationMutationVariables
  >(UpdateReviewsCampaignPersonalizationDocument, options)
}
export type UpdateReviewsCampaignPersonalizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsCampaignPersonalizationMutation,
  UpdateReviewsCampaignPersonalizationMutationVariables
>
export const UpdateReviewsEntityDocumentsDocument = gql`
  mutation updateReviewsEntityDocuments($attachableId: GlobalId!, $documentAttributes: [AssetAttributes!]!) {
    manage {
      updateDocuments(input: { attachableId: $attachableId, documentAttributes: $documentAttributes }) {
        id
      }
    }
  }
`

/**
 * __useUpdateReviewsEntityDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsEntityDocumentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsEntityDocumentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsEntityDocumentsMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     documentAttributes: // value for 'documentAttributes'
 *   },
 * });
 */
export function useUpdateReviewsEntityDocumentsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateReviewsEntityDocumentsMutation, UpdateReviewsEntityDocumentsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateReviewsEntityDocumentsMutation, UpdateReviewsEntityDocumentsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateReviewsEntityDocumentsMutation, UpdateReviewsEntityDocumentsMutationVariables>(
    UpdateReviewsEntityDocumentsDocument,
    options,
  )
}
export type UpdateReviewsEntityDocumentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsEntityDocumentsMutation,
  UpdateReviewsEntityDocumentsMutationVariables
>
export const UpdateReviewsEntityScreenshotsDocument = gql`
  mutation updateReviewsEntityScreenshots($attachableId: GlobalId!, $screenshotAttributes: [AssetAttributes!]!) {
    manage {
      updateScreenshots(input: { attachableId: $attachableId, screenshotAttributes: $screenshotAttributes }) {
        clientMutationId
      }
    }
  }
`

/**
 * __useUpdateReviewsEntityScreenshotsMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsEntityScreenshotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsEntityScreenshotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsEntityScreenshotsMutation({
 *   variables: {
 *     attachableId: // value for 'attachableId'
 *     screenshotAttributes: // value for 'screenshotAttributes'
 *   },
 * });
 */
export function useUpdateReviewsEntityScreenshotsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateReviewsEntityScreenshotsMutation, UpdateReviewsEntityScreenshotsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateReviewsEntityScreenshotsMutation, UpdateReviewsEntityScreenshotsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateReviewsEntityScreenshotsMutation, UpdateReviewsEntityScreenshotsMutationVariables>(
    UpdateReviewsEntityScreenshotsDocument,
    options,
  )
}
export type UpdateReviewsEntityScreenshotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsEntityScreenshotsMutation,
  UpdateReviewsEntityScreenshotsMutationVariables
>
export const UpdateReviewsProductDocument = gql`
  mutation updateReviewsProduct($id: ID!, $attributes: ProductAttributes!) {
    manage {
      updateProduct(input: { id: $id, attributes: $attributes }) {
        clientMutationId
      }
    }
  }
`

/**
 * __useUpdateReviewsProductMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsProductMutation({
 *   variables: {
 *     id: // value for 'id'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateReviewsProductMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateReviewsProductMutation, UpdateReviewsProductMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReviewsProductMutation, UpdateReviewsProductMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpdateReviewsProductMutation, UpdateReviewsProductMutationVariables>(
    UpdateReviewsProductDocument,
    options,
  )
}
export type UpdateReviewsProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsProductMutation,
  UpdateReviewsProductMutationVariables
>
export const UpdateReviewsProductWithPricingPlansDocument = gql`
  mutation updateReviewsProductWithPricingPlans($id: ID!, $attributes: ProductAttributes!, $pricing: ChangePricingPlansInput!) {
    manage {
      updateProduct(input: { id: $id, attributes: $attributes }) {
        clientMutationId
      }
      changePricingPlans(input: $pricing) {
        name
      }
    }
  }
`

/**
 * __useUpdateReviewsProductWithPricingPlansMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsProductWithPricingPlansMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsProductWithPricingPlansMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewsProductWithPricingPlansMutation({
 *   variables: {
 *     id: // value for 'id'
 *     attributes: // value for 'attributes'
 *     pricing: // value for 'pricing'
 *   },
 * });
 */
export function useUpdateReviewsProductWithPricingPlansMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateReviewsProductWithPricingPlansMutation,
        UpdateReviewsProductWithPricingPlansMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateReviewsProductWithPricingPlansMutation,
          UpdateReviewsProductWithPricingPlansMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateReviewsProductWithPricingPlansMutation,
    UpdateReviewsProductWithPricingPlansMutationVariables
  >(UpdateReviewsProductWithPricingPlansDocument, options)
}
export type UpdateReviewsProductWithPricingPlansMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateReviewsProductWithPricingPlansMutation,
  UpdateReviewsProductWithPricingPlansMutationVariables
>
export const UpsertReviewReplyDocument = gql`
  mutation upsertReviewReply($notifyReviewer: Boolean, $personalized: Boolean, $reply: String!, $reviewId: ID, $universalReviewId: ID) {
    manage {
      upsertReviewReply(
        input: {
          notifyReviewer: $notifyReviewer
          personalized: $personalized
          reply: $reply
          reviewId: $reviewId
          universalReviewId: $universalReviewId
        }
      ) {
        id
      }
    }
  }
`

/**
 * __useUpsertReviewReplyMutation__
 *
 * To run a mutation, you first call `useUpsertReviewReplyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReviewReplyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertReviewReplyMutation({
 *   variables: {
 *     notifyReviewer: // value for 'notifyReviewer'
 *     personalized: // value for 'personalized'
 *     reply: // value for 'reply'
 *     reviewId: // value for 'reviewId'
 *     universalReviewId: // value for 'universalReviewId'
 *   },
 * });
 */
export function useUpsertReviewReplyMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpsertReviewReplyMutation, UpsertReviewReplyMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertReviewReplyMutation, UpsertReviewReplyMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpsertReviewReplyMutation, UpsertReviewReplyMutationVariables>(UpsertReviewReplyDocument, options)
}
export type UpsertReviewReplyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpsertReviewReplyMutation,
  UpsertReviewReplyMutationVariables
>
export const BuyerInsightsDocument = gql`
  query buyerInsights($productSlug: ID!, $period: ManageInsightsPeriodPreset) {
    manage {
      insights(
        productSlug: $productSlug
        requests: [
          { competitionClickoutRate: { period: $period, orderBy: PERIOD, orderDir: ASC } }
          { buyerVisitingCompanies: { period: $period, orderBy: PERIOD, orderDir: ASC } }
        ]
      ) {
        results {
          metric
          status
          error
          response {
            __typename
            emptyReason
            ... on ManageInsightsClickoutRateResponse {
              rows {
                period
                pageviewsEstimated
                clickouts
              }
            }
            ... on ManageInsightsVisitingCompaniesResponse {
              rows {
                period
                demaskedCompanies
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useBuyerInsightsQuery__
 *
 * To run a query within a Vue component, call `useBuyerInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerInsightsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBuyerInsightsQuery({
 *   productSlug: // value for 'productSlug'
 *   period: // value for 'period'
 * });
 */
export function useBuyerInsightsQuery(
  variables:
    | BuyerInsightsQueryVariables
    | VueCompositionApi.Ref<BuyerInsightsQueryVariables>
    | ReactiveFunction<BuyerInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<BuyerInsightsQuery, BuyerInsightsQueryVariables>(BuyerInsightsDocument, variables, options)
}
export function useBuyerInsightsLazyQuery(
  variables?:
    | BuyerInsightsQueryVariables
    | VueCompositionApi.Ref<BuyerInsightsQueryVariables>
    | ReactiveFunction<BuyerInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BuyerInsightsQuery, BuyerInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<BuyerInsightsQuery, BuyerInsightsQueryVariables>(BuyerInsightsDocument, variables, options)
}
export type BuyerInsightsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BuyerInsightsQuery,
  BuyerInsightsQueryVariables
>
export const CompetitionInsightsDocument = gql`
  query competitionInsights(
    $productSlug: ID!
    $categorySlug: String!
    $period: ManageInsightsPeriodPreset
    $window: ManageInsightsWindowKey!
    $shareOfVoiceStart: ISO8601Date!
    $shareOfVoiceEnd: ISO8601Date!
    $covisitationStart: ISO8601Date!
    $covisitationEnd: ISO8601Date!
  ) {
    manage {
      insights(
        productSlug: $productSlug
        requests: [
          {
            competitionBenchmarkTiers: {
              categorySlug: $categorySlug
              measureName: PAGEVIEWS
              period: $period
              orderBy: PERIOD
              orderDir: ASC
            }
          }
          {
            competitionShareOfVoice: {
              categorySlug: $categorySlug
              startDate: $shareOfVoiceStart
              endDate: $shareOfVoiceEnd
              orderBy: PERIOD
              orderDir: ASC
            }
          }
          { competitionShareOfVoiceWindow: { categorySlug: $categorySlug, period: $window } }
          {
            competitionShareOfVoiceCompetitors: {
              categorySlug: $categorySlug
              period: $window
              orderBy: SOV_PAGEVIEWS_RANK
              orderDir: ASC
              limit: 4
            }
          }
          {
            competitionCovisitation: {
              startDate: $covisitationStart
              endDate: $covisitationEnd
              orderBy: PERIOD
              orderDir: ASC
              limit: 5000
            }
          }
          { competitionAttributeIndex: { categorySlug: $categorySlug, orderBy: TOTAL_MENTIONS, orderDir: DESC, limit: 6 } }
          { marketPricingLandscape: { entityId: $categorySlug, period: LATEST, orderBy: PRICE_DECILE, orderDir: ASC } }
          { competitionPricingPosition: {} }
        ]
      ) {
        results {
          metric
          status
          error
          response {
            __typename
            emptyReason
            ... on ManageInsightsBenchmarkTiersResponse {
              rows {
                period
                measureValue
                tier1Avg
                categoryMedian
              }
            }
            ... on ManageInsightsShareOfVoiceResponse {
              rows {
                period
                categoryPageviews
                toolsWithTraffic
              }
            }
            ... on ManageInsightsShareOfVoiceWindowResponse {
              rows {
                toolPageviews
                categoryPageviews
                sovPageviews
                previousSovPageviews
                previousComplete
              }
            }
            ... on ManageInsightsShareOfVoiceCompetitorsResponse {
              rows {
                toolSlug
                toolPageviews
              }
            }
            ... on ManageInsightsCovisitationResponse {
              truncated
              rows {
                period
                competitorSlug
                covisitingSessions
                comparingSessions
              }
            }
            ... on ManageInsightsAttributeIndexResponse {
              rows {
                attribute
                positiveShare
                categoryAvgPositiveShare
                totalMentions
                attrRank
              }
            }
            ... on ManageInsightsPricingLandscapeResponse {
              entity {
                id
              }
              rows {
                priceDecile
                avgEntryPriceMonthlyEur
                minEntryPriceMonthlyEur
                maxEntryPriceMonthlyEur
                productsInCategoryCount
                productsInDecile
              }
            }
            ... on ManageInsightsPricingPositionResponse {
              rows {
                entryPriceMonthlyEur
                priceDecile
                primaryCategorySlug
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCompetitionInsightsQuery__
 *
 * To run a query within a Vue component, call `useCompetitionInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionInsightsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompetitionInsightsQuery({
 *   productSlug: // value for 'productSlug'
 *   categorySlug: // value for 'categorySlug'
 *   period: // value for 'period'
 *   window: // value for 'window'
 *   shareOfVoiceStart: // value for 'shareOfVoiceStart'
 *   shareOfVoiceEnd: // value for 'shareOfVoiceEnd'
 *   covisitationStart: // value for 'covisitationStart'
 *   covisitationEnd: // value for 'covisitationEnd'
 * });
 */
export function useCompetitionInsightsQuery(
  variables:
    | CompetitionInsightsQueryVariables
    | VueCompositionApi.Ref<CompetitionInsightsQueryVariables>
    | ReactiveFunction<CompetitionInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>(
    CompetitionInsightsDocument,
    variables,
    options,
  )
}
export function useCompetitionInsightsLazyQuery(
  variables?:
    | CompetitionInsightsQueryVariables
    | VueCompositionApi.Ref<CompetitionInsightsQueryVariables>
    | ReactiveFunction<CompetitionInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CompetitionInsightsQuery, CompetitionInsightsQueryVariables>(
    CompetitionInsightsDocument,
    variables,
    options,
  )
}
export type CompetitionInsightsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CompetitionInsightsQuery,
  CompetitionInsightsQueryVariables
>
export const InsightsCategoryTopTenDocument = gql`
  query insightsCategoryTopTen($categorySlug: ID!) {
    exploreProducts(categorySlug: $categorySlug, sortBy: weighted_score, perPage: 10) {
      products {
        slug
        title
        reviewCount
        averageRecommendationRating
        logo {
          url
        }
      }
    }
  }
`

/**
 * __useInsightsCategoryTopTenQuery__
 *
 * To run a query within a Vue component, call `useInsightsCategoryTopTenQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsCategoryTopTenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInsightsCategoryTopTenQuery({
 *   categorySlug: // value for 'categorySlug'
 * });
 */
export function useInsightsCategoryTopTenQuery(
  variables:
    | InsightsCategoryTopTenQueryVariables
    | VueCompositionApi.Ref<InsightsCategoryTopTenQueryVariables>
    | ReactiveFunction<InsightsCategoryTopTenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>(
    InsightsCategoryTopTenDocument,
    variables,
    options,
  )
}
export function useInsightsCategoryTopTenLazyQuery(
  variables?:
    | InsightsCategoryTopTenQueryVariables
    | VueCompositionApi.Ref<InsightsCategoryTopTenQueryVariables>
    | ReactiveFunction<InsightsCategoryTopTenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<InsightsCategoryTopTenQuery, InsightsCategoryTopTenQueryVariables>(
    InsightsCategoryTopTenDocument,
    variables,
    options,
  )
}
export type InsightsCategoryTopTenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InsightsCategoryTopTenQuery,
  InsightsCategoryTopTenQueryVariables
>
export const InsightsProductsBySlugsDocument = gql`
  query insightsProductsBySlugs($slugs: [String!]!) {
    listProducts(slugs: $slugs) {
      slug
      title
      reviewCount
      averageRecommendationRating
      logo {
        url
      }
    }
  }
`

/**
 * __useInsightsProductsBySlugsQuery__
 *
 * To run a query within a Vue component, call `useInsightsProductsBySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsProductsBySlugsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInsightsProductsBySlugsQuery({
 *   slugs: // value for 'slugs'
 * });
 */
export function useInsightsProductsBySlugsQuery(
  variables:
    | InsightsProductsBySlugsQueryVariables
    | VueCompositionApi.Ref<InsightsProductsBySlugsQueryVariables>
    | ReactiveFunction<InsightsProductsBySlugsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>(
    InsightsProductsBySlugsDocument,
    variables,
    options,
  )
}
export function useInsightsProductsBySlugsLazyQuery(
  variables?:
    | InsightsProductsBySlugsQueryVariables
    | VueCompositionApi.Ref<InsightsProductsBySlugsQueryVariables>
    | ReactiveFunction<InsightsProductsBySlugsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<InsightsProductsBySlugsQuery, InsightsProductsBySlugsQueryVariables>(
    InsightsProductsBySlugsDocument,
    variables,
    options,
  )
}
export type InsightsProductsBySlugsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InsightsProductsBySlugsQuery,
  InsightsProductsBySlugsQueryVariables
>
export const MarketInsightsDocument = gql`
  query marketInsights(
    $productSlug: ID!
    $entityId: String!
    $period: ManageInsightsPeriodPreset
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
  ) {
    manage {
      insights(
        productSlug: $productSlug
        requests: [
          { competitionRankTracking: { categorySlug: $entityId, period: $period, orderBy: PERIOD, orderDir: ASC } }
          { marketCategoryDemand: { entityId: $entityId, startDate: $startDate, endDate: $endDate, orderBy: PERIOD, orderDir: ASC } }
          { marketReviewGrowth: { entityId: $entityId, startDate: $startDate, endDate: $endDate, orderBy: PERIOD, orderDir: ASC } }
          { marketNewEntrants: { entityId: $entityId, period: $period, orderBy: ENTRY_MONTH, orderDir: DESC } }
        ]
      ) {
        results {
          metric
          status
          error
          response {
            __typename
            emptyReason
            ... on ManageInsightsRankTrackingResponse {
              window {
                start
              }
              rows {
                period
                rankInCategory
              }
            }
            ... on ManageInsightsCategoryDemandResponse {
              rows {
                period
                sessions
                sessionsDeltaPrev
                pageviewsEstimated
                pageviewsEstimatedDeltaPrev
                toolsWithTraffic
                toolsWithTrafficDeltaPrev
              }
            }
            ... on ManageInsightsReviewGrowthResponse {
              rows {
                period
                newReviews
                newReviewsDeltaPrev
                cumulativeReviews
              }
            }
            ... on ManageInsightsNewEntrantsResponse {
              rows {
                toolSlug
                entryVia
                entryMonth
                enteredViaReview
                enteredViaTraffic
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useMarketInsightsQuery__
 *
 * To run a query within a Vue component, call `useMarketInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketInsightsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMarketInsightsQuery({
 *   productSlug: // value for 'productSlug'
 *   entityId: // value for 'entityId'
 *   period: // value for 'period'
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 * });
 */
export function useMarketInsightsQuery(
  variables:
    | MarketInsightsQueryVariables
    | VueCompositionApi.Ref<MarketInsightsQueryVariables>
    | ReactiveFunction<MarketInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<MarketInsightsQuery, MarketInsightsQueryVariables>(MarketInsightsDocument, variables, options)
}
export function useMarketInsightsLazyQuery(
  variables?:
    | MarketInsightsQueryVariables
    | VueCompositionApi.Ref<MarketInsightsQueryVariables>
    | ReactiveFunction<MarketInsightsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<MarketInsightsQuery, MarketInsightsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<MarketInsightsQuery, MarketInsightsQueryVariables>(MarketInsightsDocument, variables, options)
}
export type MarketInsightsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  MarketInsightsQuery,
  MarketInsightsQueryVariables
>
export const ReviewsAgenciesDocument = gql`
  query reviewsAgencies {
    manage {
      agencies {
        ...agencyBasicFields
      }
    }
  }
  ${AgencyBasicFieldsFragmentDoc}
`

/**
 * __useReviewsAgenciesQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgenciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgenciesQuery();
 */
export function useReviewsAgenciesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>(ReviewsAgenciesDocument, {}, options)
}
export function useReviewsAgenciesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgenciesQuery, ReviewsAgenciesQueryVariables>(ReviewsAgenciesDocument, {}, options)
}
export type ReviewsAgenciesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgenciesQuery,
  ReviewsAgenciesQueryVariables
>
export const ReviewsAgencyByIdDocument = gql`
  query reviewsAgencyById($id: ID!) {
    manage {
      agency(id: $id) {
        ...agencyDetailsFields
        config {
          ...AgencyConfigFields
        }
      }
    }
  }
  ${AgencyDetailsFieldsFragmentDoc}
  ${AgencyConfigFieldsFragmentDoc}
`

/**
 * __useReviewsAgencyByIdQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsAgencyByIdQuery(
  variables:
    | ReviewsAgencyByIdQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyByIdQueryVariables>
    | ReactiveFunction<ReviewsAgencyByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>(
    ReviewsAgencyByIdDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyByIdLazyQuery(
  variables?:
    | ReviewsAgencyByIdQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyByIdQueryVariables>
    | ReactiveFunction<ReviewsAgencyByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyByIdQuery, ReviewsAgencyByIdQueryVariables>(
    ReviewsAgencyByIdDocument,
    variables,
    options,
  )
}
export type ReviewsAgencyByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyByIdQuery,
  ReviewsAgencyByIdQueryVariables
>
export const ReviewsAgencyFeaturesDocument = gql`
  query reviewsAgencyFeatures($categories: [ID!]!) {
    agencyFeatures(categories: $categories) {
      id
      name
      category {
        id
        title
      }
    }
  }
`

/**
 * __useReviewsAgencyFeaturesQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyFeaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyFeaturesQuery({
 *   categories: // value for 'categories'
 * });
 */
export function useReviewsAgencyFeaturesQuery(
  variables:
    | ReviewsAgencyFeaturesQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyFeaturesQueryVariables>
    | ReactiveFunction<ReviewsAgencyFeaturesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>(
    ReviewsAgencyFeaturesDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyFeaturesLazyQuery(
  variables?:
    | ReviewsAgencyFeaturesQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyFeaturesQueryVariables>
    | ReactiveFunction<ReviewsAgencyFeaturesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyFeaturesQuery, ReviewsAgencyFeaturesQueryVariables>(
    ReviewsAgencyFeaturesDocument,
    variables,
    options,
  )
}
export type ReviewsAgencyFeaturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyFeaturesQuery,
  ReviewsAgencyFeaturesQueryVariables
>
export const ReviewsAgencyOptionsDocument = gql`
  query reviewsAgencyOptions {
    manage {
      options {
        cities {
          name
          slug
        }
        industries {
          id
          name
        }
      }
    }
  }
`

/**
 * __useReviewsAgencyOptionsQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyOptionsQuery();
 */
export function useReviewsAgencyOptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>(
    ReviewsAgencyOptionsDocument,
    {},
    options,
  )
}
export function useReviewsAgencyOptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyOptionsQuery, ReviewsAgencyOptionsQueryVariables>(
    ReviewsAgencyOptionsDocument,
    {},
    options,
  )
}
export type ReviewsAgencyOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyOptionsQuery,
  ReviewsAgencyOptionsQueryVariables
>
export const ReviewsAgencyToolPartnerOptionsDocument = gql`
  query reviewsAgencyToolPartnerOptions(
    $page: Int! = 1
    $perPage: Int! = 100
    $sortBy: ExploreProductsSortingEnum! = relevance
    $searchTerm: String
    $exclude: [ID!]
  ) {
    exploreProducts(page: $page, perPage: $perPage, sortBy: $sortBy, term: $searchTerm, exclude: $exclude) {
      pagination {
        currentPage
        hasNextPage
      }
      products {
        ...productBasicData
      }
    }
  }
  ${ProductBasicDataFragmentDoc}
`

/**
 * __useReviewsAgencyToolPartnerOptionsQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyToolPartnerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyToolPartnerOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyToolPartnerOptionsQuery({
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   sortBy: // value for 'sortBy'
 *   searchTerm: // value for 'searchTerm'
 *   exclude: // value for 'exclude'
 * });
 */
export function useReviewsAgencyToolPartnerOptionsQuery(
  variables:
    | ReviewsAgencyToolPartnerOptionsQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyToolPartnerOptionsQueryVariables>
    | ReactiveFunction<ReviewsAgencyToolPartnerOptionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>(
    ReviewsAgencyToolPartnerOptionsDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyToolPartnerOptionsLazyQuery(
  variables?:
    | ReviewsAgencyToolPartnerOptionsQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyToolPartnerOptionsQueryVariables>
    | ReactiveFunction<ReviewsAgencyToolPartnerOptionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyToolPartnerOptionsQuery, ReviewsAgencyToolPartnerOptionsQueryVariables>(
    ReviewsAgencyToolPartnerOptionsDocument,
    variables,
    options,
  )
}
export type ReviewsAgencyToolPartnerOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyToolPartnerOptionsQuery,
  ReviewsAgencyToolPartnerOptionsQueryVariables
>
export const ReviewsAgencyUniversalReviewDocument = gql`
  query reviewsAgencyUniversalReview($id: ID!) {
    manage {
      universalReview(id: $id) {
        id
        currentStatus
        anonymous
        reviewerName
        companyField
        companyName
        companyPosition
        companySize
        title
        statement
        npsScore
        publishedAt
        firstPublishedAt
        createdAt
        manualReminderDisabled
        reminders {
          id
          kind
          message
          sentAt
          userId
        }
        reviewReply {
          id
          personalized
          reply
          senderName
        }
      }
    }
  }
`

/**
 * __useReviewsAgencyUniversalReviewQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyUniversalReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyUniversalReviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyUniversalReviewQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsAgencyUniversalReviewQuery(
  variables:
    | ReviewsAgencyUniversalReviewQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>(
    ReviewsAgencyUniversalReviewDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyUniversalReviewLazyQuery(
  variables?:
    | ReviewsAgencyUniversalReviewQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyUniversalReviewQuery, ReviewsAgencyUniversalReviewQueryVariables>(
    ReviewsAgencyUniversalReviewDocument,
    variables,
    options,
  )
}
export type ReviewsAgencyUniversalReviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyUniversalReviewQuery,
  ReviewsAgencyUniversalReviewQueryVariables
>
export const ReviewsAgencyUniversalReviewsDocument = gql`
  query reviewsAgencyUniversalReviews(
    $subjectId: GlobalId!
    $page: Int
    $perPage: Int
    $sortBy: ManageUniversalReviewsSortByEnum = date
    $sortDirection: SortDirectionEnum = desc
    $filters: ManageUniversalReviewsSearchFilters
  ) {
    manage {
      universalReviews(
        subjectId: $subjectId
        page: $page
        perPage: $perPage
        sortBy: $sortBy
        sortDirection: $sortDirection
        filters: $filters
      ) {
        reviews {
          id
          currentStatus
          createdAt
          publishedAt
          firstPublishedAt
          anonymous
          reviewerName
          companyName
          npsScore
          reminders {
            id
          }
          reviewReply {
            id
          }
        }
        pagination {
          currentPage
          perPage
          totalCount
          hasNextPage
          totalPages
        }
      }
    }
  }
`

/**
 * __useReviewsAgencyUniversalReviewsQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyUniversalReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyUniversalReviewsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyUniversalReviewsQuery({
 *   subjectId: // value for 'subjectId'
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   sortBy: // value for 'sortBy'
 *   sortDirection: // value for 'sortDirection'
 *   filters: // value for 'filters'
 * });
 */
export function useReviewsAgencyUniversalReviewsQuery(
  variables:
    | ReviewsAgencyUniversalReviewsQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewsQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>(
    ReviewsAgencyUniversalReviewsDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyUniversalReviewsLazyQuery(
  variables?:
    | ReviewsAgencyUniversalReviewsQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewsQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsAgencyUniversalReviewsQuery, ReviewsAgencyUniversalReviewsQueryVariables>(
    ReviewsAgencyUniversalReviewsDocument,
    variables,
    options,
  )
}
export type ReviewsAgencyUniversalReviewsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyUniversalReviewsQuery,
  ReviewsAgencyUniversalReviewsQueryVariables
>
export const ReviewsAgencyUniversalReviewsExportCsvDocument = gql`
  query reviewsAgencyUniversalReviewsExportCsv(
    $subjectId: GlobalId!
    $sortBy: ManageUniversalReviewsSortByEnum = date
    $sortDirection: SortDirectionEnum = desc
    $filters: ManageUniversalReviewsSearchFilters
  ) {
    manage {
      universalReviewsExportCsv(
        subjectId: $subjectId
        sortBy: $sortBy
        sortDirection: $sortDirection
        filters: $filters
        fields: [
          { key: current_status, name: "Status" }
          { key: created_at, name: "Created at" }
          { key: first_published_at, name: "First published at" }
          { key: updated_at, name: "Updated at" }
          { key: published_at, name: "Published at" }
          { key: reviewer_name, name: "Reviewer name" }
          { key: company_name, name: "Company Name" }
          { key: title, name: "Title" }
          { key: statement, name: "Statement" }
          { key: nps_score, name: "Rating" }
          { key: reply_text, name: "Reply" }
        ]
      ) {
        errors
        fileUrl
      }
    }
  }
`

/**
 * __useReviewsAgencyUniversalReviewsExportCsvQuery__
 *
 * To run a query within a Vue component, call `useReviewsAgencyUniversalReviewsExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAgencyUniversalReviewsExportCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsAgencyUniversalReviewsExportCsvQuery({
 *   subjectId: // value for 'subjectId'
 *   sortBy: // value for 'sortBy'
 *   sortDirection: // value for 'sortDirection'
 *   filters: // value for 'filters'
 * });
 */
export function useReviewsAgencyUniversalReviewsExportCsvQuery(
  variables:
    | ReviewsAgencyUniversalReviewsExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewsExportCsvQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewsExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsExportCsvQuery, ReviewsAgencyUniversalReviewsExportCsvQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsAgencyUniversalReviewsExportCsvQuery,
          ReviewsAgencyUniversalReviewsExportCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsAgencyUniversalReviewsExportCsvQuery,
          ReviewsAgencyUniversalReviewsExportCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsAgencyUniversalReviewsExportCsvQuery, ReviewsAgencyUniversalReviewsExportCsvQueryVariables>(
    ReviewsAgencyUniversalReviewsExportCsvDocument,
    variables,
    options,
  )
}
export function useReviewsAgencyUniversalReviewsExportCsvLazyQuery(
  variables?:
    | ReviewsAgencyUniversalReviewsExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsAgencyUniversalReviewsExportCsvQueryVariables>
    | ReactiveFunction<ReviewsAgencyUniversalReviewsExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsAgencyUniversalReviewsExportCsvQuery, ReviewsAgencyUniversalReviewsExportCsvQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsAgencyUniversalReviewsExportCsvQuery,
          ReviewsAgencyUniversalReviewsExportCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsAgencyUniversalReviewsExportCsvQuery,
          ReviewsAgencyUniversalReviewsExportCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ReviewsAgencyUniversalReviewsExportCsvQuery,
    ReviewsAgencyUniversalReviewsExportCsvQueryVariables
  >(ReviewsAgencyUniversalReviewsExportCsvDocument, variables, options)
}
export type ReviewsAgencyUniversalReviewsExportCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsAgencyUniversalReviewsExportCsvQuery,
  ReviewsAgencyUniversalReviewsExportCsvQueryVariables
>
export const ReviewsCurrentUserDocument = gql`
  query reviewsCurrentUser {
    manage {
      currentUser {
        hasAccessToOmrViewer
        accountType
        company {
          id
          name
          slug
          planTier
        }
      }
    }
  }
`

/**
 * __useReviewsCurrentUserQuery__
 *
 * To run a query within a Vue component, call `useReviewsCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsCurrentUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsCurrentUserQuery();
 */
export function useReviewsCurrentUserQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>(ReviewsCurrentUserDocument, {}, options)
}
export function useReviewsCurrentUserLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsCurrentUserQuery, ReviewsCurrentUserQueryVariables>(
    ReviewsCurrentUserDocument,
    {},
    options,
  )
}
export type ReviewsCurrentUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsCurrentUserQuery,
  ReviewsCurrentUserQueryVariables
>
export const ReviewsIncentivizationCampaignDocument = gql`
  query reviewsIncentivizationCampaign($campaignId: ID!) {
    manage {
      incentivizationCampaign(campaign: $campaignId) {
        id
        enabled
        amount
        available
        createdAt
        title
        validFrom
        validTo
        incentivizationsLimit
        incentivizationType
        wonIncentivizationsCount
        associatedReviewsCount
        status
        limitType
        hashValue
        personalizations {
          id
          inviteMessage
          locale
          hashValue
        }
      }
    }
  }
`

/**
 * __useReviewsIncentivizationCampaignQuery__
 *
 * To run a query within a Vue component, call `useReviewsIncentivizationCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsIncentivizationCampaignQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsIncentivizationCampaignQuery({
 *   campaignId: // value for 'campaignId'
 * });
 */
export function useReviewsIncentivizationCampaignQuery(
  variables:
    | ReviewsIncentivizationCampaignQueryVariables
    | VueCompositionApi.Ref<ReviewsIncentivizationCampaignQueryVariables>
    | ReactiveFunction<ReviewsIncentivizationCampaignQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>(
    ReviewsIncentivizationCampaignDocument,
    variables,
    options,
  )
}
export function useReviewsIncentivizationCampaignLazyQuery(
  variables?:
    | ReviewsIncentivizationCampaignQueryVariables
    | VueCompositionApi.Ref<ReviewsIncentivizationCampaignQueryVariables>
    | ReactiveFunction<ReviewsIncentivizationCampaignQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsIncentivizationCampaignQuery, ReviewsIncentivizationCampaignQueryVariables>(
    ReviewsIncentivizationCampaignDocument,
    variables,
    options,
  )
}
export type ReviewsIncentivizationCampaignQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsIncentivizationCampaignQuery,
  ReviewsIncentivizationCampaignQueryVariables
>
export const ReviewsIncentivizationCampaignsDocument = gql`
  query reviewsIncentivizationCampaigns($productId: ID!, $statuses: [IncentivizationCampaignStatusEnum!]) {
    manage {
      incentivizationCampaigns(product: $productId, statuses: $statuses) {
        id
        enabled
        amount
        createdAt
        title
        validFrom
        validTo
        status
        incentivizationsLimit
        wonIncentivizationsCount
        totalIncentivizationsCount
        associatedReviewsCount
        hashValue
        personalizations {
          id
          inviteMessage
          locale
          hashValue
        }
      }
    }
  }
`

/**
 * __useReviewsIncentivizationCampaignsQuery__
 *
 * To run a query within a Vue component, call `useReviewsIncentivizationCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsIncentivizationCampaignsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsIncentivizationCampaignsQuery({
 *   productId: // value for 'productId'
 *   statuses: // value for 'statuses'
 * });
 */
export function useReviewsIncentivizationCampaignsQuery(
  variables:
    | ReviewsIncentivizationCampaignsQueryVariables
    | VueCompositionApi.Ref<ReviewsIncentivizationCampaignsQueryVariables>
    | ReactiveFunction<ReviewsIncentivizationCampaignsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>(
    ReviewsIncentivizationCampaignsDocument,
    variables,
    options,
  )
}
export function useReviewsIncentivizationCampaignsLazyQuery(
  variables?:
    | ReviewsIncentivizationCampaignsQueryVariables
    | VueCompositionApi.Ref<ReviewsIncentivizationCampaignsQueryVariables>
    | ReactiveFunction<ReviewsIncentivizationCampaignsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsIncentivizationCampaignsQuery, ReviewsIncentivizationCampaignsQueryVariables>(
    ReviewsIncentivizationCampaignsDocument,
    variables,
    options,
  )
}
export type ReviewsIncentivizationCampaignsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsIncentivizationCampaignsQuery,
  ReviewsIncentivizationCampaignsQueryVariables
>
export const ReviewsInsightsGrowthDocument = gql`
  query reviewsInsightsGrowth(
    $productSlug: ID!
    $mainCategorySlug: String!
    $growthStart: ISO8601Date!
    $growthEnd: ISO8601Date!
    $windowStart: ISO8601Date!
    $historyStart: ISO8601Date!
    $historyEnd: ISO8601Date!
    $segmentsBefore: ISO8601Date!
    $segmentsEnd: ISO8601Date!
    $monthlyStart: ISO8601Date!
    $monthlyEnd: ISO8601Date!
  ) {
    manage {
      insights(
        productSlug: $productSlug
        requests: [
          {
            competitionReviewGrowth: {
              categorySlug: $mainCategorySlug
              startDate: $growthStart
              endDate: $growthEnd
              orderBy: PERIOD
              orderDir: ASC
            }
          }
          { competitionAttributeSentiment: { startDate: $windowStart, endDate: $growthEnd, orderBy: PERIOD, orderDir: ASC, limit: 500 } }
          { vendorRatingHistory: { startDate: $historyStart, endDate: $historyEnd, orderBy: PERIOD, orderDir: ASC } }
          { competitionReviewFreshness: { startDate: $windowStart, endDate: $growthEnd, orderBy: PERIOD, orderDir: ASC, limit: 500 } }
          { buyerReviewerMix: { startDate: $segmentsEnd, endDate: $segmentsEnd, limit: 500 } }
          { buyerReviewerMix: { startDate: $segmentsBefore, endDate: $segmentsBefore, limit: 500 } }
          { buyerNpsBySegment: { startDate: $segmentsEnd, endDate: $segmentsEnd, limit: 500 } }
          { buyerNpsBySegment: { startDate: $segmentsBefore, endDate: $segmentsBefore, limit: 500 } }
          { vendorRatingMonthly: { startDate: $monthlyStart, endDate: $monthlyEnd, orderBy: PERIOD, orderDir: ASC, limit: 500 } }
          { vendorToolSwitches: { startDate: $monthlyStart, endDate: $monthlyEnd, orderBy: PERIOD, orderDir: ASC, limit: 500 } }
          { vendorToolSwitchesLifetime: { limit: 500 } }
        ]
      ) {
        results {
          metric
          status
          error
          response {
            __typename
            emptyReason
            ... on ManageInsightsToolReviewGrowthResponse {
              rows {
                period
                newReviews
              }
            }
            ... on ManageInsightsAttributeSentimentResponse {
              rows {
                period
                attribute
                positiveMentions
                negativeMentions
                totalMentions
                reviewsWithPositiveMention
                reviewsWithNegativeMention
                reviewCount
              }
            }
            ... on ManageInsightsRatingHistoryResponse {
              rows {
                period
                averageRecommendationRating
                reviewCount
                ratingDeltaPrev
              }
            }
            ... on ManageInsightsReviewFreshnessResponse {
              rows {
                period
                categorySlug
                newReviewCountByPurpose
              }
            }
            ... on ManageInsightsReviewerMixResponse {
              rows {
                segmentType
                segmentValue
                reviewCount
                toolDimReviews
                categoryReviewCount
                categoryDimReviews
              }
            }
            ... on ManageInsightsNpsBySegmentResponse {
              rows {
                segmentType
                segmentValue
                reviewCount
                promoters
                detractors
              }
            }
            ... on ManageInsightsRatingMonthlyResponse {
              rows {
                period
                reviewsBad
                reviewsWorse
                reviewsGood
                reviewsBetter
                reviewsBest
                avgEaseOfUse
                easeOfUseCount
                avgEaseOfSetup
                easeOfSetupCount
                avgCustomerSupportScore
                customerSupportScoreCount
                avgRequirementsScore
                requirementsScoreCount
                categoryAvgEaseOfUse
                categoryEaseOfUseCount
                categoryAvgEaseOfSetup
                categoryEaseOfSetupCount
                categoryAvgCustomerSupportScore
                categoryCustomerSupportScoreCount
                categoryAvgRequirementsScore
                categoryRequirementsScoreCount
              }
            }
            ... on ManageInsightsToolSwitchesResponse {
              rows {
                period
                source
                switchedFromType
                switchedFromToolTitle
                reviewers
                answeredCount
                switchedCount
                sourcedCount
              }
            }
            ... on ManageInsightsToolSwitchesLifetimeResponse {
              rows {
                source
                switchedFromType
                switchedFromToolTitle
                reviewers
                answeredCount
                switchedCount
                sourcedCount
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useReviewsInsightsGrowthQuery__
 *
 * To run a query within a Vue component, call `useReviewsInsightsGrowthQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsInsightsGrowthQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsInsightsGrowthQuery({
 *   productSlug: // value for 'productSlug'
 *   mainCategorySlug: // value for 'mainCategorySlug'
 *   growthStart: // value for 'growthStart'
 *   growthEnd: // value for 'growthEnd'
 *   windowStart: // value for 'windowStart'
 *   historyStart: // value for 'historyStart'
 *   historyEnd: // value for 'historyEnd'
 *   segmentsBefore: // value for 'segmentsBefore'
 *   segmentsEnd: // value for 'segmentsEnd'
 *   monthlyStart: // value for 'monthlyStart'
 *   monthlyEnd: // value for 'monthlyEnd'
 * });
 */
export function useReviewsInsightsGrowthQuery(
  variables:
    | ReviewsInsightsGrowthQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsGrowthQueryVariables>
    | ReactiveFunction<ReviewsInsightsGrowthQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>(
    ReviewsInsightsGrowthDocument,
    variables,
    options,
  )
}
export function useReviewsInsightsGrowthLazyQuery(
  variables?:
    | ReviewsInsightsGrowthQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsGrowthQueryVariables>
    | ReactiveFunction<ReviewsInsightsGrowthQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsInsightsGrowthQuery, ReviewsInsightsGrowthQueryVariables>(
    ReviewsInsightsGrowthDocument,
    variables,
    options,
  )
}
export type ReviewsInsightsGrowthQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsInsightsGrowthQuery,
  ReviewsInsightsGrowthQueryVariables
>
export const ReviewsInsightsLatestDocument = gql`
  query reviewsInsightsLatest($productSlug: ID!, $mainCategorySlug: String!) {
    manage {
      insights(
        productSlug: $productSlug
        requests: [
          { competitionReviewFreshness: { period: LATEST, orderBy: PERIOD, orderDir: ASC } }
          {
            competitionBenchmarkTiers: {
              categorySlug: $mainCategorySlug
              measureName: REVIEW_VELOCITY
              period: LATEST
              orderBy: PERIOD
              orderDir: ASC
            }
          }
          { vendorRatingSummary: {} }
          { vendorCampaignPerformance: { orderBy: CAMPAIGN_VALID_FROM, orderDir: DESC, limit: 10 } }
          {
            competitionBenchmarkTiers: {
              categorySlug: $mainCategorySlug
              measureName: REVIEW_COUNT
              period: LATEST
              orderBy: PERIOD
              orderDir: ASC
            }
          }
        ]
      ) {
        results {
          metric
          status
          error
          response {
            __typename
            emptyReason
            ... on ManageInsightsReviewFreshnessResponse {
              rows {
                period
                categorySlug
                reviewCountByPurpose
                outdatedReviewShare
              }
            }
            ... on ManageInsightsBenchmarkTiersResponse {
              rows {
                period
                tier1Avg
                tier2Avg
                categoryAvg
                categoryMedian
                rankedToolsInCategory
              }
            }
            ... on ManageInsightsRatingSummaryResponse {
              rows {
                reviewCount
                replyRate
                averageRecommendationRating
                reviewsBad
                reviewsWorse
                reviewsGood
                reviewsBetter
                reviewsBest
                avgEaseOfUse
                avgEaseOfSetup
                avgCustomerSupportScore
                avgRequirementsScore
                categoryAvgEaseOfUse
                categoryAvgEaseOfSetup
                categoryAvgCustomerSupportScore
                categoryAvgRequirementsScore
                isSuite
              }
            }
            ... on ManageInsightsCampaignPerformanceResponse {
              rows {
                campaignId
                campaignTitle
                campaignStatus
                campaignValidFrom
                campaignValidTo
                startedCount
                submittedCount
                publishedCount
                submitRate
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useReviewsInsightsLatestQuery__
 *
 * To run a query within a Vue component, call `useReviewsInsightsLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsInsightsLatestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsInsightsLatestQuery({
 *   productSlug: // value for 'productSlug'
 *   mainCategorySlug: // value for 'mainCategorySlug'
 * });
 */
export function useReviewsInsightsLatestQuery(
  variables:
    | ReviewsInsightsLatestQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsLatestQueryVariables>
    | ReactiveFunction<ReviewsInsightsLatestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>(
    ReviewsInsightsLatestDocument,
    variables,
    options,
  )
}
export function useReviewsInsightsLatestLazyQuery(
  variables?:
    | ReviewsInsightsLatestQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsLatestQueryVariables>
    | ReactiveFunction<ReviewsInsightsLatestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsInsightsLatestQuery, ReviewsInsightsLatestQueryVariables>(
    ReviewsInsightsLatestDocument,
    variables,
    options,
  )
}
export type ReviewsInsightsLatestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsInsightsLatestQuery,
  ReviewsInsightsLatestQueryVariables
>
export const ReviewsInsightsSurveyResponseFacetsDocument = gql`
  query reviewsInsightsSurveyResponseFacets($productSlug: ID!) {
    manage {
      all: surveyResponses(productSlug: $productSlug, perPage: 1) {
        stateFacet {
          key
          docCount
        }
      }
    }
  }
`

/**
 * __useReviewsInsightsSurveyResponseFacetsQuery__
 *
 * To run a query within a Vue component, call `useReviewsInsightsSurveyResponseFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsInsightsSurveyResponseFacetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsInsightsSurveyResponseFacetsQuery({
 *   productSlug: // value for 'productSlug'
 * });
 */
export function useReviewsInsightsSurveyResponseFacetsQuery(
  variables:
    | ReviewsInsightsSurveyResponseFacetsQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsSurveyResponseFacetsQueryVariables>
    | ReactiveFunction<ReviewsInsightsSurveyResponseFacetsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>(
    ReviewsInsightsSurveyResponseFacetsDocument,
    variables,
    options,
  )
}
export function useReviewsInsightsSurveyResponseFacetsLazyQuery(
  variables?:
    | ReviewsInsightsSurveyResponseFacetsQueryVariables
    | VueCompositionApi.Ref<ReviewsInsightsSurveyResponseFacetsQueryVariables>
    | ReactiveFunction<ReviewsInsightsSurveyResponseFacetsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsInsightsSurveyResponseFacetsQuery, ReviewsInsightsSurveyResponseFacetsQueryVariables>(
    ReviewsInsightsSurveyResponseFacetsDocument,
    variables,
    options,
  )
}
export type ReviewsInsightsSurveyResponseFacetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsInsightsSurveyResponseFacetsQuery,
  ReviewsInsightsSurveyResponseFacetsQueryVariables
>
export const ReviewsLeadDocument = gql`
  query reviewsLead($id: ID!) {
    manage {
      lead(id: $id) {
        id
        senderName
        senderEmail
        senderCompany
        senderPhone
        senderCompanyPosition
        latestRequestAt
        archivedAt
        status
        statusChangedAt
        contactRequests {
          id
          contactRequestType
          message
          createdAt
          locked
        }
        notes {
          id
          authorName
          body
          createdAt
        }
        history {
          id
          kind
          actorName
          body
          createdAt
          fromStatus
          toStatus
        }
      }
    }
  }
`

/**
 * __useReviewsLeadQuery__
 *
 * To run a query within a Vue component, call `useReviewsLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsLeadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsLeadQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsLeadQuery(
  variables: ReviewsLeadQueryVariables | VueCompositionApi.Ref<ReviewsLeadQueryVariables> | ReactiveFunction<ReviewsLeadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsLeadQuery, ReviewsLeadQueryVariables>(ReviewsLeadDocument, variables, options)
}
export function useReviewsLeadLazyQuery(
  variables?: ReviewsLeadQueryVariables | VueCompositionApi.Ref<ReviewsLeadQueryVariables> | ReactiveFunction<ReviewsLeadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadQuery, ReviewsLeadQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsLeadQuery, ReviewsLeadQueryVariables>(ReviewsLeadDocument, variables, options)
}
export type ReviewsLeadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReviewsLeadQuery, ReviewsLeadQueryVariables>
export const ReviewsLeadsDocument = gql`
  query reviewsLeads(
    $contactableId: GlobalId
    $filters: ManageLeadsSearchFilters
    $page: Int
    $perPage: Int
    $sortBy: LeadsSortByEnum
    $sortDirection: SortDirectionEnum
  ) {
    manage {
      leads(
        contactableId: $contactableId
        filters: $filters
        page: $page
        perPage: $perPage
        sortBy: $sortBy
        sortDirection: $sortDirection
      ) {
        results {
          id
          contactRequestType
          senderName
          senderEmail
          senderCompany
          createdAt
          locked
          leadStatus
        }
        pagination {
          currentPage
          perPage
          totalCount
          totalPages
          hasNextPage
          hasPrevPage
        }
        contactRequestTypeFacet {
          key
          docCount
        }
      }
    }
  }
`

/**
 * __useReviewsLeadsQuery__
 *
 * To run a query within a Vue component, call `useReviewsLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsLeadsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsLeadsQuery({
 *   contactableId: // value for 'contactableId'
 *   filters: // value for 'filters'
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   sortBy: // value for 'sortBy'
 *   sortDirection: // value for 'sortDirection'
 * });
 */
export function useReviewsLeadsQuery(
  variables:
    | ReviewsLeadsQueryVariables
    | VueCompositionApi.Ref<ReviewsLeadsQueryVariables>
    | ReactiveFunction<ReviewsLeadsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>(ReviewsLeadsDocument, variables, options)
}
export function useReviewsLeadsLazyQuery(
  variables:
    | ReviewsLeadsQueryVariables
    | VueCompositionApi.Ref<ReviewsLeadsQueryVariables>
    | ReactiveFunction<ReviewsLeadsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>(ReviewsLeadsDocument, variables, options)
}
export type ReviewsLeadsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReviewsLeadsQuery, ReviewsLeadsQueryVariables>
export const ReviewsLeadsExportCsvDocument = gql`
  query reviewsLeadsExportCsv(
    $contactableId: GlobalId!
    $fields: [ManageLeadsFieldsEntry!]!
    $filters: ManageLeadsSearchFilters
    $sortBy: LeadsSortByEnum
    $sortDirection: SortDirectionEnum
  ) {
    manage {
      leadsExportCsv(contactableId: $contactableId, fields: $fields, filters: $filters, sortBy: $sortBy, sortDirection: $sortDirection) {
        fileUrl
        errors
      }
    }
  }
`

/**
 * __useReviewsLeadsExportCsvQuery__
 *
 * To run a query within a Vue component, call `useReviewsLeadsExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsLeadsExportCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsLeadsExportCsvQuery({
 *   contactableId: // value for 'contactableId'
 *   fields: // value for 'fields'
 *   filters: // value for 'filters'
 *   sortBy: // value for 'sortBy'
 *   sortDirection: // value for 'sortDirection'
 * });
 */
export function useReviewsLeadsExportCsvQuery(
  variables:
    | ReviewsLeadsExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsLeadsExportCsvQueryVariables>
    | ReactiveFunction<ReviewsLeadsExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>(
    ReviewsLeadsExportCsvDocument,
    variables,
    options,
  )
}
export function useReviewsLeadsExportCsvLazyQuery(
  variables?:
    | ReviewsLeadsExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsLeadsExportCsvQueryVariables>
    | ReactiveFunction<ReviewsLeadsExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsLeadsExportCsvQuery, ReviewsLeadsExportCsvQueryVariables>(
    ReviewsLeadsExportCsvDocument,
    variables,
    options,
  )
}
export type ReviewsLeadsExportCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsLeadsExportCsvQuery,
  ReviewsLeadsExportCsvQueryVariables
>
export const ReviewsProductByIdDocument = gql`
  query reviewsProductById($id: ID!) {
    manage {
      product(id: $id) {
        ...productBasicData
        companySlug
        hasPaidPlan
        hero {
          ...assetFields
        }
        heroVideoThumbnail {
          ...assetFields
        }
        documents {
          ...documentFields
        }
        config {
          ...ProductConfigFields
        }
        screenshots {
          ...screenshotFields
        }
        mainCategory {
          id
          slug
          title
        }
        categories {
          id
          slug
          title
          hidden
          published
        }
        descriptionTranslations {
          locale
          value
        }
        shortDescriptionTranslations {
          locale
          value
        }
        twitter
        linkedin
        urlTranslations {
          locale
          value
        }
        linkTextTranslations {
          locale
          value
        }
        showDisclaimer
        disclaimerText
        disclaimerUrl
        disclaimerTextTranslations {
          locale
          value
        }
        disclaimerUrlTranslations {
          locale
          value
        }
        freePlanAvailable
        freeDemo
        freeTrial
        trialUnit
        trialPeriod
        noPricingPlans
        noPricingPlansHint
        noPricingPlansHintTranslations {
          locale
          value
        }
        pricingPlans {
          ...ProductPricingPlan
        }
        cloud
        anytimeSupport
        onPremise
        germanSupport
        germanLocation
        euLocation
        euStandardContract
        euCompanyAffiliated
        ctaSecondaryLabelTranslations {
          locale
          value
        }
        ctaSecondaryUrlTranslations {
          locale
          value
        }
        ctaSecondary {
          url
          label
        }
        contactFormRecipients
        pageVisitReportEmails
        vendorEmailAddresses
        currentBudget {
          value
          usedValue
          endDate
          additionalValue
          remainingValue
        }
      }
    }
  }
  ${ProductBasicDataFragmentDoc}
  ${AssetFieldsFragmentDoc}
  ${DocumentFieldsFragmentDoc}
  ${ProductConfigFieldsFragmentDoc}
  ${ScreenshotFieldsFragmentDoc}
  ${ProductPricingPlanFragmentDoc}
`

/**
 * __useReviewsProductByIdQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsProductByIdQuery(
  variables:
    | ReviewsProductByIdQueryVariables
    | VueCompositionApi.Ref<ReviewsProductByIdQueryVariables>
    | ReactiveFunction<ReviewsProductByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>(
    ReviewsProductByIdDocument,
    variables,
    options,
  )
}
export function useReviewsProductByIdLazyQuery(
  variables?:
    | ReviewsProductByIdQueryVariables
    | VueCompositionApi.Ref<ReviewsProductByIdQueryVariables>
    | ReactiveFunction<ReviewsProductByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductByIdQuery, ReviewsProductByIdQueryVariables>(
    ReviewsProductByIdDocument,
    variables,
    options,
  )
}
export type ReviewsProductByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductByIdQuery,
  ReviewsProductByIdQueryVariables
>
export const ReviewsProductOptionsDocument = gql`
  query reviewsProductOptions {
    manage {
      options {
        pricingTextOptions {
          id
          name
          nameTranslations {
            ...translationFields
          }
          free
        }
        pricingSubscriptionModes {
          id
          name
          nameTranslations {
            ...translationFields
          }
          inDays
        }
        currencies {
          name
          code
          symbol
        }
      }
    }
  }
  ${TranslationFieldsFragmentDoc}
`

/**
 * __useReviewsProductOptionsQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductOptionsQuery();
 */
export function useReviewsProductOptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>(
    ReviewsProductOptionsDocument,
    {},
    options,
  )
}
export function useReviewsProductOptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductOptionsQuery, ReviewsProductOptionsQueryVariables>(
    ReviewsProductOptionsDocument,
    {},
    options,
  )
}
export type ReviewsProductOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductOptionsQuery,
  ReviewsProductOptionsQueryVariables
>
export const ReviewsProductSurveyResponseDetailsDocument = gql`
  query reviewsProductSurveyResponseDetails($id: ID!) {
    manage {
      surveyResponse(id: $id) {
        aasmState
        anonymous
        createdAt
        firstPublishedAt
        id
        incentive {
          slug
        }
        publishedAt
        purposes {
          title
        }
        rejectedAt
        rejectedReason
        reminderDisabled
        reviewerCompany
        reviewerCompanySize
        reviewerIndustry
        reviewerFirstName
        reviewerPosition
        updatedAt
        reminders {
          id
          sentAt
          createdAt
          message
          status
          userId
          automatic
        }
        review {
          id
          positive
          negative
          problems
          reviewReply {
            id
            personalized
            reply
            senderName
          }
          anonymous
          companySize
          companyName
          companyField
          companyPosition
          title
          recommendationScore
          reviewerFirstName
          reviewerLastName
          incentive
          publishedAt
          purposes {
            title
          }
          product {
            title
          }
          video {
            contentType
            name
            url
          }
        }
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponseDetailsQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponseDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponseDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsProductSurveyResponseDetailsQuery(
  variables:
    | ReviewsProductSurveyResponseDetailsQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponseDetailsQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponseDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>(
    ReviewsProductSurveyResponseDetailsDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponseDetailsLazyQuery(
  variables?:
    | ReviewsProductSurveyResponseDetailsQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponseDetailsQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponseDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductSurveyResponseDetailsQuery, ReviewsProductSurveyResponseDetailsQueryVariables>(
    ReviewsProductSurveyResponseDetailsDocument,
    variables,
    options,
  )
}
export type ReviewsProductSurveyResponseDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponseDetailsQuery,
  ReviewsProductSurveyResponseDetailsQueryVariables
>
export const ReviewsProductSurveyResponsesExportCsvDocument = gql`
  query reviewsProductSurveyResponsesExportCsv(
    $slug: String!
    $filters: ManageSurveyResponsesSearchFilters!
    $view: SurveyResponsesViewEnum
  ) {
    manage {
      surveyResponsesExportCsv(
        productSlug: $slug
        filters: $filters
        view: $view
        fields: [
          { key: campaign_name, name: "Campaign Name" }
          { key: invitation_link, name: "Source" }
          { key: invitation_message, name: "Invitation Message" }
          { key: state, name: "State" }
          { key: created_at, name: "Created at" }
          { key: first_published_at, name: "First published at" }
          { key: updated_at, name: "Updated at" }
          { key: published_at, name: "Published at" }
          { key: reviewer_first_name, name: "Reviewer Firstname" }
          { key: company_name, name: "Company Name" }
          { key: industry, name: "Reviewer industry" }
          { key: title, name: "Title" }
          { key: purpose, name: "Purpose" }
          { key: positive, name: "Positive" }
          { key: negative, name: "Negative" }
          { key: problems, name: "Problems" }
          { key: rating, name: "Rating" }
          { key: reply_text, name: "Replies to reviews" }
        ]
      ) {
        errors
        fileUrl
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponsesExportCsvQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponsesExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponsesExportCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponsesExportCsvQuery({
 *   slug: // value for 'slug'
 *   filters: // value for 'filters'
 *   view: // value for 'view'
 * });
 */
export function useReviewsProductSurveyResponsesExportCsvQuery(
  variables:
    | ReviewsProductSurveyResponsesExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesExportCsvQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesExportCsvQuery, ReviewsProductSurveyResponsesExportCsvQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesExportCsvQuery,
          ReviewsProductSurveyResponsesExportCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesExportCsvQuery,
          ReviewsProductSurveyResponsesExportCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponsesExportCsvQuery, ReviewsProductSurveyResponsesExportCsvQueryVariables>(
    ReviewsProductSurveyResponsesExportCsvDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponsesExportCsvLazyQuery(
  variables?:
    | ReviewsProductSurveyResponsesExportCsvQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesExportCsvQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesExportCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesExportCsvQuery, ReviewsProductSurveyResponsesExportCsvQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesExportCsvQuery,
          ReviewsProductSurveyResponsesExportCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesExportCsvQuery,
          ReviewsProductSurveyResponsesExportCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ReviewsProductSurveyResponsesExportCsvQuery,
    ReviewsProductSurveyResponsesExportCsvQueryVariables
  >(ReviewsProductSurveyResponsesExportCsvDocument, variables, options)
}
export type ReviewsProductSurveyResponsesExportCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponsesExportCsvQuery,
  ReviewsProductSurveyResponsesExportCsvQueryVariables
>
export const ReviewsProductSurveyResponseStatusDocument = gql`
  query reviewsProductSurveyResponseStatus($id: ID!) {
    manage {
      surveyResponse(id: $id) {
        aasmState
        id
        reviewerFirstName
        rejectedReason
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponseStatusQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponseStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponseStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsProductSurveyResponseStatusQuery(
  variables:
    | ReviewsProductSurveyResponseStatusQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponseStatusQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponseStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>(
    ReviewsProductSurveyResponseStatusDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponseStatusLazyQuery(
  variables?:
    | ReviewsProductSurveyResponseStatusQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponseStatusQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponseStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductSurveyResponseStatusQuery, ReviewsProductSurveyResponseStatusQueryVariables>(
    ReviewsProductSurveyResponseStatusDocument,
    variables,
    options,
  )
}
export type ReviewsProductSurveyResponseStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponseStatusQuery,
  ReviewsProductSurveyResponseStatusQueryVariables
>
export const ReviewsProductSurveyResponsesDocument = gql`
  query reviewsProductSurveyResponses(
    $slug: ID!
    $page: Int!
    $perPage: Int!
    $sortBy: SurveyResponsesSortByEnum = updated_at
    $sortDirection: SortDirectionEnum = desc
    $filters: ManageSurveyResponsesSearchFilters!
    $view: SurveyResponsesViewEnum
  ) {
    manage {
      surveyResponses(
        productSlug: $slug
        page: $page
        perPage: $perPage
        sortBy: $sortBy
        sortDirection: $sortDirection
        filters: $filters
        view: $view
      ) {
        results {
          id
          aasmState
          purposes {
            title
          }
          reviewerFirstName
          reviewerCompany
          reviewerPosition
          rejectedReason
          reminderDisabled
          reminders {
            id
            sentAt
          }
          review {
            recommendationScore
            companyName
            companyPosition
            reviewReply {
              id
            }
            campaign {
              title
            }
          }
          updatedAt
          requestedCampaign {
            title
          }
        }
        purposesFacet {
          docCount
          key
          name
        }
        viewFacet {
          key
          docCount
        }
        pagination {
          perPage
          currentPage
          totalCount
          hasNextPage
          totalPages
        }
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponsesQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponsesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponsesQuery({
 *   slug: // value for 'slug'
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   sortBy: // value for 'sortBy'
 *   sortDirection: // value for 'sortDirection'
 *   filters: // value for 'filters'
 *   view: // value for 'view'
 * });
 */
export function useReviewsProductSurveyResponsesQuery(
  variables:
    | ReviewsProductSurveyResponsesQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>(
    ReviewsProductSurveyResponsesDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponsesLazyQuery(
  variables?:
    | ReviewsProductSurveyResponsesQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductSurveyResponsesQuery, ReviewsProductSurveyResponsesQueryVariables>(
    ReviewsProductSurveyResponsesDocument,
    variables,
    options,
  )
}
export type ReviewsProductSurveyResponsesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponsesQuery,
  ReviewsProductSurveyResponsesQueryVariables
>
export const ReviewsProductSurveyResponsesCountDocument = gql`
  query reviewsProductSurveyResponsesCount($slug: ID!) {
    manage {
      surveyResponses(productSlug: $slug) {
        pagination {
          totalCount
        }
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponsesCountQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponsesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponsesCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponsesCountQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useReviewsProductSurveyResponsesCountQuery(
  variables:
    | ReviewsProductSurveyResponsesCountQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesCountQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesCountQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>(
    ReviewsProductSurveyResponsesCountDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponsesCountLazyQuery(
  variables?:
    | ReviewsProductSurveyResponsesCountQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesCountQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesCountQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductSurveyResponsesCountQuery, ReviewsProductSurveyResponsesCountQueryVariables>(
    ReviewsProductSurveyResponsesCountDocument,
    variables,
    options,
  )
}
export type ReviewsProductSurveyResponsesCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponsesCountQuery,
  ReviewsProductSurveyResponsesCountQueryVariables
>
export const ReviewsProductSurveyResponsesViewFacetDocument = gql`
  query reviewsProductSurveyResponsesViewFacet($slug: ID!) {
    manage {
      surveyResponses(productSlug: $slug) {
        viewFacet {
          key
          docCount
        }
      }
    }
  }
`

/**
 * __useReviewsProductSurveyResponsesViewFacetQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductSurveyResponsesViewFacetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductSurveyResponsesViewFacetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductSurveyResponsesViewFacetQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useReviewsProductSurveyResponsesViewFacetQuery(
  variables:
    | ReviewsProductSurveyResponsesViewFacetQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesViewFacetQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesViewFacetQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesViewFacetQuery, ReviewsProductSurveyResponsesViewFacetQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesViewFacetQuery,
          ReviewsProductSurveyResponsesViewFacetQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesViewFacetQuery,
          ReviewsProductSurveyResponsesViewFacetQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductSurveyResponsesViewFacetQuery, ReviewsProductSurveyResponsesViewFacetQueryVariables>(
    ReviewsProductSurveyResponsesViewFacetDocument,
    variables,
    options,
  )
}
export function useReviewsProductSurveyResponsesViewFacetLazyQuery(
  variables?:
    | ReviewsProductSurveyResponsesViewFacetQueryVariables
    | VueCompositionApi.Ref<ReviewsProductSurveyResponsesViewFacetQueryVariables>
    | ReactiveFunction<ReviewsProductSurveyResponsesViewFacetQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductSurveyResponsesViewFacetQuery, ReviewsProductSurveyResponsesViewFacetQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesViewFacetQuery,
          ReviewsProductSurveyResponsesViewFacetQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ReviewsProductSurveyResponsesViewFacetQuery,
          ReviewsProductSurveyResponsesViewFacetQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ReviewsProductSurveyResponsesViewFacetQuery,
    ReviewsProductSurveyResponsesViewFacetQueryVariables
  >(ReviewsProductSurveyResponsesViewFacetDocument, variables, options)
}
export type ReviewsProductSurveyResponsesViewFacetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductSurveyResponsesViewFacetQuery,
  ReviewsProductSurveyResponsesViewFacetQueryVariables
>
export const ReviewsProductsDocument = gql`
  query reviewsProducts {
    manage {
      products {
        ...productBasicData
        hasPaidPlan
        rankscaleUrl
        config {
          profileClaimedCached
          aiVisibilityDashboardCached
        }
      }
    }
  }
  ${ProductBasicDataFragmentDoc}
`

/**
 * __useReviewsProductsQuery__
 *
 * To run a query within a Vue component, call `useReviewsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsProductsQuery();
 */
export function useReviewsProductsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsProductsQuery, ReviewsProductsQueryVariables>(ReviewsProductsDocument, {}, options)
}
export function useReviewsProductsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsProductsQuery, ReviewsProductsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsProductsQuery, ReviewsProductsQueryVariables>(ReviewsProductsDocument, {}, options)
}
export type ReviewsProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsProductsQuery,
  ReviewsProductsQueryVariables
>
export const ReviewReviewsDocument = gql`
  query reviewReviews($product: ID!, $filters: ReviewsSearchFilters) {
    reviews(product: $product, filters: $filters) {
      statistics {
        recommendationScoreBetter
        recommendationScoreBest
      }
    }
  }
`

/**
 * __useReviewReviewsQuery__
 *
 * To run a query within a Vue component, call `useReviewReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewReviewsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewReviewsQuery({
 *   product: // value for 'product'
 *   filters: // value for 'filters'
 * });
 */
export function useReviewReviewsQuery(
  variables:
    | ReviewReviewsQueryVariables
    | VueCompositionApi.Ref<ReviewReviewsQueryVariables>
    | ReactiveFunction<ReviewReviewsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewReviewsQuery, ReviewReviewsQueryVariables>(ReviewReviewsDocument, variables, options)
}
export function useReviewReviewsLazyQuery(
  variables?:
    | ReviewReviewsQueryVariables
    | VueCompositionApi.Ref<ReviewReviewsQueryVariables>
    | ReactiveFunction<ReviewReviewsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewReviewsQuery, ReviewReviewsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewReviewsQuery, ReviewReviewsQueryVariables>(ReviewReviewsDocument, variables, options)
}
export type ReviewReviewsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewReviewsQuery,
  ReviewReviewsQueryVariables
>
export const ReviewsTopProductsRankingDocument = gql`
  query reviewsTopProductsRanking(
    $productSlug: ID!
    $orderBy: ManageTopProductsRankingOrderBy
    $orderDir: SortDirectionEnum
    $page: Int!
    $perPage: Int!
    $search: String
  ) {
    manage {
      topProductsRanking(
        productSlug: $productSlug
        orderBy: $orderBy
        orderDir: $orderDir
        page: $page
        perPage: $perPage
        search: $search
      ) {
        year
        results {
          tool
          toolTitle
          rank
          position
          rating
          reviewCount
        }
        pinned {
          tool
          toolTitle
          rank
          position
          rating
          reviewCount
        }
        pagination {
          currentPage
          perPage
          totalCount
          totalPages
          hasNextPage
        }
      }
    }
  }
`

/**
 * __useReviewsTopProductsRankingQuery__
 *
 * To run a query within a Vue component, call `useReviewsTopProductsRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsTopProductsRankingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsTopProductsRankingQuery({
 *   productSlug: // value for 'productSlug'
 *   orderBy: // value for 'orderBy'
 *   orderDir: // value for 'orderDir'
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   search: // value for 'search'
 * });
 */
export function useReviewsTopProductsRankingQuery(
  variables:
    | ReviewsTopProductsRankingQueryVariables
    | VueCompositionApi.Ref<ReviewsTopProductsRankingQueryVariables>
    | ReactiveFunction<ReviewsTopProductsRankingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>(
    ReviewsTopProductsRankingDocument,
    variables,
    options,
  )
}
export function useReviewsTopProductsRankingLazyQuery(
  variables?:
    | ReviewsTopProductsRankingQueryVariables
    | VueCompositionApi.Ref<ReviewsTopProductsRankingQueryVariables>
    | ReactiveFunction<ReviewsTopProductsRankingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsTopProductsRankingQuery, ReviewsTopProductsRankingQueryVariables>(
    ReviewsTopProductsRankingDocument,
    variables,
    options,
  )
}
export type ReviewsTopProductsRankingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsTopProductsRankingQuery,
  ReviewsTopProductsRankingQueryVariables
>
export const ReviewsTopRatedBadgeProgressDocument = gql`
  query reviewsTopRatedBadgeProgress($id: ID!) {
    manage {
      topRatedBadgeProgress(id: $id) {
        reviewCount
        averageScore
        eligible
        minimumReviewCount
        minimumAverageScore
      }
    }
  }
`

/**
 * __useReviewsTopRatedBadgeProgressQuery__
 *
 * To run a query within a Vue component, call `useReviewsTopRatedBadgeProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsTopRatedBadgeProgressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReviewsTopRatedBadgeProgressQuery({
 *   id: // value for 'id'
 * });
 */
export function useReviewsTopRatedBadgeProgressQuery(
  variables:
    | ReviewsTopRatedBadgeProgressQueryVariables
    | VueCompositionApi.Ref<ReviewsTopRatedBadgeProgressQueryVariables>
    | ReactiveFunction<ReviewsTopRatedBadgeProgressQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>(
    ReviewsTopRatedBadgeProgressDocument,
    variables,
    options,
  )
}
export function useReviewsTopRatedBadgeProgressLazyQuery(
  variables?:
    | ReviewsTopRatedBadgeProgressQueryVariables
    | VueCompositionApi.Ref<ReviewsTopRatedBadgeProgressQueryVariables>
    | ReactiveFunction<ReviewsTopRatedBadgeProgressQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ReviewsTopRatedBadgeProgressQuery, ReviewsTopRatedBadgeProgressQueryVariables>(
    ReviewsTopRatedBadgeProgressDocument,
    variables,
    options,
  )
}
export type ReviewsTopRatedBadgeProgressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReviewsTopRatedBadgeProgressQuery,
  ReviewsTopRatedBadgeProgressQueryVariables
>
